webpackJsonp([1],{

/***/ "+88Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'faqNew',
  data: function data() {
    return {
      // 模式导航索引
      modNavIndex: 0,
      // 教程索引
      setpNavIndex: 0,
      // 模式
      modList: [{
        index: 0,
        text: '地图模式'
      }, {
        index: 1,
        text: '私服模式'
      }],
      // 模式索引
      modIndexList: [{
        index: 0
      }, {
        index: 1
      }],
      // 地图模式进度
      stepList: [{
        index: 0,
        cls: 'step1',
        text: '下载和安装'
      }, {
        index: 1,
        cls: 'step2',
        text: '使用插件'
      }, {
        index: 2,
        cls: 'step3',
        text: '发布测试区'
      }, {
        index: 3,
        cls: 'step4',
        text: '发布正式区'
      }]
    };
  },

  methods: {
    // 教程模式索引切换
    modNavFn: function modNavFn(index) {
      this.modNavIndex = index;
    },

    // 教程进度索引切换
    setpNavIndexFn: function setpNavIndexFn(index) {
      this.setpNavIndex = index;
    }
  }
});

/***/ }),

/***/ "+AE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"faq"},[_c('v-login-info',[_c('a',{staticClass:"left clearfix",attrs:{"slot":"goBack","href":"javascript: void(0)"},on:{"click":_vm.goBackFn},slot:"goBack"},[_c('i',{staticClass:"icon-left-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"faq-content"},[_c('div',{staticClass:"faq-left"},[_c('v-faq-left')],1),_vm._v(" "),_c('div',{staticClass:"faq-right"},[_c('router-view')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+hi/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginInfo_vue__ = __webpack_require__("67u8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002f4c92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginInfo_vue__ = __webpack_require__("pLPZ");
function injectStyle (ssrContext) {
  __webpack_require__("8hZK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002f4c92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+rhx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/0E6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"examine-fail"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"apply-result"},[_vm._v("审核失败")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',{staticClass:"examine-desc"},[_vm._v("您的地图MOD："+_vm._s(_vm.mapName)+" 的游戏内容需要修改，很遗憾您的本次审核没有通过，请根据拒绝原因修改后再次上传。")]),_vm._v(" "),_c('p',{staticClass:"examine-content"},[_vm._v("\n      拒绝原因："),_c('br'),_vm._v("\n      "+_vm._s(_vm.errorInfo || '没有填写')+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('router-link',{staticClass:"handle-btn",attrs:{"to":"/home"}},[_vm._v("返回开发者首页")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"head"},[_c('i',{staticClass:"icon-fail"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/2IE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerSuccess_vue__ = __webpack_require__("ayyW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7b1c6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerSuccess_vue__ = __webpack_require__("eGfi");
function injectStyle (ssrContext) {
  __webpack_require__("kJAF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerSuccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7b1c6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerSuccess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/gCT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_core_image_upload__ = __webpack_require__("ngqk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_js_user__ = __webpack_require__("xKOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_basicMask_basicMask__ = __webpack_require__("/pyY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件

// 图片上传组件

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作

// 遮罩提示层

var ERROR_TIPS = [{ desc: '表单验证失败' }, { desc: '最少上传3张游戏截图' }, { desc: '网络错误' }, { desc: '请上传游戏主图' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  // 测试区地图审核页面
  name: 'devMapinspect',
  data: function data() {
    return {
      // 遮罩层
      maskFlag: false,
      // 上传图片时的错误信息
      uploadPicTps: '',
      // loading 加载层开关
      imageLoadingFlag: false,
      // 地图版本信息
      mapVersion: '',
      // 游戏类型
      mapType: 1,
      // 地图信息
      mapInfo: '',
      // 地图id
      mapId: this.$route.params.mapId,
      // 地图进行阶段
      stage: this.$route.params.stage,
      // 请求地图信息接口
      apiPath: '',
      // 地图标签
      tags: [],
      // 添加地图标标签输入框默认值
      tagVal: '',
      // 地图名称
      mapName: '',
      // 地图描述
      mapDesc: '',
      // 地图更新内容
      mapUpdate: '',
      // 图片demo1
      demoFlag1: false,
      // 图片demo2
      demoFlag2: false,
      // 表单错误信息
      formErrot: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('SessionID')
      },
      // 默认显示图片
      defaultPic: '/static/img/default-image.png',
      // 上传图片信息列表
      picList: [{ picture: '' }, { picture: '' }, { picture: '' }, { picture: '' }, { picture: '' }, { picture: '' }],
      // 图片上传参数列表
      picData: {
        // 用户id
        UserID: '',
        // session id
        SessionID: '',
        // 地图进度阶段id
        Stage: '',
        // 地图 id
        MapStageId: '',
        // 地图索引
        PictureIndex: '',
        // 上传地图后要替换的图片位置
        picReplace: ''
      }
    };
  },

  computed: {
    // 地图标签输入框 显示\隐藏 标志
    tagAddFlag: function tagAddFlag() {
      if (this.tags.length >= 3) {
        return false;
      } else {
        return true;
      }
    },

    // 计算上传图片的数量
    countPicList: function countPicList() {
      var tempArr = [];
      // 过滤
      this.picList.forEach(function (item, index) {
        // 跳过游戏主图
        if (index !== 0) {
          if (item.picture !== '') {
            tempArr.push(item);
          }
        }
      });
      // 返回过滤后数组的长度
      return tempArr.length;
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    // 初始化数据
    init: function init() {
      var _this = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图id
      formData.append('MapId', this.mapId);
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/Developer/GetMapDevInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 将地图信息赋值到对象属性
              _this.mapInfo = res.DevInfo;
              // 游戏主图
              _this.picList[0].picture = _this.mapInfo.MainPicture;
              // 获取图片默认地址
              _this.picList[1].picture = _this.mapInfo.Picture1;
              _this.picList[2].picture = _this.mapInfo.Picture2;
              _this.picList[3].picture = _this.mapInfo.Picture3;
              _this.picList[4].picture = _this.mapInfo.Picture4;
              _this.picList[5].picture = _this.mapInfo.Picture5;
              // 设置地图当前进行阶段的id
              _this.picData.MapStageId = _this.mapInfo.Id;
              // 设置图片上传时的地图进行阶段id
              _this.picData.Stage = _this.stage;
              // 地图描述信息
              _this.mapDesc = _this.mapInfo.Note;
              // 地图更新内容
              _this.mapUpdate = _this.mapInfo.UpdateContent;
              // 地图版本你信息
              _this.mapVersion = _this.mapInfo.MapVersion;
              // 如果标签不是为空
              if (_this.mapInfo.MapTag !== null) {
                // 将字符串拆分成数组
                _this.tags = _this.mapInfo.MapTag.split(',');
              }
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 图片上传回调函数
    imageuploaded: function imageuploaded(res) {
      switch (res.Code) {
        case 0:
          // 关闭图片上传 loading 加载层
          this.imageLoadingFlag = false;
          // 将返回的图片地址设置到图片上
          this.picReplace[0].src = res.ImgUrl;
          // 对数组中的图片信息进行赋值
          this.picList[this.picData.PictureIndex].picture = res.ImgUrl;
          // 清空错误信息
          this.formErrot = '';
          break;
        case 1:
          // 删除登录信息
          Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
          this.$router.push({ name: 'login' });
          break;
        case 2:
          // this.uploadPicTps = res.Msg
          // 弹出提示层
          // this.maskFlag = true
          this.formErrot = res.Msg;
          break;
        default:
          // 其他错误
          this.formErrot = res.Msg;
          console.log(res.Code);
          console.log(res.Msg);
      }
    },

    // 图片上传过程中
    imageuploading: function imageuploading() {
      // 打开 loading 加载层
      this.imageLoadingFlag = true;
    },

    // 文件上传时出现错误
    errorhandle: function errorhandle(error) {
      // 检查错误
      switch (error) {
        case 'FILE IS TOO LARGER MAX FILE IS 1.00MB':
          this.uploadPicTps = '文件大小不能超过1M';
          break;
        case 'access_denied':
          this.uploadPicTps = '网络错误';
          break;
        default:
          this.uploadPicTps = error;
      }
      // 弹出错误提示
      this.maskFlag = true;
    },

    // 关闭错误提示层
    closeMaskFn: function closeMaskFn() {
      this.maskFlag = false;
    },

    // 点击上传图片时设置参数
    picUploadFn: function picUploadFn(event, index) {
      // 设置图片索引
      this.picData.PictureIndex = index;
      // 设置上传参数用户id
      this.picData.UserID = this.formDatas.userId;
      // 设置上传参数 session id
      this.picData.SessionID = this.formDatas.sessionId;
      // 上传后替换图片的位置
      this.picReplace = event.currentTarget.getElementsByClassName('hook-item-pic');
    },

    // 删除图片
    delPicFn: function delPicFn(index) {
      var _this2 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图进行阶段
      formData.append('Stage', this.picData.Stage);
      // 地图进行阶段id
      formData.append('MapStageId', this.picData.MapStageId);
      // 图片索引
      formData.append('PictureIndex', index);
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.upload + '/Developer/DeleteMapPicture', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 清空图片信息
              _this2.picList[_this2.picData.PictureIndex].picture = '';
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this2.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 添加地图标签
    addTagFn: function addTagFn() {
      // 清空输入内容的空格
      var tag = this.tagVal.trim();
      // 如果地图标签有内容输入
      if (tag !== '') {
        // 添加到数组
        this.tags.push(this.tagVal);
        // 清空输入框
        this.tagVal = '';
        // 获取输入框焦点
        this.$refs.addTagInput.focus();
      }
    },

    // 删除地图标签
    delTagFn: function delTagFn(index) {
      // console.log(index)
      this.tags.splice(index, 1);
    },

    // 地图提交审核
    mapSubexamine: function mapSubexamine() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        // 表单是否有错误信息
        var isError = _this3.errors.any();
        if (isError) {
          // 获取所有错误信息的数组列表
          var formErrors = _this3.$validator.errors.all();
          // 返回第一个错误信息
          _this3.formErrot = formErrors[0];
        } else {
          if (_this3.picList[0].picture !== '') {
            // 判断上传游戏截图的数量
            if (_this3.countPicList >= 3) {
              // 实例化表单对象
              var formData = new FormData();
              // 将用户名添加到表单
              formData.append('UserID', _this3.formDatas.userId);
              // 将密码添加到表单
              formData.append('SessionID', _this3.formDatas.sessionId);
              // 地图id
              formData.append('MapId', _this3.mapId);
              // 地图名称
              formData.append('MapName', _this3.mapName);
              // 地图进行阶段
              formData.append('Stage', _this3.picData.Stage);
              // 地图标签
              formData.append('MapTag', _this3.tags.join(','));
              // 地图进行阶段id
              formData.append('MapStageId', _this3.picData.MapStageId);
              // 地图类型
              formData.append('MapType', _this3.mapType);
              // 地图描述
              formData.append('Note', _this3.mapDesc);
              // 更新内容
              formData.append('UpdateContent', _this3.mapUpdate);
              // 地图版本
              formData.append('MapVersion', _this3.mapInfo.MapVersion);
              // 请求地图详细信息 api
              __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$api.root + '/Developer/SubmitAuditDev', formData, {
                // 设置请求为表单提交
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then(function (response) {
                // http 请求成功
                if (response.status === 200) {
                  // 获取接口数据
                  var res = response.data;
                  switch (res.Code) {
                    case 0:
                      // 跳转到审核中页面
                      _this3.$router.push({ name: 'toExamine', params: { mapId: _this3.mapId, stage: _this3.stage } });
                      break;
                    case 1:
                      // 删除登录信息
                      Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
                      _this3.$router.push({ name: 'login' });
                      break;
                    default:
                      console.log(res.Code);
                      console.log(res.Msg);
                  }
                }
              }).catch(function (error) {
                _this3.formErrot = ERROR_TIPS[2].desc;
                console.log(error);
              });
            } else {
              // 提示上传图片数量的信息
              _this3.formErrot = ERROR_TIPS[1].desc;
            }
          } else {
            // 提示上传游戏主图
            _this3.formErrot = ERROR_TIPS[3].desc;
          }
        }
      }).catch(function () {
        _this3.formErrot = ERROR_TIPS[0].desc;
      });
    },

    // demo图示1
    demo1Fn: function demo1Fn() {
      this.demoFlag1 = !this.demoFlag1;
    },

    // demo图示2
    demo2Fn: function demo2Fn() {
      this.demoFlag2 = !this.demoFlag2;
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */],
    'vue-core-image-upload': __WEBPACK_IMPORTED_MODULE_1_vue_core_image_upload__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_5_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "/h22":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_downloadPlugin_vue__ = __webpack_require__("IEL4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5629ea6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_downloadPlugin_vue__ = __webpack_require__("r42K");
function injectStyle (ssrContext) {
  __webpack_require__("opPI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_downloadPlugin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5629ea6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_downloadPlugin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/pyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basicMask_vue__ = __webpack_require__("BXlu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adff7fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basicMask_vue__ = __webpack_require__("Htb+");
function injectStyle (ssrContext) {
  __webpack_require__("sS7y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basicMask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adff7fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basicMask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0fWv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0kXI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-resize-bar"},[_c('div',{staticClass:"g-resize-highlight",style:({width: _vm.left + '%',})}),_vm._v(" "),_c('button',{staticClass:"circle-btn",style:({left: _vm.left + '%',}),on:{"touchstart":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.drag($event)},"mousedown":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.drag($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "11ap":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "145B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-mask-wrap",attrs:{"onselectstart":"return false"}},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading-mask"},[_c('img',{staticClass:"icon-loading",attrs:{"src":"/static/loading/loading-spin.svg","alt":"loading"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "16Cq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backstage_vue__ = __webpack_require__("z1Lt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243edf06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backstage_vue__ = __webpack_require__("3ceT");
function injectStyle (ssrContext) {
  __webpack_require__("0fWv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backstage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243edf06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backstage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "24gT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.afa5955.png";

/***/ }),

/***/ "2NpF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2RhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_testMapinspect_vue__ = __webpack_require__("w2qT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a71e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_testMapinspect_vue__ = __webpack_require__("PQE7");
function injectStyle (ssrContext) {
  __webpack_require__("Du3Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_testMapinspect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a71e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_testMapinspect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3JVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root-doc"},[_c('h1',{staticClass:"root-title"},[_vm._v("关于解除ROOT的说明")]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("什么是ROOT？")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("ROOT是指安卓手机系统底层的超级权限。部分安卓手机操作系统，以及一部分手机优化软件提供ROOT的功能。如果您使用安卓模拟器进行游戏，一般而言也是开启了ROOT的。")])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("为什么要解除ROOT？")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("ROOT过的手机更容易受到恶意第三方软件的影响，影响您以及其它玩家的游戏体验，因此我们建议您解除ROOT后再进入游戏。")])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("如何解除ROOT？")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("如果您之前有意开启了ROOT权限，可以通过您之前使用的软件操作关闭ROOT。如果您是无意中开启的ROOT，或者忘记了之前开启ROOT的方式，可以按照下面提供的方式进行操作。下面提供的工具和操作方式只需操作后重启手机即可完成，不会对您手机的数据和功能使用造成影响。如果您有其它疑虑，也可咨询官方客服4009-393-333。")])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("安卓手机解除ROOT方法")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("如果您使用的是ROOT过的安卓手机，可以使用以下工具解除ROOT。")])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("1. 360一键Root工具解除")]),_vm._v(" "),_c('dd',[_c('div',{staticClass:"link-box"},[_c('span',{staticClass:"title"},[_vm._v("官方网站")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"http://root.360.cn"}},[_vm._v("http://root.360.cn")])]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("下载最新版本的手机版本来解除。")]),_vm._v(" "),_c('ol',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('p',{staticClass:"item-title"},[_vm._v("1. 点击官网支持机型，查看是否支持：")]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("cHPI"),"alt":"图例"}})])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('p',{staticClass:"item-title"},[_vm._v("2. 把apk安装到手机中，然后运行")])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('p',{staticClass:"item-title"},[_vm._v("3. 点击右上角")]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("yqDz"),"alt":"图例"}})])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('p',{staticClass:"item-title"},[_vm._v("4. 点击移除ROOT")]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("24gT"),"alt":"图例"}})])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('p',{staticClass:"item-title"},[_vm._v("5. 弹出界面点击继续")]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("J3cW"),"alt":"图例"}})])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('p',{staticClass:"item-title"},[_vm._v("6. 会有提示")]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("aOvb"),"alt":"图例"}})])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('p',{staticClass:"item-title"},[_vm._v("7. 移除root会可能失败几次，多点几次就可以了")])])])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("2. 使用ROOT大师一键解除root")]),_vm._v(" "),_c('dd',[_c('div',{staticClass:"link-box"},[_c('div',[_c('span',{staticClass:"title"},[_vm._v("ROOT大师 官方网站")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"http://root.mgyun.com"}},[_vm._v("http://root.mgyun.com")])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"title"},[_vm._v("ROM基地 官方网站")]),_vm._v(" "),_c('a',{staticClass:"link",attrs:{"href":"http://www.romjd.com"}},[_vm._v("http://www.romjd.com")])])]),_vm._v(" "),_c('ol',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('p',{staticClass:"item-title"},[_vm._v("1. 先去官网查看你的手机是否支持")]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("uxun"),"alt":"图例"}})]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("S/MZ"),"alt":"图例"}})])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('p',{staticClass:"item-title"},[_c('span',[_vm._v("2. 官方教学网址")]),_vm._v(" "),_c('a',{attrs:{"href":"http://www.romjd.com/jiaocheng/content/10819"}},[_vm._v("http://www.romjd.com/jiaocheng/content/10819")])])])])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("3. 如果以上工具都无效")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("您可以联系官方客服4009-393-333咨询解决方式，我们将记录您的联系方式并尽力帮您解决问题。您也可以尝试使用刷机的方式重新安装操作系统来尝试解决问题。但是由于可能导致手机损坏或者数据丢失等风险，因此我们并不推荐您这样做。")])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("模拟器关闭ROOT的方法")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("并非所有模拟器都支持非ROOT方式运行，因此如果您使用的不是以下五款模拟器（夜神，蓝叠，逍遥，雷电，二次元天天）之一，请您更换模拟器。")])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("1.夜神模拟器")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("可以自由切换Root模式，点击界面右方的设置按钮可呼出如下图(此版本为6.0.6.1 2018/03/19，个别时候需要重启2次才生效)")]),_vm._v(" "),_c('ol',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("5USR"),"alt":"图例"}})]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("Vr6n"),"alt":"图例"}})])])])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("2. 蓝叠模拟器")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("最新版本蓝叠3支持动态调整root（设置后需要重启模拟器）界面右上角点击如图:")]),_vm._v(" "),_c('ol',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("cnnt"),"alt":"图例"}})]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("HLWg"),"alt":"图例"}})])])])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("3. 逍遥模拟器")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("支持动态设置ROOT模式，如下")]),_vm._v(" "),_c('ol',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("9VHD"),"alt":"图例"}})]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("624b"),"alt":"图例"}})])])])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("4.雷电模式器")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("支持调整root权限，点击边框菜单栏里的设置")]),_vm._v(" "),_c('ol',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("fci3"),"alt":"图例"}})]),_vm._v(" "),_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("ciBS"),"alt":"图例"}})])])])])]),_vm._v(" "),_c('dl',{staticClass:"brand-tiem"},[_c('dt',{staticClass:"brand-title"},[_vm._v("5.二次元天天模拟器")]),_vm._v(" "),_c('dd',[_c('p',{staticClass:"desc"},[_vm._v("可以设置ROOT，在底部的菜单栏里如图：")]),_vm._v(" "),_c('ol',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('div',{staticClass:"pic-box"},[_c('img',{staticClass:"pic",attrs:{"src":__webpack_require__("PBgz"),"alt":"图例"}})])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3ceT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"backstage"},[_c('h3',{staticClass:"backstage-title"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("后台FAQ")]),_vm._v(" "),_c('span',{staticClass:"line"})]),_vm._v(" "),_c('dl',{staticClass:"qa"},[_c('dt',{staticClass:"ask"},[_vm._v("问：测试区可以收费么？")]),_vm._v(" "),_c('dd',{staticClass:"answer"},[_vm._v("答：开发者开发的内容在测试区开放是为开发者收集bug的，正式区会开放给开发者收费的选项和接口，测试区属于免费区，开发者可以在测试区验证付费的内容，但是无法收费。")])]),_vm._v(" "),_c('dl',{staticClass:"qa"},[_c('dt',{staticClass:"ask"},[_vm._v("问：地图mod和私服mod有什么区别？")]),_vm._v(" "),_c('dd',{staticClass:"answer"},[_vm._v("答：地图mod是单局玩法，不需要拥有服务器，私服mod是需要购买服务器，向其他玩家提供私服内容。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3hIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_user__ = __webpack_require__("xKOl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作


/* harmony default export */ __webpack_exports__["a"] = ({
  // 地图审核失败页面
  name: 'examineFail',
  data: function data() {
    return {
      // 地图 id
      mapId: this.$route.params.mapId,
      // 地图审核阶段
      stage: this.$route.params.stage,
      // 地图名称
      mapName: '',
      // 错误信息
      errorInfo: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('SessionID')
      }
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      var _this = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图id
      formData.append('MapId', this.mapId);
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$api.root + '/Developer/GetMapDevInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 获取地图名称
              _this.mapName = res.DevInfo.MapName;
              // 获取错误信息
              _this.errorInfo = res.DevInfo.FailInfo;
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_2_assets_js_user__["a" /* delUserCookie */])();
              _this.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "4OdC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/demo-image.a72b71e.png";

/***/ }),

/***/ "4ZrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examineFail_vue__ = __webpack_require__("3hIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_445c66cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examineFail_vue__ = __webpack_require__("/0E6");
function injectStyle (ssrContext) {
  __webpack_require__("bY1t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examineFail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_445c66cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examineFail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Ltc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_user__ = __webpack_require__("xKOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_basicMask_basicMask__ = __webpack_require__("/pyY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 用户登录信息组件

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作

// 基础弹出层组件

var ERROR_TIPS = [{ desc: '网络错误' }, { desc: '表单验证失败' }, { desc: '开服卷数量不足' }];
/* harmony default export */ __webpack_exports__["a"] = ({
  // 创建服务器
  name: 'createServer',
  data: function data() {
    return {
      // 表单验证错误信息
      formErrot: '',
      // 开服卷服务器列表
      ticketServerList: [],
      // 提示层开关
      tipsShow: false,
      // 提示信息
      tipsText: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('SessionID'),
        // 服务器名称
        severName: '',
        // 选择的开服卷id
        selectTicketId: '',
        // 选择的开服卷类型
        selectTicketType: '',
        // 是否创建密码
        serverIsPwd: '',
        // 服务器密码
        serverPwd: '',
        // 是否公开服务器
        serverIsPublic: '',
        // 服务器模式
        serverType: '',
        // 房间模式
        rootType: ''
      }
    };
  },
  created: function created() {
    // 初始化页面信息
    this.init();
  },

  methods: {
    init: function init() {
      var _this = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('userId', this.formDatas.userId);
      // 将session id表单
      formData.append('sessionId', this.formDatas.sessionId);

      // 请求是否创建过游戏服务器 api
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$api.root + '/PersonalRoom/GetHaveGameServer', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 创建过私服
              if (res.HaveGameServer) {
                // 跳转到首页
                _this.$router.push({ name: 'home' });
                // 请求开服卷信息接口
              } else {
                // 请求开服卷 api
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this.$api.root + '/PersonalRoom/GetTicketInfo', formData, {
                  // 设置请求为表单提交
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                }).then(function (response) {
                  // http 请求成功
                  if (response.status === 200) {
                    // 获取接口数据
                    var _res = response.data;
                    // 开服卷服务器列表
                    _this.ticketServerList = _res.TicketList;
                  }
                }).catch(function (error) {
                  console.log(error);
                });
              }
              break;
            case 1:
              // 删除用户信息
              Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
              // 跳转到登录页
              _this.$router.push({ name: 'login' });
              break;
            case 2:
              _this.tipsShow = true;
              _this.tipsText = res.Msg;
              break;
            default:
              _this.tipsShow = true;
              _this.tipsText = res.Msg;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 创建服务器
    createServerFn: function createServerFn() {
      var _this2 = this;

      // 验证表单所有信息
      this.$validator.validateAll().then(function () {
        // 表单有错误返回 true 没错误返回 false
        // console.log(this.errors.any())
        // 返回所有错信的信息列表
        // console.log(this.errors.all())
        // 表单是否有错误信息
        var isError = _this2.errors.any();
        // 有错误信息
        if (isError) {
          // console.log(this.errors.all())
          // console.log(this.errors.first('serverName'))
          // console.log(this.$validator.errors.all())
          // console.log(this.$validator.errors.all())
          // console.log(this.$validator.errors.first('serverName'))
          // 获取所有错误信息的数组列表
          var formErrors = _this2.$validator.errors.all();
          // 返回第一个错误信息
          _this2.formErrot = formErrors[0];
        } else {
          // 清空表单错误提示信息
          _this2.formErrot = '';
          // 获取选择的开服卷的数量
          var titckArr = _this2.countTicket(_this2.formDatas.serverType);
          // 如果数量大于0，开始创建服务器
          if (titckArr.length > 0) {
            _this2.formDatas.selectTicketId = titckArr[0].TicketId;
            // 实例化表单对象
            var formData = new FormData();
            // 将用户名添加到表单
            formData.append('userId', _this2.formDatas.userId);
            // session id
            formData.append('sessionId', _this2.formDatas.sessionId);
            // 服务器名称
            formData.append('ServerName', _this2.formDatas.severName);
            // 服务器类型
            formData.append('CheckPvpType', _this2.formDatas.rootType);
            // 选择的开服卷类型
            formData.append('TicketType', _this2.formDatas.serverType);
            // 是否公开房间列表
            formData.append('CheckPublic', _this2.formDatas.serverIsPublic);
            // 服务器是否创建密码
            formData.append('CheckPassWord', _this2.formDatas.serverIsPwd);
            // 选择的开服卷 id
            formData.append('TicketId', _this2.formDatas.selectTicketId);
            // 是否创建密码
            if (_this2.formDatas.serverIsPwd) {
              formData.append('Password', _this2.formDatas.serverPwd);
            }

            /*
            console.log('用户id = ' + this.formDatas.userId)
            console.log('session = ' + this.formDatas.sessionId)
            console.log('服务器名称 = ' + this.formDatas.severName)
            console.log('游戏模式 = ' + this.formDatas.rootType)
            console.log('服务器类型 = ' + this.formDatas.serverType)
            console.log('开服卷id = ' + this.formDatas.selectTicketId)
            console.log('是否有密码 = ' + this.formDatas.serverIsPwd)
            console.log('服务器设置密码 = ' + this.formDatas.serverPwd)
            console.log('服务器是否公开 = ' + this.formDatas.serverIsPublic)
            */

            // 请求登录 api
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this2.$api.root + '/PersonalRoom/CreateGameServer', formData, {
              // 设置请求为表单提交
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function (response) {
              // http 请求成功
              if (response.status === 200) {
                console.log(response);
                // 获取接口数据
                var res = response.data;
                switch (res.Code) {
                  case 0:
                    _this2.$router.push({ name: 'serverManage' });
                    break;
                  case 1:
                    // 删除用户信息
                    Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
                    // 跳转到登录页
                    _this2.$router.push({ name: 'login' });
                    break;
                  case 2:
                    _this2.tipsShow = true;
                    _this2.tipsText = res.Msg;
                    break;
                  default:
                    _this2.tipsShow = true;
                    _this2.tipsText = res.Msg;
                }
                if (res.Code === 0) {
                  _this2.$router.push({ name: 'serverManage' });
                }
              }
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            _this2.tipsShow = true;
            _this2.tipsText = ERROR_TIPS[2].desc;
          }
        }
      }).catch(function () {
        _this2.tipsShow = true;
        _this2.tipsText = ERROR_TIPS[0].desc;
      });
    },

    // 开服卷统计
    countTicket: function countTicket(type) {
      // 初始化列表
      var list = [];
      this.ticketServerList.forEach(function (item) {
        // 将于选择类型一致的服务器数据添加到列表
        if (parseInt(item.TicketType) === parseInt(type)) {
          list.push(item);
        }
      });
      // 返回列表
      return list;
    },

    // 关闭提示层
    closeMaskEvFn: function closeMaskEvFn(val) {
      // 关闭弹出层
      this.tipsShow = val;
      // 是否刷新页面
      if (this.refreshFlag) {
        // 重置刷新标志
        this.refreshFlag = false;
        // 刷新页面
        this.$router.go(0);
      }
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_4_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "5MOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5USR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.7376ece.png";

/***/ }),

/***/ "6+6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 配置下载地址
/* harmony default export */ __webpack_exports__["a"] = ({
  root: "http://developer.zm.yingxiong.com"
});

/***/ }),

/***/ "624b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/16.c5a5ed8.png";

/***/ }),

/***/ "67u8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_user__ = __webpack_require__("xKOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_loading_loading__ = __webpack_require__("qqiS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作

// lading 加载组件


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loginInfo',
  data: function data() {
    return {
      // 加载提示层
      loading: false,
      // 登录后的操作弹出层标志
      loginFlag: false,
      // 用户登录后记录 cookie 信息
      loginInfo: {
        userNmae: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('UserName'),
        userId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('UserID'),
        sessionId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('SessionID'),
        headPic: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('HeadPictrueUrl')
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    // axios 前置拦截器
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(function (config) {
      // 显示 loading 提示层
      _this.loading = true;
      return config;
    });
    // axios 后置拦截器
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function (response) {
      // 关闭 loading 提示层
      _this.loading = false;
      return response;
    });
  },

  methods: {
    goBackFn: function goBackFn() {
      this.$router.go(-1);
    },

    // 登出
    logoutFn: function logoutFn() {
      var _this2 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.loginInfo.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.loginInfo.sessionId);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$api.root + '/account/New_LogOff', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          // 结果匹配
          switch (res.Code) {
            // 请求成功
            case 0:
              // 删除 cookie 信息
              Object(__WEBPACK_IMPORTED_MODULE_2_assets_js_user__["a" /* delUserCookie */])();
              // 跳转到个人主页
              _this2.$router.push({ path: '/login' });
              break;
            // 如果出现其他错误，强制退出
            default:
              // 删除 cookie 信息
              Object(__WEBPACK_IMPORTED_MODULE_2_assets_js_user__["a" /* delUserCookie */])();
              // 跳转到个人主页
              _this2.$router.push({ path: '/login' });
          }
        }
        // 请求接口失败
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 显示操作弹出层
    handleShowFn: function handleShowFn() {
      this.loginFlag = true;
    },

    // 关闭操作弹出层
    handleHiddenFn: function handleHiddenFn() {
      this.loginFlag = false;
    }
  },
  components: {
    'v-loading': __WEBPACK_IMPORTED_MODULE_3_components_loading_loading__["a" /* default */]
  }
});

/***/ }),

/***/ "75ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerHeader_vue__ = __webpack_require__("FUUT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228af237_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerHeader_vue__ = __webpack_require__("l6Hr");
function injectStyle (ssrContext) {
  __webpack_require__("HOqT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228af237_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7N/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf"},[_c('v-login-info',[_c('div',{attrs:{"slot":"goBack"},slot:"goBack"},[_c('a',{staticClass:"left clearfix",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.goBackFn}},[_c('i',{staticClass:"icon-left-arrow"})])])]),_vm._v(" "),_c('iframe',{staticClass:"pdf-view",attrs:{"src":_vm.url}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8B1J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_zh_CN__ = __webpack_require__("+8+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_zh_CN__);

// 表单验证插件

// 表单验证插件中文包

// 添加中文包
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].addLocale(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_zh_CN___default.a);
// 配置中文
var config = {
  locale: 'zh_CN'
  // 注册表单插件
};__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */], config);

// 自定义验证规则
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('phone', {
  messages: {
    zh_CN: function zh_CN(field) {
      return field + '必须是11位手机号码';
    }
  },
  validate: function validate(value) {
    return value.length === 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value);
  }
});

// 修改默认提示信息
var dictionary = {
  zh_CN: {
    messages: {
      // 修改邮箱格式错误时的提示信息
      email: function email() {
        return 'email格式错误';
      },
      // 修改默认 required 的文字提示信息
      required: function required(field) {
        return field;
      }
    },
    // 修改字段提示的名称
    attributes: {
      email: '请输入email',
      heroUser: '请输入英雄账号',
      phone: '请输入手机',
      user: '请输入姓名',
      pwd: '是否设置密码',
      password: '请输入密码',
      serverName: '请输入服务器名称',
      serverType: '请选择房间类型',
      rootList: '请选择是否公开房间列表',
      serverPackage: '请选择服务器套餐',
      mapName: '请输入地图名称',
      gameDesc: '请输入游戏介绍'
    }
  }
  // 更新配置
};__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].updateDictionary(dictionary);

/***/ }),

/***/ "8hZK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "93t6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9G6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faq_vue__ = __webpack_require__("sqEy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09666b8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__ = __webpack_require__("+AE0");
function injectStyle (ssrContext) {
  __webpack_require__("Zln7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09666b8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9UVs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_vue__ = __webpack_require__("qBkf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d8a566_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_vue__ = __webpack_require__("dm8O");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d8a566_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9VHD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/15.7dd5d49.png";

/***/ }),

/***/ "9uWE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9yIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_scroll__ = __webpack_require__("bqTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_infinite_scroll__);
// 引入 vue

// 引入分页插件

// 注册插件
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_infinite_scroll___default.a);

/***/ }),

/***/ "A9Xz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_helper__ = __webpack_require__("ZKdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag__ = __webpack_require__("Wx/i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_drag__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    minProgress: {
      type: [Number, String],
      default: 0
    }

  },
  data: function data() {
    return {
      progress: 100,
      left: 100
    };
  },


  methods: {
    setProgress: function setProgress(num) {
      this.left = num;
    },
    drag: function drag(e) {
      e.preventDefault();
      e.stopPropagation();
      var $el = e.target;
      this.el = $el;
      var $container = this.$el.parentElement;
      var self = this;
      var isMobile = __WEBPACK_IMPORTED_MODULE_0__lib_helper___default.a.isMobile;
      var width = 200;
      var coor = {
        x: (isMobile ? e.touches[0]['clientX'] : e.clientX) - $el.offsetLeft,
        y: (isMobile ? e.touches[0]['clientY'] : e.clientY) - $el.offsetTop,
        maxLeft: width,
        maxTop: parseInt($container.style.height) - parseInt($el.style.height),
        minLeft: 0,
        minTop: 0
      };
      var move = function move(ev) {
        var newCoor = __WEBPACK_IMPORTED_MODULE_1__lib_drag___default()(ev, self.el, coor);
        if (newCoor) {
          if (newCoor.left / width < self.minProgress) {
            return;
          }
          self.progress = (newCoor.left - width / 2) / width;
          self.left = newCoor.left / width * 100;

          self.$emit('resize', self.progress);
        }
      };
      var stopMove = function stopMove(ev) {
        self.el = null;
        if (isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', stopMove, false);
          return;
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', stopMove, false);
      };
      if (isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', stopMove, false);
        return;
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', stopMove, false);
    }
  }

});

/***/ }),

/***/ "AmPc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faqNew_vue__ = __webpack_require__("+88Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790029cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faqNew_vue__ = __webpack_require__("wOAr");
function injectStyle (ssrContext) {
  __webpack_require__("QAId")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faqNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_790029cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faqNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B7TD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件

/* harmony default export */ __webpack_exports__["a"] = ({
  // 开发文档页面
  name: 'downloadPlugin',
  data: function data() {
    return {
      // 列表数据
      listData: [],
      // 导航数据
      navList: [],
      // 目录数据
      dirTree: [{
        id: 1,
        pid: 0,
        name: '游戏本体说明',
        text: '游戏本体说明',
        type: 1,
        lev: 1,
        show: true
      }, {
        id: 2,
        pid: 1,
        name: '总目录',
        text: '总目录.xlsx',
        type: 2,
        lev: 2,
        show: false
      }, {
        id: 3,
        pid: 1,
        name: 'NEWART目录',
        text: 'NEWART目录.xlsx',
        type: 2,
        lev: 2,
        show: false
      }, {
        id: 4,
        pid: 1,
        name: '_RESOURCES目录',
        text: '_RESOURCES目录.xlsx',
        type: 2,
        lev: 2,
        show: false
      }, {
        id: 5,
        pid: 0,
        name: '开发工具说明',
        text: '开发工具说明',
        type: 1,
        lev: 1,
        show: true
      }, {
        id: 6,
        pid: 5,
        name: '开发插件使用说明',
        text: '开发插件使用说明.docx',
        type: 3,
        lev: 2,
        show: false
      }, {
        id: 7,
        pid: 0,
        name: '首先阅读',
        text: '首先阅读.docx',
        type: 3,
        lev: 1,
        show: true
      }]
    };
  },
  created: function created() {
    // 初始化目录数据
    this.listData = this.childFn(this.dirTree, this.$route.params.pid);
    // 初始化导航数据
    this.navList = this.parentFn(this.dirTree, this.$route.params.pid);
  },

  methods: {
    // 查找子分类
    childFn: function childFn(arr, pid) {
      pid = parseInt(pid);
      // 初始化数组
      var list = [];
      // 遍历数据
      arr.forEach(function (item) {
        // 如果是子数据
        if (item.pid === pid) {
          // 添加到数据
          list.push(item);
        }
      });
      // 返回数据
      return list;
    },

    // 查找父级分类
    parentFn: function parentFn(arr, id) {
      id = parseInt(id);
      var list = [];
      arr.forEach(function (item) {
        if (item.id === id) {
          list.push(item);
        }
      });
      return list;
    },

    // 进入文件夹
    cdDirFn: function cdDirFn(id) {
      this.listData = this.childFn(this.dirTree, id);
      this.navList = this.parentFn(this.dirTree, id);
    },

    // 打开文件
    openFn: function openFn(name, pid, id) {
      this.$router.push({ path: '/pdf/' + name + '/' + pid });
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */]
  }
});

/***/ }),

/***/ "BMee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_developerHeader_developerHeader__ = __webpack_require__("75ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_user__ = __webpack_require__("xKOl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ajax 请求插件

// 引入 cookie插件

// 开发者申请头部组件

// 用户信息相关操作

// 发送验证码倒计时
var TIME_COUNT = 120;
// 错误提示
var ERROR_TIPS = [{ desc: '网络错误' }, { desc: '验证码错误' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  // 开发者申请信息填写页面
  name: 'developerInfo',
  data: function data() {
    return {
      // 验证码错误提示
      codeFlag: false,
      // 是否勾选协议
      checkBoxFlag: false,
      // 发送请求开关
      sendFlag: true,
      // 发送验证码按钮开关
      sendCodeshow: true,
      // 验证码倒计时变量
      codeTimeCount: '',
      // 计时器变量
      codeTimer: null,
      // 验证码错误信息
      codeErrorTips: '',
      // 错误提示
      errorTips: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('SessionID'),
        // 申请开发者姓名
        userName: '',
        // 邮箱
        email: '',
        // 手机
        mobile: '',
        // 验证码
        checkCode: ''
      }
    };
  },

  methods: {
    successFn: function successFn() {
      var _this = this;

      // 验证表单是否有错误
      this.$validator.validateAll().then(function () {
        // 表单有错误返回 true 没错误返回 false
        // console.log(this.errors.any())
        // 返回所有错信的信息列表
        // console.log(this.errors.all())
        // 检测表单中是否有验证错误
        var validateRes = _this.errors.any();

        if (validateRes) {
          // 错误信息
          _this.errorTips = ERROR_TIPS[1].desc;
          // 显示错误信息
          _this.codeFlag = true;
        } else {
          if (_this.sendFlag) {
            // 关闭发送请求按钮
            _this.sendFlag = false;
            // 实例化表单对象
            var formData = new FormData();
            // 用户id
            formData.append('UserID', _this.formDatas.userId);
            // sessionId
            formData.append('SessionID', _this.formDatas.sessionId);
            // 用户名
            formData.append('RealName', _this.formDatas.userName);
            // 邮箱
            formData.append('Email', _this.formDatas.email);
            // 手机
            formData.append('Mobile', _this.formDatas.mobile);
            // 验证码
            formData.append('VerificationCode', _this.formDatas.checkCode);
            // 申请开发者 api
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this.$api.root + '/Developer/DeveloperApply', formData, {
              // 设置请求为表单提交
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function (response) {
              // http 请求成功
              if (response.status === 200) {
                // 获取接口数据
                var res = response.data;
                switch (res.Code) {
                  // 申请成功跳转到申请状态页面
                  case 0:
                    _this.$router.push({ name: 'developerStatus' });
                    break;
                  // 登录信息失效，删除登录信息跳转到登录页
                  case 1:
                    Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
                    _this.$router.push({ name: 'login' });
                    break;
                  case 2:
                    // 错误信息
                    _this.errorTips = res.Msg;
                    // 显示错误信息
                    _this.codeFlag = true;
                    // 开启发送请求按钮
                    _this.sendFlag = true;
                    break;
                  // 请求失败
                  default:
                    // 错误信息
                    _this.errorTips = res.Msg;
                    _this.codeFlag = true;
                    // 开启发送请求按钮
                    _this.sendFlag = true;
                }
              } else {
                // 开启发送请求按钮
                _this.sendFlag = true;
              }
              // 请求接口失败
            }).catch(function (error) {
              // 开始发送请求按钮
              _this.sendFlag = true;
              // 打印请求失败信息
              console.log(error);
            });
          }
        }
      }).catch(function () {
        console.log('表单验证失败');
      });
    },

    // 发送验证后倒计时
    getCode: function getCode() {
      var _this2 = this;

      this.$validator.validate('phone', this.formDatas.mobile);
      // 检测手机号是否正确
      var mobileCheck = this.errors.any();
      console.log(mobileCheck);
      if (!mobileCheck) {
        // 实例化表单对象
        var formData = new FormData();
        // 用户id
        formData.append('UserID', this.formDatas.userId);
        // sessionId
        formData.append('SessionID', this.formDatas.sessionId);
        // 手机
        formData.append('Mobile', this.formDatas.mobile);
        // 验证码 api
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$api.root + '/Developer/GetVerificationCode', formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            var res = response.data;

            switch (res.Code) {
              // 验证码申请成功，开始验证码倒计时
              case 0:
                _this2.getCodeTime();
                // 清空验证码错误提示
                _this2.codeErrorTips = '';
                break;
              // 登录信息失效，删除登录信息跳转到登录页
              case 1:
                Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
                _this2.$router.push({ name: 'login' });
                break;
              // 记录错误提示信息
              case 2:
                _this2.codeErrorTips = res.Msg;
                break;
              // 清除用户登录信息并清空验证码提示信息
              default:
                _this2.codeErrorTips = '';
                Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
                _this2.$router.push({ name: 'login' });
            }
          }
          // 请求接口失败
        }).catch(function (error) {
          // 打印请求失败信息
          console.log(error);
        });
      }
    },

    // 发送短信验证码倒计时
    getCodeTime: function getCodeTime() {
      var _this3 = this;

      if (!this.codeTimer) {
        this.codeTimeCount = TIME_COUNT;
        this.sendCodeshow = false;
        this.codeTimer = setInterval(function () {
          if (_this3.codeTimeCount > 0 && _this3.codeTimeCount <= TIME_COUNT) {
            _this3.codeTimeCount--;
          } else {
            _this3.sendCodeshow = true;
            clearInterval(_this3.codeTimer);
            _this3.codeTimer = null;
          }
        }, 1000);
      }
    }
  },
  components: {
    'v-developer-header': __WEBPACK_IMPORTED_MODULE_2_components_developerHeader_developerHeader__["a" /* default */]
  }
});

/***/ }),

/***/ "BXlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'basicMask',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  beforeUpdate: function beforeUpdate() {
    var _this = this;

    this.$nextTick(function () {
      // 初始化遮罩层的位置
      _this.init();
    });
  },

  methods: {
    init: function init() {
      // 获取弹出层内容
      var oBasicMaskContent = this.$refs.basicMaskContent;
      // 计算左边边距
      var left = oBasicMaskContent.offsetWidth / 2;
      // 计算上边边距
      var top = oBasicMaskContent.offsetHeight / 2;
      // 对边距进行赋值
      oBasicMaskContent.style.marginLeft = -left + 'px';
      oBasicMaskContent.style.marginTop = -top + 'px';
    },
    colseMask: function colseMask() {
      this.$emit('closeMaskEv', !this.show);
    }
  }
});

/***/ }),

/***/ "C5HD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-1-image.33b0ebd.png";

/***/ }),

/***/ "D8rO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rotateDegree: 0
    };
  },


  methods: {
    rotateRight: function rotateRight() {
      this.rotateDegree += 90;
      this.$emit('rotate', this.rotateDegree);
    },
    rotateLeft: function rotateLeft() {
      this.rotateDegree -= 90;
      this.$emit('rotate', this.rotateDegree);
    }
  }
});

/***/ }),

/***/ "DJxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-aside"},[_c('div',{staticClass:"g-crop-image-box"},[_c('div',{staticClass:"g-crop-image-principal",on:{"touchstart":_vm.drag,"mousedown":_vm.drag}},[_c('div',{staticClass:"image-wrap",style:({ width: _vm.width + 'px',height: _vm.height + 'px', left: _vm.left+ 'px', top: _vm.top + 'px', backgroundImage: 'url(' + _vm.src + ')', cursor: _vm.isResize ? 'default' : 'move'})},[_c('img',{ref:"crop-image",staticStyle:{"width":"0","height":"0"},attrs:{"src":_vm.src}})]),_vm._v(" "),(!_vm.isResize)?_c('div',{staticClass:"image-mask"},[_c('div',{staticClass:"mask top",style:({ top:0, height: _vm.cropCSS.top + 'px', left: 0, width: '100%'})}),_vm._v(" "),_c('div',{staticClass:"mask bottom",style:({ bottom:0, top: (_vm.cropCSS.top + _vm.cropCSS.height) + 'px', left: 0, width: '100%'})}),_vm._v(" "),_c('div',{staticClass:"mask left",style:({top: _vm.cropCSS.top + 'px', height: _vm.cropCSS.height + 'px', left:0, width: _vm.cropCSS.left + 'px'})}),_vm._v(" "),_c('div',{staticClass:"mask right",style:({top: _vm.cropCSS.top + 'px', height: _vm.cropCSS.height + 'px', left: (_vm.cropCSS.left + _vm.cropCSS.width) + 'px', right: 0})})]):_vm._e(),_vm._v(" "),(!_vm.isResize)?_c('div',{staticClass:"crop-box",style:({top: _vm.cropCSS.top + 'px', left: _vm.cropCSS.left + 'px', height: _vm.cropCSS.height + 'px',  width: _vm.cropCSS.width + 'px'})},[_c('div',{staticClass:"reference-line v"}),_vm._v(" "),_c('div',{staticClass:"reference-line h"}),_vm._v(" "),_c('a',{staticClass:"g-resize",on:{"touchstart":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.resize($event)},"mousedown":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.resize($event)}}})]):_vm._e()]),_vm._v(" "),(_vm.resize)?_c('resize-bar',{ref:"resizeBar",on:{"resize":_vm.resizeImage}}):_vm._e(),_vm._v(" "),(_vm.isRotate)?_c('rotate-bar',{on:{"rotate":_vm.rotateImage}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DKKg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Du0Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Du3Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ENjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"map-info"},[_c('v-login-info'),_vm._v(" "),_c('div',{staticClass:"form-content"},[_c('h1',{staticClass:"map-title"},[_vm._v("地图MOD"+_vm._s(_vm.setpText)+"区信息")]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("地图ID：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_vm._v(_vm._s(_vm.mapInfo.MapId))])]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("地图名字：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.mapInfo.MapName))])])]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("匹配模式：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('div',[_vm._v(_vm._s(_vm.tempInfo.teampeople)+"排， "+_vm._s(_vm.tempInfo.teamnummin)+"队")])])]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏标签：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.mapInfo.MapTag))])])]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏介绍：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.mapInfo.Note))])])]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("更新内容：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.mapInfo.UpdateContent))])])]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏主图：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('img',{staticClass:"game-main-image",attrs:{"src":_vm.mapInfo.MainPicture ? _vm.mapInfo.MainPicture : _vm.defaultPic,"alt":"游戏主图"}})])]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏截图：")]),_vm._v(" "),_c('dd',{staticClass:"content game-scree-image"},[_c('div',{staticClass:"item"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.mapInfo.Picture1),expression:"mapInfo.Picture1"}],staticClass:"image",attrs:{"src":_vm.mapInfo.Picture1,"alt":"截图截图"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.mapInfo.Picture2),expression:"mapInfo.Picture2"}],staticClass:"image",attrs:{"src":_vm.mapInfo.Picture2,"alt":"截图截图"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.mapInfo.Picture3),expression:"mapInfo.Picture3"}],staticClass:"image",attrs:{"src":_vm.mapInfo.Picture3,"alt":"截图截图"}})])])]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"}),_vm._v(" "),_c('dd',{staticClass:"content game-scree-image"},[_c('div',{staticClass:"item"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.mapInfo.Picture4),expression:"mapInfo.Picture4"}],staticClass:"image",attrs:{"src":_vm.mapInfo.Picture4,"alt":"截图截图"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.mapInfo.Picture5),expression:"mapInfo.Picture5"}],staticClass:"image",attrs:{"src":_vm.mapInfo.Picture5,"alt":"截图截图"}})]),_vm._v(" "),_c('div',{staticClass:"item"})])]),_vm._v(" "),_c('dl',{staticClass:"form-box clearfix"},[_c('dt',{staticClass:"title"}),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('p',[_vm._v("发布时间："+_vm._s(_vm.createTime))]),_vm._v(" "),_c('p',[_vm._v("您的版本提交日期："+_vm._s(_vm.submitTime))]),_vm._v(" "),_c('p',[_vm._v("版本号："+_vm._s(_vm.mapInfo.MapVersion))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EWHj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toExamine_vue__ = __webpack_require__("U/Gq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3953a69b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toExamine_vue__ = __webpack_require__("S0ej");
function injectStyle (ssrContext) {
  __webpack_require__("9uWE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toExamine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3953a69b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toExamine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EsPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // 审核通过页面
  name: 'developerStatus',
  methods: {
    goHomeFn: function goHomeFn() {
      this.$router.push({ path: 'home' });
    }
  }
});

/***/ }),

/***/ "FUUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'developerHeader'
});

/***/ }),

/***/ "FY9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createServer_vue__ = __webpack_require__("5Ltc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99a5d1a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createServer_vue__ = __webpack_require__("p83Q");
function injectStyle (ssrContext) {
  __webpack_require__("HbGP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createServer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99a5d1a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createServer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fmar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"developer-agreement"},[_c('v-developer-header'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"agreement-confirm",attrs:{"onselectstart":"return false"}},[_c('span',{staticClass:"base-checkbox-box agreement-checkbox agreement-content-desc"},[_c('input',{staticClass:"base-checkbox",attrs:{"id":"agree","name":"test","type":"checkbox"},on:{"click":function($event){_vm.agreeFlag = !_vm.agreeFlag}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('span',{staticClass:"greement-content-desc"},[_vm._v("我已仔细阅读并同意以上")]),_vm._v(" "),_c('span',{staticClass:"agreement-content-tips"},[_vm._v("协议内容")])]),_vm._v(" "),_c('div',{staticClass:"handle",on:{"click":_vm.nextFn}},[_c('router-link',{staticClass:"handle-btn",class:!_vm.agreeFlag ? 'no-agreement' : '',attrs:{"to":_vm.agreeFlag ? '/developerInfo' : ''}},[_vm._v("下一步")])],1),_vm._v(" "),_c('v-basic-mask',{ref:"basicMask",attrs:{"show":_vm.maskFlag},on:{"closeMaskEv":_vm.closeMaskFn}},[_c('span',{attrs:{"slot":"desc"},slot:"desc"},[_vm._v("需要同意开发者协议才能提交申请")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apply-content"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"dev-center"},[_vm._v("鲲计划开发者协议")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("重要提示：")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("天津五麦科技有限公司依据本协议向开发者提供服务，本协议在开发者和天津五麦科技有限公司间具有合同上的法律效力，对双方具有约束力。")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("天津五麦科技有限公司在此特别提醒开发者认真阅读、充分理解本协议各条款，特别是其中所涉及的免除及限制天津五麦科技有限公司责任的条款、对开发者权利限制条款、争议解决和法律适用条款等。")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("请审慎阅读并选择接受或不接受本协议。除非开发者接受本协议所有条款，否则开发者无权使用天津五麦科技有限公司于本协议项下所提供的服务。")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("开发者一经注册鲲计划平台账号或使用本协议下任何服务即视为对本服务条款的充分理解和完全接受。")]),_vm._v(" "),_c('p',{staticClass:"strengthen paragraph"},[_vm._v("1.定义")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("如无特别说明，下列术语在本协议中的含义为：")]),_vm._v(" "),_c('p',[_vm._v("(1)鲲计划平台，是指由天津五麦科技有限公司（以下简称“五麦公司”）基于其拥有的《创造与魔法》游戏基础技术构架提供的独立开发平台，是旨在为开发者提供技术服务的平台，供开发者在平台上开发相关产品，并可通过 鲲计划平台申请将开发完成的产品上传至《创造与魔法》游戏 创意工坊板块供用户使用。")]),_vm._v(" "),_c('p',[_vm._v("(2)开发者，指经有效申请并经过五麦公司同意，可以使用鲲计划平台进行产品开发的个人或企业用户。")]),_vm._v(" "),_c('p',[_vm._v("(3)产品，指由开发者开发的可向用户提供各种服务的内容，包括但不限于拥有完整世界观的游戏场景、游戏人物、游戏玩法、美术资源、视频或音乐类服务等内容。")]),_vm._v(" "),_c('p',[_vm._v("(4)平台基础工具，是指鲲计划平台提供的基础数据及网站数据，开发者可以基于平台基础工具进行产品开发。平台基础数据归属于五麦公司，属于五麦公司财产。")]),_vm._v(" "),_c('p',[_vm._v("(5)平台运营数据，是指开发者通过鲲计划平台使用服务及开发产品后，将产品提交的、平台生成的或开发者应用生成的任何数据或信息，包括但不限于用户注册数据，用户行为数据，用户消费数据，用户智能终端属性等数据。平台运营数据是五麦公司的财产。")]),_vm._v(" "),_c('p',[_vm._v("(6)商标，是指开发者使用的或同移动游戏产品或相关的手册、促销或销售小册子或其他材料一起使用商标、商品名、标识或特性或其它相当物（无论是否已经注册）。")]),_vm._v(" "),_c('p',[_vm._v("(7)著作权，是指由中国版权保护中心出具的《计算机软件著作权登记证书》《美术作品登记证书》等著作权证书，以证明该软件享有相应知识产权的权利。")]),_vm._v(" "),_c('p',[_vm._v("(8)服务器，是指五麦公司在指定地点安装有服务器端软件的计算机，鉴于用户数据安全的需要，合作必须使用五麦公司提供的服务器。")]),_vm._v(" "),_c('p',[_vm._v("(9)BUG，是指在软件产品依照正确运行的配置需求和开发者提供给最终用户的文件进行运行时出现的影响用户使用该产品或服务的误差、缺陷、错误。BUG可能因为程序代码或系统设计内的缺陷和误差产生。但此错误并不指也不包括任何由外界因素直接或间接造成的缺陷和BUG，外界因素包括但不限于外挂攻击和其它非上述软件的缺陷和BUG引起的因素。")]),_vm._v(" "),_c('p',{staticClass:"strengthen paragraph"},[_vm._v("2.接受")]),_vm._v(" "),_c('p',[_vm._v("(1)您知晓、认可并同意遵守五麦公司《鲲计划开发者协议》。")]),_vm._v(" "),_c('p',[_vm._v("(2)当您注册或使用本协议下任何服务时，您知晓、认可并同意遵守《鲲计划开发者协议》。")]),_vm._v(" "),_c('p',[_vm._v("(3)五麦公司有权在必要时更新本协议。本协议的每次更新都会在鲲计划平台网站上发布，并立即生效。如果您拒绝接受新的协议，您必须放弃使用五麦公司提供的服务；若您继续使用鲲计划平台，则表明您知晓、认可并同意遵守新的协议。")]),_vm._v(" "),_c('p',[_vm._v("(4)五麦公司有权自行决定调整、增加、停止鲲计划平台上的服务或功能。除非特别声明，新功能、新服务将适用此协议。")]),_vm._v(" "),_c('p',[_vm._v("(5)开发者违反本协议或相关条款、协议、规则等时五麦公司有权依照其违反情况随时限制或停止向开发者提供鲲计划平台相关服务，并有权追究开发者的相关责任。")]),_vm._v(" "),_c('p',{staticClass:"strengthen paragraph"},[_vm._v("3.开发者权利和义务")]),_vm._v(" "),_c('p',[_vm._v("(1)账号注册")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("1)开发者应当通过英雄互娱的平台账号登录鲲计划平台，进行开发者申请，以成为鲲计划平台的开发者。开发者帐户一经申请成功，相应的注册号码（手机号、邮箱等）不得变更，且该帐户与开发者唯一绑定，不可赠与、不可转让、不可继承。")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("2)开发者不得违反本协议约定将开发者的账户用于其他目的。否则，五麦公司有权随时单方限制、中止或终止向开发者提供本服务，且未经五麦公司同意开发者不得再次使用本服务。")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("3)开发者的鲲计划平台帐号，是开发者登录及使用本服务的凭证。开发者应当做好号码、密码，以及进入和管理本服务中的各类产品与服务的口令、密码等的保密措施。因开发者保密措施不当或开发者的其他行为，致使上述口令、密码等丢失或泄漏所引起的一切损失和后果，均由开发者自行承担。")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("4)开发者保证：开发者注册本服务账户的手机、邮箱均是开发者本人合法拥有的。鲲计划平台账号在本服务中进行的包括但不限于以下事项：提交相应资质材料、确认和同意相关协议和规则、选择具体服务类别、进行产品开发以及费用结算等事项，均是开发者自行或开发者授权他人进行的行为，对开发者均有约束力。同时，开发者负责妥善管理前述账号，对该账号项下所发生的一切行为负责，开发者承担以前述号码为标识进行的全部行为的法律责任。")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("5)若开发者发现有他人冒用或盗用开发者的账户及密码、或任何其他未经开发者合法授权的情形时，应立即以有效方式通知五麦公司。五麦公司收到开发者的有效请求并核实身份后，会根据不同情况采取相应措施。若开发者提供的信息不完全，导致五麦公司无法核实开发者的身份或无法判断开发者的需求等，而导致五麦公司无法进行及时处理，给开发者带来的损失，开发者应自行承担。同时，五麦公司对开发者的请求采取措施需要合理期限，对于开发者通知五麦公司以及五麦公司根据开发者的有效通知采取措施之前，由于他人行为给开发者造成的损失，五麦公司不承担任何责任。")]),_vm._v(" "),_c('p',[_vm._v("(2)产品开发")]),_vm._v(" "),_c('p',[_vm._v("鲲计划平台提供的技术服务包含不限于工具及运营、客服系统、策划指导等帮助。根据鲲计划平台提供的平台工具，开发者应使用LUA语言进行产品开发。")]),_vm._v(" "),_c('p',[_vm._v("(3)产品保证")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("1)开发者保证，使用鲲计划平台开发的相关产品，内容应与《创造与魔法》游戏整体世界观、基调等相吻合。产品不包含任何与《创造与魔法》游戏相抵触的内容，不存在降低或可能降低《创造与魔法》游戏评价的内容。")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("2)开发者保证，开发完成的产品，不存在BUG等影响产品正常运转的瑕疵，开发者会根据产品运营情况定期对产品进行更新及调整，保证提供优质的产品和服务。")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("3)开发者保证产品内容不得含有任何违反国家法律、法规和政策的信息，包括但不限于：")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("a.违反宪法确定的基本原则的；")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("b.危害国家统一、主权和领土完整的；")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("c.泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("d.煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("e.宣扬邪教、迷信的；")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("f.散布谣言，扰乱社会秩序，破坏社会稳定的；")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("g.宣扬淫秽、色情、赌博、暴力，或者教唆犯罪的；")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("h.侮辱、诽谤他人，侵害他人合法权益的；")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("i.违背社会公德的；")]),_vm._v(" "),_c('p',{staticClass:"indent-2"},[_vm._v("j.有法律、行政法规和国家规定禁止的其他内容的。")]),_vm._v(" "),_c('p',[_vm._v("4)如开发者产品存在违法、违规或者侵权信息的，由此产生的一切责任由开发者自行承担。如因此给五麦公司造成损失的，开发者应一并承担五麦公司的损失。")]),_vm._v(" "),_c('p',[_vm._v("(4)产品发布")]),_vm._v(" "),_c('p',[_vm._v("开发者知悉并同意，基于鲲计划平台开发的全部产品，通过审核后仅能用于上传至《创造与魔法》游戏内，供游戏用户使用，并根据产品的评价及用户使用情况、道具购买情况等综合因素，取得开发收益。产品在《创造与魔法》游戏内发布期间，开发者不得将产品另行以任何形式发布至其他平台。")]),_vm._v(" "),_c('p',[_vm._v("(5)客户服务")]),_vm._v(" "),_c('p',[_vm._v("开发者应就其开发的产品提供客户服务工作，包含不限于线上QQ、微信解答用户咨询，电话反馈用户问题等，及时、妥善的解决用户提出的问题。如果发生用户投诉，开发者应积极主动解决并承担全部责任。因客户服务处理不当导致用户投诉《创造与魔法》游戏的，开发者承担全部责任。")]),_vm._v(" "),_c('p',[_vm._v("(6)服务器")]),_vm._v(" "),_c('p',[_vm._v("开发者知悉并同意，基于鲲计划平台开发产生的全部内容，均存储在五麦公司购买或拥有合法权利的服务器之上。开发者应根据其使用服务器的数量向五麦公司支付相关费用，费用的支付形式以届时平台要求为准。")]),_vm._v(" "),_c('p',{staticClass:"strengthen paragraph"},[_vm._v("4.五麦公司权利及义务")]),_vm._v(" "),_c('p',[_vm._v("(1)保护开发者的信息安全是五麦公司的一项基本原则，未经开发者的同意，五麦公司不会向五麦公司及其关联方以外的任何公司、组织和个人披露、提供开发者的信息，但下列情形除外：")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("1)据本协议或其他相关协议、规则等规定可以提供的；")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("2)依据法律法规的规定可以提供的；")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("3)行政、司法等政府部门要求提供的；")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("4)开发者同意五麦公司向第三方提供；")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("5)为解决举报事件、提起诉讼而需要提供的；")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("6)为防止严重违法行为或涉嫌犯罪行为发生而采")]),_vm._v(" "),_c('p',[_vm._v("(2)尽管五麦公司会对开发者的信息保护做极大的努力，但是仍然不能保证在现有的安全技术措施下，开发者的信息可能会因为不可抗力或非五麦公司因素造成泄漏、窃取等，由此给开发者造成损失的，开发者同意五麦公司可以免责。")]),_vm._v(" "),_c('p',[_vm._v("(3)除了另行有约定外，五麦公司无需为按照本协议享有的权益而向开发者支付任何费用。")]),_vm._v(" "),_c('p',[_vm._v("(4)开发者理解并同意：为向更多互联网使用者推广开发者的产品，五麦公司有权采取以下行为，而无须再取得开发者的同意。")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("1)在第三方平台、网站等采取各种形式对产品进行宣传、推广；")]),_vm._v(" "),_c('p',{staticClass:"indent-1"},[_vm._v("2)有权为本协议目的使用开发者移动游戏产品的LOGO、标识、名称、图片等相关素材。")]),_vm._v(" "),_c('p',{staticClass:"strengthen paragraph"},[_vm._v("5.知识产权归属及许可")]),_vm._v(" "),_c('p',[_vm._v("(1)五麦公司因履行本协议而提供的所有内容包含不限于开发平台、账号、平台商标，著作权平台基础数据、平台运营数据等全部具有商业价值的资产之知识产权归属于五麦公司所有，授权开发者使用并不视为转让或者无偿许可等。未经五麦公司书面许可，开发者不得将五麦公司提供的内容用于本协议以外之目的和用途。")]),_vm._v(" "),_c('p',[_vm._v("(2)开发者在鲲计划平台开发的所有产品，包含不限于著作权、商标权、专利等所有知识产权归属于开发者。开发者在此不可撤销的授权五麦公司，有权使用开发者在鲲计划平台平台开发的所有产品之著作权财产权，包含不限于对开发产品进行复制、改编、信息网络传播等各种权利，并有权对侵权行为以自己的名义进行维权。")]),_vm._v(" "),_c('p',{staticClass:"strengthen paragraph"},[_vm._v("6.服务的暂停或终止")]),_vm._v(" "),_c('p',[_vm._v("(1)开发者应按照五麦公司的要求提交真实准确的相关资料，如五麦公司发现开发者提交的任何信息不真实或不准确的，五麦公司有权暂停或终止向其提供本协议下服务,由此产生的一切法律责任由开发者自行承担。 ")]),_vm._v(" "),_c('p',[_vm._v("(2)如开发者书面通知或以实际行动表示不接受五麦公司新的服务条款的，五麦公司有权随时暂停或终止向其提供本协议下服务。")]),_vm._v(" "),_c('p',[_vm._v("(3)在开发者违反本协议规定、违反任何法律法规或者侵害第三方权益时，五麦公司有权随时暂停或终止向该开发者提供服务。如该开发者后续再直接或间接或以他人名义注册登录鲲计划平台并申请使用登录服务的，五麦公司有权直接单方面暂停或终止提供本协议下服务。")]),_vm._v(" "),_c('p',[_vm._v("(4)如本协议服务终止，五麦公司有权选择是否为开发者保留开发者账号中与登录服务相关的任何信息，也可选择是否将信息转发给开发者，也有权选择是否保存开发者的数据及以前的记录。")]),_vm._v(" "),_c('p',[_vm._v("如本协议服务终止的，五麦公司有权删除在服务终止前开发者尚未完成或已经完成的全部信息。")]),_vm._v(" "),_c('p',{staticClass:"strengthen paragraph"},[_vm._v("7.其他")]),_vm._v(" "),_c('p',[_vm._v("(1)开发者一经注册或使用本协议下任何服务，即视为开发者已阅读并同意接受本协议及上述内容的约束。五麦公司有权在必要时单方修改本协议或上述内容，相关内容变更后，如果开发者继续使用本服务，即视为开发者已接受修改后的相关内容。 如果开发者不接受修改后的相关内容，应当停止使用相关服务。")]),_vm._v(" "),_c('p',[_vm._v("(2)本协议签订地为中华人民共和国北京市朝阳区。")]),_vm._v(" "),_c('p',[_vm._v("(3)本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）")]),_vm._v(" "),_c('p',[_vm._v("(4)若开发者和五麦公司就本协议发生任何纠纷或争议，首先应当友好协商解决；协商无法达成一致的，双方均同意将纠纷或争议提交本协议签订地有管辖权的人民法院解决。")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"icon-box",attrs:{"for":"agree"}},[_c('i',{staticClass:"icon icon-checkbox-unchecked"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GoBJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H3eK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkboxComponent_vue__ = __webpack_require__("ywfD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_515cd57d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkboxComponent_vue__ = __webpack_require__("Lsvt");
function injectStyle (ssrContext) {
  __webpack_require__("hfl/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkboxComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_515cd57d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkboxComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HB59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerInfo_vue__ = __webpack_require__("BMee");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69897c02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerInfo_vue__ = __webpack_require__("Tlxa");
function injectStyle (ssrContext) {
  __webpack_require__("HyNL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69897c02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HLWg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/14.642c00c.png";

/***/ }),

/***/ "HOqT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Haow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_developerHeader_developerHeader__ = __webpack_require__("75ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_loading_loading__ = __webpack_require__("qqiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_js_user__ = __webpack_require__("xKOl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 头部组件

// 引入 cookie插件

// ajax 请求插件

// 遮罩层组件
// import basicMask from 'components/basicMask/basicMask'
// lading 加载组件

// 用户信息相关操作

// 其他错误
var ERRORS = {
  NET_ERROR: '网络错误',
  UNKNOWN_ERROR: '未知错误'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  // 登录页面
  name: 'login',
  data: function data() {
    return {
      // 常用手机操作系统标志
      tipsFlag: false,
      // 加载提示层
      loading: false,
      // 遮罩层开关
      // maskFlag: false,
      // 错误提示
      errorTips: '',
      // 表单错误信息
      formErrot: '',
      // 表单提交信息
      formDatas: {
        // 用户名
        userName: '',
        // 密码
        passWord: '',
        // 系统类型
        systemType: '',
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('SessionID')
      }
    };
  },
  created: function created() {
    /*
    let loginInfo = {
      UserID: VueCookie.get('UserID'),
      SessionID: VueCookie.get('SessionID')
    }
    */
    // 如果已经登录过了，跳转到首页
    if (this.formDatas.userId && this.formDatas.sessionId) {
      // 跳转到个人主页
      this.$router.push({ path: '/home' });
    }
  },
  mounted: function mounted() {
    var _this = this;

    // axios 前置拦截器
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function (config) {
      // 显示 loading 提示层
      _this.loading = true;
      return config;
    });
    // axios 后置拦截器
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(function (response) {
      // 关闭 loading 提示层
      _this.loading = false;
      return response;
    });
  },

  methods: {
    // 登录
    loginFn: function loginFn() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        // 表单有错误返回 true 没错误返回 false
        // console.log(this.errors.any())
        // 返回所有错信的信息列表
        // console.log(this.errors.all())
        // 表单是否有错误信息
        var isError = _this2.errors.any();
        if (isError) {
          // 获取所有错误信息的数组列表
          var formErrors = _this2.$validator.errors.all();
          // 返回第一个错误信息
          _this2.formErrot = formErrors[0];
        } else {
          // 是否选择手机系统
          if (_this2.formDatas.systemType) {
            /* let formData = new FormData()
              for (let key in this.formDatas) {
             formData.append("'" + key + "'", this.formDatas[key])
             //console.log(key + ' = ' + this.formDatas[key])
             } */

            // 实例化表单对象
            var formData = new FormData();
            // 将用户名添加到表单
            formData.append('LoginName', _this2.formDatas.userName);
            // 将密码添加到表单
            formData.append('PassWord', _this2.formDatas.passWord);
            // 常用手机操作系统
            formData.append('PlatId', _this2.formDatas.systemType);
            // 请求登录 api
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this2.$api.root + '/account/New_Login', formData, {
              // Axios.post(this.$api.root + '/account/New_Login', formData, {
              // 设置请求为表单提交
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function (response) {
              // http 请求成功
              if (response.status === 200) {
                // 获取接口数据
                var res = response.data;

                switch (res.Code) {
                  case 0:
                    // 保存登录信息到 cookie
                    Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["b" /* saveCookie */])(res);
                    // 跳转到信息填写页面
                    _this2.$router.push({ name: 'home' });
                    break;
                  case 1:
                    // 密码或账号错误
                    // this.errorTips = res.Msg
                    // 将错误信息添加到验证中
                    // this.$validator.errors.add('password', this.errorTips)
                    _this2.formErrot = res.Msg;
                    break;
                  case 2:
                    // 错误信息
                    // this.errorTips = res.Msg
                    // 将错误信息添加到验证中
                    // this.$validator.errors.add('password', this.errorTips)
                    _this2.formErrot = res.Msg;
                    break;
                  default:
                    // 未知错误
                    // this.$validator.errors.add('password', ERRORS.UNKNOWN_ERROR)
                    _this2.formErrot = ERRORS.UNKNOWN_ERROR;
                }
              }
              // 请求接口失败
            }).catch(function (error) {
              console.log(error);
              // 关闭加载提示层
              _this2.loading = false;
              // this.$validator.errors.add('password', ERRORS.NET_ERROR)
              _this2.formErrot = ERRORS.NET_ERROR;
            });
            // 没有选择手机操作系统
          } else {
            // 打开遮罩层
            // this.maskFlag = true
            _this2.formErrot = '请选择常用手机操作系统';
          }
        }
      }).catch(function () {
        console.log('表单验证失败');
      });
    },
    androidFn: function androidFn() {
      // 设置安卓系统状态码
      this.formDatas.systemType = '85';
    },
    appleFn: function appleFn() {
      this.formDatas.systemType = '106';
    },

    /*
    closeMaskFn (val) {
      // 设置苹果系统状态码
      this.maskFlag = val
    },
    */
    // 常用操作系统提示信息
    tipsFn: function tipsFn() {
      this.tipsFlag = !this.tipsFlag;
    }
  },
  components: {
    'v-developer-header': __WEBPACK_IMPORTED_MODULE_0_components_developerHeader_developerHeader__["a" /* default */],
    // 'v-basic-mask': basicMask,
    'v-loading': __WEBPACK_IMPORTED_MODULE_3_components_loading_loading__["a" /* default */]
  }
});

/***/ }),

/***/ "HbGP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Htb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-mask-wrap"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"basic-mask"},[_c('div',{ref:"basicMaskContent",staticClass:"basic-mask-content"},[_c('div',{staticClass:"desc"},[_vm._t("desc",[_vm._v("提示层")])],2),_vm._v(" "),_c('div',{staticClass:"btn-wrap"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.colseMask}},[_vm._v("确定")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HyNL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IEL4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件

// 判断客户端来源
// import {isPc} from 'assets/js/ispc'

/* harmony default export */ __webpack_exports__["a"] = ({
  // 下载开发插件页面
  name: 'downloadPlugin',
  data: function data() {
    return {
      // 默认菜单索引
      menuIndex: 0,
      menuList: ['地图模式插件下载', '私服模式插件下载'],
      mapList: [{
        list: [{
          title: '说明文档下载地址',
          // downLink: `${this.$down.root}/static/down/说明文档.rar`,
          downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Doc/%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3.rar',
          blank: false
        }, {
          title: '开发插件下载地址(版本号:1.1014756.1014756)',
          downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Creation%26MagicDevelopmentKit/1.1016678.1016678/Creation%26MagicDevelopmentKit-1.1016678.1016678.rar',
          blank: false
        }, {
          title: 'unity 5.5.4f164位下载地址：（需使用本版本的unity才可以配合《创造与魔法》插件使用）：',
          downLink: 'https://download.unity3d.com/download_unity/8ffd0efd98b1/Windows64EditorInstaller/UnitySetup64-5.5.4f1.exe',
          blank: false
        }, {
          title: '欢乐射击MOD资源文件下载地址：',
          downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/ModHappyShooting/2018-2-7/%E6%AC%A2%E4%B9%90%E5%B0%84%E5%87%BB%E6%96%87%E4%BB%B6%E5%8C%85.rar',
          blank: false
        },
        /* {
          title: '射箭小游戏教程地址：',
          downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Course/ModShooting.rar',
          blank: false
        }, */
        {
          title: '开发者modhappjump教程：',
          downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Doc/%E5%BC%80%E5%8F%91%E8%80%85modhappyjump%E6%95%99%E7%A8%8B.docx',
          blank: false
        }, {
          title: '程序架构文档：',
          downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Doc/%E7%A8%8B%E5%BA%8F%E6%9E%B6%E6%9E%84%E6%96%87%E6%A1%A3.docx',
          blank: false
        }, {
          title: 'NewMODHappJump工程资源文件：',
          downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Course/NewModHpaayJumpDeveloper.rar',
          blank: false
        }]
      }, {
        list: [{
          title: '私服MOD正在研发中，敬请期待。',
          downLink: ''
        }]
      }]
    };
  },

  methods: {
    meunFn: function meunFn(index) {
      this.menuIndex = index;
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */]
  }
});

/***/ }),

/***/ "IX/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_checkboxComponent_checkboxComponent__ = __webpack_require__("H3eK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_developerHeader_developerHeader__ = __webpack_require__("75ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_basicMask_basicMask__ = __webpack_require__("/pyY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入复选框组件

// 头部组件

// 遮罩提示层


/* harmony default export */ __webpack_exports__["a"] = ({
  // 开发者而申请协议
  name: 'developerAgreement',
  data: function data() {
    return {
      // 是否勾选协议
      agreeFlag: false,
      // 弹出层
      maskFlag: false
    };
  },

  methods: {
    // 同意协议后下一步
    nextFn: function nextFn() {
      // 弹出提示框
      this.maskFlag = !this.maskFlag;
    },
    closeMaskFn: function closeMaskFn(val) {
      this.maskFlag = val;
    }
  },
  components: {
    'v-checkbox': __WEBPACK_IMPORTED_MODULE_0_components_checkboxComponent_checkboxComponent__["a" /* default */],
    'v-developer-header': __WEBPACK_IMPORTED_MODULE_1_components_developerHeader_developerHeader__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_2_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "Ik4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_user__ = __webpack_require__("xKOl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作


/* harmony default export */ __webpack_exports__["a"] = ({
  // 地图审核信息不完善
  name: 'mapInfoImperfect',
  data: function data() {
    return {
      // 地图 id
      mapId: this.$route.params.mapId,
      // 地图审核阶段
      stage: this.$route.params.stage,
      // 地图名称
      mapName: '',
      // 错误信息
      errorInfo: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('SessionID')
      }
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      var _this = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图id
      formData.append('MapId', this.mapId);
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$api.root + '/Developer/GetMapDevInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 获取地图名称
              _this.mapName = res.DevInfo.MapName;
              // 获取错误信息
              _this.errorInfo = res.DevInfo.FailInfo;
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_2_assets_js_user__["a" /* delUserCookie */])();
              _this.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "J3cW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.0ca39f6.png";

/***/ }),

/***/ "KO5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KSet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"plugin-faq"},[_c('h3',{staticClass:"plugin-faq-title"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("插件FAQ")]),_vm._v(" "),_c('span',{staticClass:"line"})]),_vm._v(" "),_c('dl',{staticClass:"qa"},[_c('dt',{staticClass:"ask"},[_vm._v("问：为什么插件要选择IOS和安卓？")]),_vm._v(" "),_c('dd',{staticClass:"answer"},[_vm._v("答：受限于常用平台的限制，英雄账号下设两个平台的子账号，使用子账号可以玩游戏、访问论坛、登陆开发插件，访问开发者论坛。")])]),_vm._v(" "),_c('dl',{staticClass:"qa"},[_c('dt',{staticClass:"ask"},[_vm._v("问：为什么插件的很多操作会要求登陆？")]),_vm._v(" "),_c('dd',{staticClass:"answer"},[_vm._v("答：为了账号的安全性，需要登陆才可以使用。")])]),_vm._v(" "),_c('dl',{staticClass:"qa"},[_c('dt',{staticClass:"ask"},[_vm._v("问：多个人一起开发怎么办？")]),_vm._v(" "),_c('dd',{staticClass:"answer"},[_vm._v("答：多人使用同一账号，维护同一个内容，请保证您分享的账号的安全性。")])]),_vm._v(" "),_c('dl',{staticClass:"qa"},[_c('dt',{staticClass:"ask"},[_vm._v("问：创建的地图，想删除怎么办？")]),_vm._v(" "),_c('dd',{staticClass:"answer"},[_vm._v("答：暂时不支持删除地图，后续会考虑支持。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KuXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('v-login-info'),_vm._v(" "),_c('div',{staticClass:"home-content"},[_c('div',{staticClass:"development"},[_c('div',{staticClass:"title"},[_vm._m(0),_vm._v(" "),(!_vm.isDevStatus)?_c('div',{staticClass:"right clearfix"},[_c('a',{staticClass:"item more",attrs:{"href":"http://sm.yingxiong.com/special/kun-plan.html","target":"_blank"}},[_vm._v("了解更多")]),_vm._v(" "),(_vm.applyStatus)?_c('router-link',{staticClass:"item apply-developer",attrs:{"to":"/developerAgreement"}},[_vm._v("申请成为开发者")]):_vm._e(),_vm._v(" "),(!_vm.applyStatus)?_c('router-link',{staticClass:"apply-developer item examine",attrs:{"to":"/developerStatus"}},[_vm._v("审核中")]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"list clearfix",class:_vm.isDevStatus ? 'active' : 'no-developer'},[_c('li',{staticClass:"item"},[(_vm.isDevStatus)?[_c('router-link',{staticClass:"btn",attrs:{"to":"/downloadPlugin","target":_vm.pcFlag}},[_vm._v("下载开发插件")])]:[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"}},[_vm._v("下载开发插件")])]],2),_vm._v(" "),_c('li',{staticClass:"item"},[(_vm.isDevStatus)?[_c('a',{staticClass:"btn",attrs:{"href":"http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Doc/%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3.rar"}},[_vm._v("开发文档")])]:[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"}},[_vm._v("开发文档")])]],2),_vm._v(" "),_c('li',{staticClass:"item"},[_c('router-link',{staticClass:"btn",attrs:{"to":_vm.isDevStatus ? '/faq' : ''}},[_vm._v("FAQ")])],1),_vm._v(" "),_c('li',{staticClass:"item"},[(_vm.isDevStatus)?[_c('a',{staticClass:"btn",attrs:{"href":"http://forumsm.yingxiong.com","target":_vm.pcFlag}},[_vm._v("开发者论坛")])]:[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"}},[_vm._v("开发者论坛")])]],2)]),_vm._v(" "),_c('div',{staticClass:"mod-box"},[_c('router-link',{staticClass:"btn map",class:!_vm.isDevStatus ? 'no-developer' : '',attrs:{"to":_vm.isDevStatus ? '/home/mapMod' : ''}},[_vm._v("我的地图MOD")]),_vm._v(" "),_c('router-link',{staticClass:"btn server",class:!_vm.isDevStatus ? 'no-developer' : '',attrs:{"to":_vm.isDevStatus ? '/home/selfMod' : ''}},[_vm._v("我的私服MOD")])],1),_vm._v(" "),_c('keep-alive',[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDevStatus),expression:"isDevStatus"}],attrs:{"mapInfo":_vm.mapInfo}})],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isDevStatus),expression:"!isDevStatus"}],staticClass:"no-map-mod"},[_vm._v("\n        申请成为开发者后，您将可以下载创造与魔法的开发工具包，开发您专属的MOD玩法，开发者可获得MOD服务器全部收入55%的分成~\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"self-server"},[_c('div',{staticClass:"title"},[_vm._m(1),_vm._v(" "),(!_vm.isCreateServer)?_c('div',{staticClass:"right clearfix"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCreateServer),expression:"!isCreateServer"}],staticClass:"item apply-developer",attrs:{"to":"/createServer"}},[_vm._v("我要建服")])],1):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"list clearfix",class:_vm.isCreateServer ? 'active' : 'no-developer'},[_c('li',{staticClass:"item"},[_c('router-link',{staticClass:"btn",attrs:{"to":_vm.isCreateServer ? '/serverManage' : ''}},[_vm._v("私服管理")])],1),_vm._v(" "),_c('li',{staticClass:"item"}),_vm._v(" "),_c('li',{staticClass:"item"}),_vm._v(" "),_c('li',{staticClass:"item"})])])]),_vm._v(" "),_c('v-basic-mask',{attrs:{"show":_vm.tipsShow},on:{"closeMaskEv":_vm.closeMaskEvFn}},[_c('div',{attrs:{"slot":"desc"},slot:"desc"},[_c('h3',{staticClass:"title"},[_vm._v("公告")]),_vm._v(" "),_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.noticeText))])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left clearfix"},[_c('span',{staticClass:"text"},[_vm._v("开发")]),_vm._v(" "),_c('i',{staticClass:"icon icon-development"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('span',{staticClass:"text"},[_vm._v("私服")]),_vm._v(" "),_c('i',{staticClass:"icon icon-self-server"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L+BW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rootDoc_vue__ = __webpack_require__("NK+o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eb5770a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rootDoc_vue__ = __webpack_require__("3JVv");
function injectStyle (ssrContext) {
  __webpack_require__("2NpF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rootDoc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9eb5770a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rootDoc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L4vx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/demo-image.a72b71e.png";

/***/ }),

/***/ "L9UR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LebW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pluginFaq_vue__ = __webpack_require__("xPYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03487356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pluginFaq_vue__ = __webpack_require__("KSet");
function injectStyle (ssrContext) {
  __webpack_require__("MSPi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pluginFaq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03487356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pluginFaq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LiqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"self-mod"},[_c('p',{staticClass:"self-mod-desc"},[_vm._v("私服MOD正在研发中，敬请期待。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lsvt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-box"},[_c('input',{staticClass:"check-input",attrs:{"name":_vm.rName,"id":_vm.rId,"type":"checkbox"}}),_vm._v(" "),_c('label',{staticClass:"label-btn",attrs:{"for":_vm.rId},on:{"click":_vm.toggleFn}},[_c('i',{staticClass:"icon",class:_vm.checkboxFlag ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked'})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ded75700_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("KO5b");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ded75700_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MSPi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Miij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mapInfo-imperfect"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"apply-result"},[_vm._v("审核信息待完善")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',{staticClass:"examine-desc"},[_vm._v("您的地图MOD："+_vm._s(_vm.mapName)+" 需要完善一些信息，您的本次审核暂未通过，请继续完善。")]),_vm._v(" "),_c('p',{staticClass:"examine-content"},[_vm._v("\n      拒绝原因："),_c('br'),_vm._v("\n      "+_vm._s(_vm.errorInfo || '没有填写')+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('router-link',{staticClass:"item re-submit",attrs:{"to":{ name: 'devMapinspect', params: {mapId: _vm.mapId, stage: _vm.stage} }}},[_vm._v("重新提交")]),_vm._v(" "),_c('router-link',{staticClass:"item go-home",attrs:{"to":"/home"}},[_vm._v("返回开发者首页")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"head"},[_c('i',{staticClass:"icon-notice"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_stylus_index_styl__ = __webpack_require__("+rhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_index_js__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__down_index_js__ = __webpack_require__("6+6Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_VeeValidate_index__ = __webpack_require__("8B1J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lib_vueInfiniteScroll_index__ = __webpack_require__("9yIw");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 引入 vue

// 引入 app 组件

// 引入路由

// 引入基本样式及字体图标

// 引用API文件

// 引入下载地址

// 引入 vuex
// import store from './store/index'
// 表单验证插件

// 分页插件


// 将API方法绑定到全局
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$api = __WEBPACK_IMPORTED_MODULE_4__api_index_js__["a" /* default */];
// 将下载地址绑定到全局
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$down = __WEBPACK_IMPORTED_MODULE_5__down_index_js__["a" /* default */];

// 关闭生产模式调试信息
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */],
  // store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NK+o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rootDoc'
});

/***/ }),

/***/ "O2JA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OZfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_serverManage_vue__ = __webpack_require__("U3Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7071f1cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_serverManage_vue__ = __webpack_require__("TACh");
function injectStyle (ssrContext) {
  __webpack_require__("srZ8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_serverManage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7071f1cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_serverManage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PBgz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/19.be0e532.png";

/***/ }),

/***/ "PQE7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"test-mapinspect"},[_c('v-login-info'),_vm._v(" "),_c('div',{staticClass:"form-content"},[_c('h1',{staticClass:"map-title"},[_vm._v("地图MOD正式区审核")]),_vm._v(" "),_c('form',{attrs:{"action":"javascript: void(0)"}},[_c('dl',{staticClass:"form-box"},[_c('dt',{staticClass:"title"},[_vm._v("地图ID：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_vm._v(_vm._s(_vm.mapInfo.MapId))])]),_vm._v(" "),_c('dl',{staticClass:"form-box"},[_c('dt',{staticClass:"title"},[_vm._v("地图名字：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapName),expression:"mapName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"map-name",attrs:{"name":"mapName","type":"text"},domProps:{"value":(_vm.mapName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mapName=$event.target.value}}})])]),_vm._v(" "),_c('dl',{staticClass:"form-box form-box-tag clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏标签：")]),_vm._v(" "),_c('dd',{staticClass:"tag-content clearfix"},[_c('ul',{staticClass:"tag-list-box"},_vm._l((_vm.tags),function(item,index){return _c('li',{staticClass:"tag"},[_vm._v("\n              "+_vm._s(item)+"\n              "),_c('a',{staticClass:"close-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delTagFn(index)}}},[_c('i',{staticClass:"icon-close"})])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tagAddFlag),expression:"tagAddFlag"}],staticClass:"add-tag-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tagVal),expression:"tagVal"}],ref:"addTagInput",staticClass:"add-tag-input",attrs:{"type":"text","maxlength":"3"},domProps:{"value":(_vm.tagVal)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.addTagFn($event)},"input":function($event){if($event.target.composing){ return; }_vm.tagVal=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"add-tag-btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.addTagFn}},[_vm._v("添加")])]),_vm._v(" "),_c('p',{staticClass:"tag-desc"},[_vm._v("可以填写最多三个标签，每个标签3个字")])])]),_vm._v(" "),_c('dl',{staticClass:"form-box game-desc clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏介绍：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapDesc),expression:"mapDesc"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"desc",attrs:{"name":"gameDesc","maxlength":"500"},domProps:{"value":(_vm.mapDesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mapDesc=$event.target.value}}},[_vm._v("游戏介绍")])])]),_vm._v(" "),_c('dl',{staticClass:"form-box game-desc clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("更细内容：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapUpdate),expression:"mapUpdate"}],staticClass:"desc",attrs:{"name":"contentUpdate","maxlength":"300"},domProps:{"value":(_vm.mapUpdate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mapUpdate=$event.target.value}}},[_vm._v("更细介绍")])])]),_vm._v(" "),_c('p',{staticClass:"main-ganme-desc"},[_c('span',[_vm._v("游戏主图：")]),_vm._v("\n        请上传1张截图支持JPG格式。截图尺寸要求：必须为306*172，单张图片不能超过1M。\n        "),_c('a',{staticClass:"demo",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.demo1Fn}},[_vm._v("\n          查看示例\n          "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.demoFlag1),expression:"demoFlag1"}],staticClass:"demo-image1",attrs:{"src":__webpack_require__("4OdC"),"alt":"示例"}})])]),_vm._v(" "),_c('div',{staticClass:"game-pic"},[_c('ul',{staticClass:"pic-list-box pic-list1 clearfix"},[_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 0)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[0].picture ? _vm.picList[0].picture : _vm.defaultPic,"alt":"上传主图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[0].picture),expression:"!picList[0].picture"}],staticClass:"upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":306,"maxHeight":172,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"imageuploading":_vm.imageuploading,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[0].picture),expression:"picList[0].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(0)}}},[_vm._v("删除图片")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageLoadingFlag),expression:"imageLoadingFlag"}],staticClass:"upload-image-loading"},[_c('img',{staticClass:"loading-svg",attrs:{"src":"/static/loading/loading-spinning-bubbles.svg","alt":"加载中"}})])],1)]),_vm._v(" "),_c('li',{staticClass:"item"}),_vm._v(" "),_c('li',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"pic-list"},[_c('p',{staticClass:"pic-desc"},[_vm._v("游戏截图：请上传3—5张截图。")]),_vm._v(" "),_c('p',{staticClass:"pic-desc pic-demo-box"},[_c('span',[_vm._v("截请上传3-5张截图支持JPG格式。截图尺寸要求：必须为800*450，单张图片不能超过1M。")]),_vm._v(" "),_c('a',{staticClass:"demo",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.demo2Fn}},[_vm._v("\n              查看示例\n              "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.demoFlag2),expression:"demoFlag2"}],staticClass:"demo-image2",attrs:{"src":__webpack_require__("4OdC"),"alt":"示例"}})])]),_vm._v(" "),_c('ul',{staticClass:"pic-list-box pic-list1 clearfix"},[_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 1)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[1].picture ? _vm.picList[1].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[1].picture),expression:"!picList[1].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[1].picture),expression:"picList[1].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(1)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 2)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[2].picture ? _vm.picList[2].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[2].picture),expression:"!picList[2].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[2].picture),expression:"picList[2].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(2)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 3)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[3].picture ? _vm.picList[3].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[3].picture),expression:"!picList[3].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[3].picture),expression:"picList[3].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(3)}}},[_vm._v("删除图片")])],1)])]),_vm._v(" "),_c('ul',{staticClass:"pic-list-box pic-list2 clearfix"},[_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 4)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[4].picture ? _vm.picList[4].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[4].picture),expression:"!picList[4].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[4].picture),expression:"picList[4].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(4)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 5)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[5].picture ? _vm.picList[5].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[5].picture),expression:"!picList[5].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[5].picture),expression:"picList[5].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(5)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item"})])])]),_vm._v(" "),_c('p',{staticClass:"on-line-info"},[_vm._v("\n        您的测试区版本上线日期：2017-10-31  1:00:00\n        "),_c('span',[_vm._v("版本号："+_vm._s(_vm.mapVersion))])]),_vm._v(" "),_c('p',{staticClass:"errot-desc"},[_vm._v(_vm._s(_vm.formErrot))]),_vm._v(" "),_c('div',{staticClass:"submit-examine"},[_c('a',{staticClass:"submit-examine-btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.mapSubexamine}},[_vm._v("提交审核")])])])]),_vm._v(" "),_c('v-basic-mask',{ref:"basicMask",attrs:{"show":_vm.maskFlag},on:{"closeMaskEv":_vm.closeMaskFn}},[_c('span',{attrs:{"slot":"desc"},slot:"desc"},[_vm._v(_vm._s(_vm.uploadPicTps))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QAId":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qfng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_resize_bar_vue__ = __webpack_require__("A9Xz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5028424f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_resize_bar_vue__ = __webpack_require__("0kXI");
function injectStyle (ssrContext) {
  __webpack_require__("SafL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5028424f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_resize_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5028424f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_resize_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RysO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"map-mod"},[(_vm.mapInfo.length)?[_c('ul',{staticClass:"map-list-box"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.mapInfo),function(item){return _c('li',{staticClass:"map-list-item"},[_c('dl',{staticClass:"map-info-dl clearfix"},[_c('dt',{staticClass:"mid"},[_vm._v(_vm._s(item.MapId))]),_vm._v(" "),_c('dd',{staticClass:"name item"},[(item.PubInfo)?[_c('router-link',{attrs:{"to":{ name: 'mapShowStatus', params: {mapId: item.MapId, stage: 'pub'} }}},[_vm._v("\n                  "+_vm._s(item.MapName)+"\n                ")])]:(item.ExaInfo)?[_c('router-link',{attrs:{"to":{ name: 'mapShowStatus', params: {mapId: item.MapId, stage: 'exa'} }}},[_vm._v("\n                  "+_vm._s(item.MapName)+"\n                ")])]:(item.DevInfo)?[_c('span',{attrs:{"href":"javascript: void(0)"}},[_vm._v(_vm._s(item.MapName))])]:[_vm._v("\n                "+_vm._s(item.MapName)+"\n              ")]],2),_vm._v(" "),_c('dd',{staticClass:"version item"},[(item.DevInfo)?[_c('span',{staticClass:"ver-num"},[_vm._v(_vm._s(item.DevInfo.MapVersion))]),_vm._v(" "),(item.DevInfo.Status === 0)?_c('span',[_vm._v("未提交")]):_vm._e(),_vm._v(" "),(item.DevInfo.Status === 1)?_c('router-link',{attrs:{"to":{ name: 'devMapinspect', params: {mapId: item.MapId, stage: 'dev'} }}},[_c('span',{staticClass:"text base-examine"},[_vm._v("提交审核")])]):_vm._e(),_vm._v(" "),(item.DevInfo.Status === 2)?_c('router-link',{attrs:{"to":{ name: 'toExamine', params: {mapId: item.MapId, stage: 'dev'} }}},[_c('span',{staticClass:"text base-examine"},[_vm._v("审核中")])]):_vm._e(),_vm._v(" "),(item.DevInfo.Status === 3)?_c('router-link',{staticClass:"examine-rewrite",attrs:{"to":{ name: 'mapInfoImperfect', params: {mapId: item.MapId, stage: 'dev'} }}},[_c('i',{staticClass:"icon icon-examine-rewrite"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("请重新填写")])]):_vm._e(),_vm._v(" "),(item.DevInfo.Status === 4)?_c('router-link',{staticClass:"examine-fail",attrs:{"to":{ name: 'examineFail', params: {mapId: item.MapId, stage: 'dev'} }}},[_c('i',{staticClass:"icon icon-examine-fail"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("审核失败")])]):_vm._e(),_vm._v(" "),(item.DevInfo.Status === 5)?_c('span',[_vm._v("已删除")]):_vm._e(),_vm._v(" "),(item.DevInfo.Status === 6)?_c('span',{staticClass:"examine-success"},[_c('i',{staticClass:"icon icon-examine-success"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("审核通过")])]):_vm._e()]:[_c('span',[_vm._v("无")])]],2),_vm._v(" "),_c('dd',{staticClass:"test-number item"},[(item.ExaInfo)?[_c('span',{staticClass:"ver-num"},[_vm._v(_vm._s(item.ExaInfo.MapVersion))]),_vm._v(" "),(item.ExaInfo.Status === 0)?_c('span',[_vm._v("未提交")]):_vm._e(),_vm._v(" "),(item.ExaInfo.Status === 1)?_c('router-link',{attrs:{"to":{ name: 'devMapinspect', params: {mapId: item.MapId, stage: 'exa'} }}}):_vm._e(),_vm._v(" "),(item.ExaInfo.Status === 2)?_c('router-link',{attrs:{"to":{ name: 'toExamine', params: {mapId: item.MapId, stage: 'exa'} }}},[_c('span',{staticClass:"text base-examine"},[_vm._v("审核中")])]):_vm._e(),_vm._v(" "),(item.ExaInfo.Status === 3)?_c('router-link',{staticClass:"examine-rewrite",attrs:{"to":{ name: 'mapInfoImperfect', params: {mapId: item.MapId, stage: 'exa'} }}},[_c('i',{staticClass:"icon icon-examine-rewrite"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("请重新填写")])]):_vm._e(),_vm._v(" "),(item.ExaInfo.Status === 4)?_c('router-link',{staticClass:"examine-fail",attrs:{"to":{ name: 'examineFail', params: {mapId: item.MapId, stage: 'exa'} }}},[_c('i',{staticClass:"icon icon-examine-fail"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("审核失败")])]):_vm._e(),_vm._v(" "),(item.ExaInfo.Status === 5)?_c('span',[_vm._v("已删除")]):_vm._e(),_vm._v(" "),(item.ExaInfo.Status === 6)?_c('span',{staticClass:"examine-success"},[_c('i',{staticClass:"icon icon-examine-success"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("审核通过")])]):_vm._e()]:[_c('span',[_vm._v("无")])]],2),_vm._v(" "),_vm._m(1,true)])])})],2)]:[_c('p',{staticClass:"no-map-desc"},[_vm._v("\n        您还没有地图MOD，地图MOD通过《创造与魔法》开发插件制作，上传后在这里进行测试区的线上操作，玩家就可以玩到你的呢地图MOD了\n        "),_c('router-link',{staticClass:"server-manage-btn",attrs:{"to":"/downloadPlugin","target":"_blank"}},[_vm._v("下载插件")])],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"map-list-title"},[_c('dl',{staticClass:"map-info-dl clearfix"},[_c('dt',{staticClass:"mid"},[_vm._v("ID")]),_vm._v(" "),_c('dd',{staticClass:"name item"},[_vm._v("名称")]),_vm._v(" "),_c('dd',{staticClass:"version item"},[_vm._v("审核中版本号")]),_vm._v(" "),_c('dd',{staticClass:"test-number item"},[_vm._v("已发布版本号(测试区)")]),_vm._v(" "),_c('dd',{staticClass:"formal-number item"},[_vm._v("已发布版本号(正式区)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dd',{staticClass:"formal-number item"},[_c('span',[_vm._v("无")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S/MZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.d2771da.png";

/***/ }),

/***/ "S0ej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"to-examine"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"apply-result"},[_vm._v("审核中")]),_vm._v(" "),_c('p',{staticClass:"to-examine-desc"},[_vm._v("您的地图MOD已经在审核中，请耐心等待审核结果，审核通过将会邮件通知您")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('ul',{staticClass:"step-list clearfix"},_vm._l((_vm.stepList),function(item,index){return _c('li',{staticClass:"item",class:_vm.mapStatus > index ? 'active' : ''},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(item))])])}))]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('router-link',{staticClass:"go-home item",attrs:{"to":"/home"}},[_vm._v("返回开发者首页")]),_vm._v(" "),_c('a',{staticClass:"revoke item",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.revokeFn}},[_vm._v("撤销审核")])],1),_vm._v(" "),_c('div',{staticClass:"confirm-mask-wrap",attrs:{"onselectstart":"return false"}},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"confirm-mask"},[_c('div',{ref:"confirmMaskContent",staticClass:"confirm-mask-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.revokeFlag),expression:"!revokeFlag"}]},[_c('p',{staticClass:"desc"},[_vm._v("您将撤销您的审核，请确认您的操作")]),_vm._v(" "),_c('div',{staticClass:"btn-wrap"},[_c('a',{staticClass:"btn cancel",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.closeMaskFn}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"btn revoke",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.revokeConfirmFn}},[_vm._v("撤销审核")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.revokeFlag),expression:"revokeFlag"}]},[_c('p',{staticClass:"desc"},[_vm._v("撤销成功，"+_vm._s(_vm.num)+" s 后返回开发者首页")]),_vm._v(" "),_c('div',{staticClass:"btn-wrap"},[_c('a',{staticClass:"btn cancel",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.goHomeFn}},[_vm._v("确定")])])])])])])],1),_vm._v(" "),_c('v-basic-mask',{attrs:{"show":_vm.tipsShow},on:{"closeMaskEv":_vm.closeMaskEvFn}},[_c('span',{attrs:{"slot":"desc"},slot:"desc"},[_vm._v(_vm._s(_vm.tipsText))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"head"},[_c('i',{staticClass:"icon-notice"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S7Og":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SFkb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_user__ = __webpack_require__("xKOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_loading_loading__ = __webpack_require__("qqiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_js_ispc__ = __webpack_require__("vH9d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_basicMask_basicMask__ = __webpack_require__("/pyY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作

// loading 加载组件

// 判断客户端来源

// 基础弹出层组件

/* harmony default export */ __webpack_exports__["a"] = ({
  // 开发者首页
  name: 'home',
  data: function data() {
    return {
      // load 标志
      // loadFlag: false,
      // 开发者地图列表
      mapInfo: '',
      // 是否是开发者
      isDeveloper: '',
      // 获取用户名
      userNmae: __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('UserName'),
      // 错误信息
      errorTips: '',
      // 是否创建过私服
      isCreateServer: false,
      // 提示层开关
      tipsShow: false,
      // 提示信息
      tipsText: '',
      // 公告信息
      noticeText: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('SessionID')
      }
    };
  },
  created: function created() {
    // 初始化
    this.init();
  },

  /*
  mounted () {
    // axios 前置拦截器
    Axios.interceptors.request.use(config => {
      // 显示 loading 提示层
      this.loadFlag = true
      return config
    })
    // axios 后置拦截器
    Axios.interceptors.response.use(response => {
      // 关闭 loading 提示层
      this.loadFlag = false
      return response
    })
  },
  */
  computed: {
    isDevStatus: function isDevStatus() {
      // 是开发者
      if (this.isDeveloper >= 1) {
        return true;
        // 不是开发者
      } else {
        return false;
      }
    },

    // 是否申请开发者
    applyStatus: function applyStatus() {
      switch (this.isDeveloper) {
        // 没有申请开发者
        case -1:
          return true;
        // 申请开发者审核中
        case 0:
          return false;
        default:
          return false;
      }
    },

    // 是否是PC
    pcFlag: function pcFlag() {
      if (Object(__WEBPACK_IMPORTED_MODULE_5_assets_js_ispc__["a" /* isPc */])()) {
        return '_blank';
      } else {
        return '_self';
      }
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户id添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将session id 添加到表单
      formData.append('SessionID', this.formDatas.sessionId);

      // 是否是开发者 api
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$api.root + '/Developer/IsDeveloper', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            // 请求成功
            case 0:
              // 获取当前开发者状态
              _this.isDeveloper = res.UserType;
              // 如果公开内容不为空
              if (res.Notice) {
                // 公告信息进行赋值
                _this.noticeText = res.Notice;
                // DOM加载完毕后显示遮罩层
                _this.$nextTick(function () {
                  _this.tipsShow = true;
                });
              }
              // 是开发者
              if (res.UserType === 1) {
                // 请求开发者地图 MOD 列表
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_this.$api.root + '/Developer/GetMapList', formData, {
                  // 设置请求为表单提交
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                }).then(function (response) {
                  // http 请求成功
                  if (response.status === 200) {
                    // 获取接口数据
                    var _res = response.data;
                    switch (_res.Code) {
                      case 0:
                        _this.mapInfo = _res.MapList;
                        break;
                      case 1:
                        // 删除登录信息
                        Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
                        _this.$router.push({ name: 'login' });
                        break;
                      default:
                        console.log(_res.Msg);
                    }
                  }
                }).catch(function (error) {
                  console.log(error);
                });
              }
              break;
            // 登录信息失效，删除登录信息跳转到登录页
            case 1:
              Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
              _this.$router.push({ name: 'login' });
              break;
            case 2:
              // 登录失败，将失败信息显示到界面
              _this.errorTips = res.Msg;
              break;
            default:
              // 删除用户信息
              Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
              // 跳转到登录页面
              _this.$router.push({ name: 'login' });
          }
        }
        // 请求接口失败
      }).catch(function (error) {
        console.log(error);
      });

      // 请求是否创建过游戏服务器 api
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$api.root + '/PersonalRoom/GetHaveGameServer', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              if (res.HaveGameServer) {
                // 创建过私服
                _this.isCreateServer = true;
              } else {
                // 没有创建过私服
                _this.isCreateServer = false;
              }
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
              _this.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 进入服务器创建页面
    createServerFn: function createServerFn() {
      this.$router.push({ name: 'createServer' });
    },

    // 进入游戏管理页面
    gameManageFn: function gameManageFn() {
      this.$router.push({ name: 'serverManage' });
    },

    // 申请开发者按钮
    applyDevFn: function applyDevFn() {
      // 提示层开关
      this.tipsShow = true;
      // 提示信息
      this.tipsText = '开发者后台暂未开启注册，欢迎加入鲲计划开发群参与互动讨论:546241346';
    },

    // 关闭提示层
    closeMaskEvFn: function closeMaskEvFn(val) {
      // 关闭弹出层
      this.tipsShow = val;
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */],
    'v-loading': __WEBPACK_IMPORTED_MODULE_4_components_loading_loading__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_6_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "SafL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TACh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"serverManage"},[_c('v-login-info'),_vm._v(" "),_c('div',{staticClass:"server-manage-content"},[_c('h3',{staticClass:"server-name"},[_vm._v("服务器名字："+_vm._s(_vm.serverInfo.ServerName))]),_vm._v(" "),_c('div',{staticClass:"server-manage-info"},[_c('p',{staticClass:"server-desc"},[_vm._v("服务器信息")]),_vm._v(" "),_c('ul',{staticClass:"server-info-list"},[_c('li',{staticClass:"list-item"},[_c('span',{staticClass:"text-item"},[_vm._v("服务器SID："+_vm._s(_vm.serverInfo.ServerId))]),_vm._v(" "),_c('span',{staticClass:"text-item"},[_vm._v("服务器状态："+_vm._s(_vm.serverInfo.ServerStatus))])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('span',{staticClass:"text-item"},[_vm._v("服务器模式："+_vm._s(_vm.modTypeText))]),_vm._v(" "),_c('span',{staticClass:"text-item"},[_vm._v("服务器套餐："+_vm._s(_vm.serverInfo.ServerType))])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('span',{staticClass:"text-item"},[_vm._v("服务器密码："+_vm._s(_vm.serverInfo.PassWord ? _vm.serverInfo.PassWord : '无'))]),_vm._v(" "),_c('span',{staticClass:"text-item"},[_vm._v("是否公开："+_vm._s(_vm.serverInfo.IsShow ? '是' : '否'))])])]),_vm._v(" "),_c('p',{staticClass:"operate-info"},[_vm._v("运营数据")]),_vm._v(" "),_c('ul',{staticClass:"operate-info-list"},[_c('li',{staticClass:"list-item"},[_c('span',{staticClass:"text-item operate-item"},[_vm._v("开放截止时间："+_vm._s(_vm.serverInfo.EndTime))]),_vm._v(" "),_c('span',{staticClass:"text-item"},[_vm._v("在线人数："+_vm._s(_vm.serverInfo.PlayerNum)+"/"+_vm._s(_vm.serverInfo.MaxPlayerNum))])])]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('a',{staticClass:"btn-item",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.setupFn}},[_vm._v("设置")]),_vm._v(" "),_c('a',{staticClass:"btn-item",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.expandFn}},[_vm._v(_vm._s(_vm.expandBtnText))]),_vm._v(" "),_c('a',{staticClass:"btn-item",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.renewFn}},[_vm._v("续费")]),_vm._v(" "),_c('a',{staticClass:"btn-item",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.blackFn}},[_vm._v("黑名单")])])])]),_vm._v(" "),_c('div',{staticClass:"handle-mask-wrap",attrs:{"onselectstart":"return false"}},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"confirm-mask"},[_c('div',{ref:"confirmMaskContent",staticClass:"confirm-mask-content"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.setupFlag),expression:"setupFlag"}],staticClass:"self-server-setup",attrs:{"action":"javascript: void(0)"}},[_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"item-title"},[_vm._v("密码设置：")]),_vm._v(" "),_c('dd',{staticClass:"item-content"},[_c('div',{staticClass:"radio-item"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isServerPwd),expression:"isServerPwd"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"noPwd","name":"pwd","type":"radio","value":"false"},domProps:{"checked":_vm._q(_vm.isServerPwd,"false")},on:{"change":function($event){_vm.isServerPwd="false"}}}),_vm._v(" "),_c('label',{staticClass:"icon-box",attrs:{"for":"noPwd"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("无密码")])]),_vm._v(" "),_c('div',{staticClass:"radio-item"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isServerPwd),expression:"isServerPwd"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"hasPwd","name":"pwd","type":"radio","value":"true"},domProps:{"checked":_vm._q(_vm.isServerPwd,"true")},on:{"change":function($event){_vm.isServerPwd="true"}}}),_vm._v(" "),_c('label',{staticClass:"icon-box",attrs:{"for":"hasPwd"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("有密码")]),_vm._v(" "),_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serverPwd),expression:"serverPwd"}],staticClass:"server-pwd",attrs:{"type":"password"},domProps:{"value":(_vm.serverPwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.serverPwd=$event.target.value}}})])])])]),_vm._v(" "),_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"item-title"},[_vm._v("公开房间列表：")]),_vm._v(" "),_c('dd',{staticClass:"item-content"},[_c('div',{staticClass:"radio-item radio-inline"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPublic),expression:"isPublic"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"pub","name":"rootList","type":"radio","value":"true"},domProps:{"checked":_vm._q(_vm.isPublic,"true")},on:{"change":function($event){_vm.isPublic="true"}}}),_vm._v(" "),_c('label',{staticClass:"icon-box",attrs:{"for":"pub"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("公开")])]),_vm._v(" "),_c('div',{staticClass:"radio-item radio-inline"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPublic),expression:"isPublic"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"noPub","name":"rootList","type":"radio","value":"false"},domProps:{"checked":_vm._q(_vm.isPublic,"false")},on:{"change":function($event){_vm.isPublic="false"}}}),_vm._v(" "),_c('label',{staticClass:"icon-box",attrs:{"for":"noPub"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("不公开")])])])]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.setupCancelFn}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"btn sub",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.setupSaveFn}},[_vm._v("提交")])])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag),expression:"expandFlag"}],staticClass:"expand",attrs:{"action":"javascript: void(0)"}},[_c('h3',{staticClass:"expand-title"},[_vm._v("服务器切换")]),_vm._v(" "),_c('p',{staticClass:"expand-desc"},[_vm._v("切换后，10天内不得在进行次操作")]),_vm._v(" "),_c('ul',{staticClass:"expand-list clearfix"},_vm._l((_vm.expandListSort),function(item,index){return _c('li',{staticClass:"li-item clearfix"},[_c('div',{staticClass:"item",class:{ active : item.id === _vm.expandInfo.ServerType },attrs:{"href":"javascript: void(0)"}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("最多同时在线"+_vm._s(item.player)+"人")])])])})),_vm._v(" "),_c('ul',{staticClass:"expand-info-list"},[_c('li',{staticClass:"item"},[_vm._v("上次操作时间 "+_vm._s(_vm.expandInfo.OprateTime))]),_vm._v(" "),_c('li',{staticClass:"item"},[_vm._v("当前剩余时间 "+_vm._s(_vm.expandInfo.DaysRemaining)+" 天")]),_vm._v(" "),_c('li',{staticClass:"item"},[_vm._v("切换后剩余时间 "+_vm._s(_vm.expandToggleTime)+" 天")])]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.expandCancelFn}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"btn",class:_vm.expandInfo.CanEnlarge ? 'active' : '',attrs:{"href":"javascript: void(0)"},on:{"click":_vm.expandToggleFn}},[_vm._v("切换")])])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.renewFlag),expression:"renewFlag"}],staticClass:"renew",attrs:{"action":"javascript: void(0)"}},[_c('h3',{staticClass:"renew-title"},[_vm._v("服务器续费")]),_vm._v(" "),_c('div',{staticClass:"ticket-info"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.countTicket(3)),expression:"countTicket(3)"}],staticClass:"ticket-info-item"},[_vm._v("小型服务器3个月续费券 "+_vm._s(_vm.countTicket(3))+" 张")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.countTicket(4)),expression:"countTicket(4)"}],staticClass:"ticket-info-item"},[_vm._v("小型服务器6个月续费券 "+_vm._s(_vm.countTicket(4))+" 张")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.countTicket(5)),expression:"countTicket(5)"}],staticClass:"ticket-info-item"},[_vm._v("中型服务器3个月续费券 "+_vm._s(_vm.countTicket(5))+" 张")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.countTicket(6)),expression:"countTicket(6)"}],staticClass:"ticket-info-item"},[_vm._v("中型服务器6个月续费券 "+_vm._s(_vm.countTicket(6))+" 张")])]),_vm._v(" "),_c('h3',{staticClass:"ticket-list-title"},[_vm._v("续费卷")]),_vm._v(" "),_c('ul',{staticClass:"ticket-list"},_vm._l((_vm.ticketList),function(item,index){return _c('li',{staticClass:"item clearfix"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ticketId),expression:"ticketId"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":("item" + index),"name":"pwd","type":"radio"},domProps:{"value":item.Id,"checked":_vm._q(_vm.ticketId,item.Id)},on:{"change":function($event){_vm.ticketId=item.Id}}}),_vm._v(" "),_c('label',{staticClass:"icon-box",attrs:{"for":("item" + index)}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.ticketInfo[item.Type].name))])])})),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.renewCancelFn}},[_vm._v("取消")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.ticketList.length),expression:"ticketList.length"}],staticClass:"btn sub",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.renewSubFn}},[_vm._v("提交")])])]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.blackFlag),expression:"blackFlag"}],staticClass:"black-menu",attrs:{"action":"javascript: void(0)"}},[_c('h3',{staticClass:"black-title clearfix"},[_c('span',{staticClass:"left"},[_vm._v("添加黑名单")]),_vm._v(" "),_c('a',{staticClass:"right",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.blackCancelFn}},[_c('i',{staticClass:" icon icon-cancel-circle"})])]),_vm._v(" "),_c('div',{staticClass:"conent"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchName),expression:"searchName"}],staticClass:"black-input",attrs:{"name":"black","type":"text","value":"searchName"},domProps:{"value":(_vm.searchName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchName=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"black-search",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.blackSearchFn}},[_vm._v("查询")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInfo),expression:"searchInfo"}],staticClass:"black-list"},[_c('div',{staticClass:"list-item"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.searchInfo.RoleName))]),_vm._v(" "),_c('span',{staticClass:"content"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.addBlackFn(_vm.searchInfo.Id)}}},[_vm._v("添加")])])])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.blackList.length),expression:"blackList.length"}],staticClass:"black-list"},[_c('li',{staticClass:"list-item"},[_c('span',{staticClass:"title"},[_vm._v("角色名")]),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v("操作")])]),_vm._v(" "),_vm._l((_vm.blackList),function(item,index){return _c('li',{staticClass:"list-item"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item.RoleName))]),_vm._v(" "),_c('span',{staticClass:"content"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delBlackFn(item.Id, index)}}},[_vm._v("删除")])])])})],2)])])])])],1),_vm._v(" "),_c('div',{staticClass:"confirm-mask-wrap",attrs:{"onselectstart":"return false"}},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirmFlag),expression:"confirmFlag"}],staticClass:"confirm-mask"},[_c('div',{ref:"confirmMaskContent",staticClass:"confirm-mask-content"},[_c('p',{staticClass:"desc"},[_vm._v("请确认您的操作")]),_vm._v(" "),_c('div',{staticClass:"btn-wrap"},[_c('a',{staticClass:"btn cancel",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.closeMaskFn}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"btn revoke",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.delBlackConfirmFn}},[_vm._v("删除")])])])])])],1),_vm._v(" "),_c('v-basic-mask',{attrs:{"show":_vm.tipsShow},on:{"closeMaskEv":_vm.closeMaskEvFn}},[_c('span',{attrs:{"slot":"desc"},slot:"desc"},[_vm._v(_vm._s(_vm.tipsText))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TT/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // 私服MOD
  name: 'selfMod'
});

/***/ }),

/***/ "Tlxa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"developerInfo"},[_c('v-developer-header'),_vm._v(" "),_c('div',{staticClass:"developer-info-content"},[_c('div',{staticClass:"form-content"},[_c('form',{staticClass:"form-controll",attrs:{"action":"javascript: void(0)"},on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit($event)}}},[_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("您的姓名：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.userName),expression:"formDatas.userName"},{name:"validate",rawName:"v-validate",value:('required|max:20'),expression:"'required|max:20'"}],attrs:{"name":"user","type":"text","placeholder":"您的姓名"},domProps:{"value":(_vm.formDatas.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formDatas, "userName", $event.target.value)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('user')),expression:"errors.has('user')"}],staticClass:"form-tips form-error-tips"},[_c('i',{staticClass:"icon"}),_vm._v(" "),_c('i',{staticClass:"icon-error-tips"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.errors.first('user')))])])])]),_vm._v(" "),_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("您的邮箱：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.email),expression:"formDatas.email"},{name:"validate",rawName:"v-validate",value:('required|email|max:50'),expression:"'required|email|max:50'"}],attrs:{"name":"email","type":"text","placeholder":"Email"},domProps:{"value":(_vm.formDatas.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formDatas, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"form-tips form-error-tips"},[_c('i',{staticClass:"icon"}),_vm._v(" "),_c('i',{staticClass:"icon-error-tips"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.errors.first('email')))])])])]),_vm._v(" "),_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("您的手机号：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.mobile),expression:"formDatas.mobile"},{name:"validate",rawName:"v-validate",value:('required|phone'),expression:"'required|phone'"}],attrs:{"name":"phone","type":"tel","placeholder":"请输入手机号"},domProps:{"value":(_vm.formDatas.mobile)},on:{"focus":function($event){_vm.codeErrorTips = ''},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formDatas, "mobile", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"check-code-box"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.sendCodeshow),expression:"sendCodeshow"}],staticClass:"check-code-btn",attrs:{"href":"javascript: void(0)","disabled":!_vm.sendCodeshow},on:{"click":_vm.getCode}},[_vm._v("发送验证码")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.sendCodeshow),expression:"!sendCodeshow"}],staticClass:"check-code-btn",attrs:{"onselectstart":"return false"}},[_vm._v(_vm._s(_vm.codeTimeCount)+" s 后再次发送")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.codeErrorTips),expression:"codeErrorTips"}],staticClass:"form-tips form-error-tips"},[_c('i',{staticClass:"icon"}),_vm._v(" "),_c('i',{staticClass:"icon-error-tips"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.codeErrorTips))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('phone')),expression:"errors.has('phone')"}],staticClass:"form-tips form-error-tips"},[_c('i',{staticClass:"icon"}),_vm._v(" "),_c('i',{staticClass:"icon-error-tips"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.errors.first('phone')))])])])]),_vm._v(" "),_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("验证码：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.checkCode),expression:"formDatas.checkCode"}],attrs:{"type":"text"},domProps:{"value":(_vm.formDatas.checkCode)},on:{"focus":function($event){_vm.codeFlag = false},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formDatas, "checkCode", $event.target.value)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.codeFlag),expression:"codeFlag"}],staticClass:"form-tips form-error-tips"},[_c('i',{staticClass:"icon"}),_vm._v(" "),_c('i',{staticClass:"icon-error-tips"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.errorTips))])])])])])]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('div',{staticClass:"handle-btn-wrap"},[_c('a',{staticClass:"handle-btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.successFn}},[_vm._v("完成")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U/Gq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_confirmMask_confirmMask__ = __webpack_require__("diup");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_js_user__ = __webpack_require__("xKOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_basicMask_basicMask__ = __webpack_require__("/pyY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ajax 请求插件

// 引入 cookie插件

// 确认弹出层组件

// 用户信息相关操作

// 基础弹出层组件

var stepList = ['地图MOD制作', '测试区审核', '测试区上线', '正式区审核', '正式区上线'];

/* harmony default export */ __webpack_exports__["a"] = ({
  // 审核中页面
  name: 'toExamine',
  data: function data() {
    return {
      // 倒计时计时器
      timer: '',
      // 接口地址
      apiPath: {
        getMapInfo: '',
        revokeApply: ''
      },
      // 倒计时
      num: 3,
      // 地图id
      mapId: this.$route.params.mapId,
      // 地图进行阶段
      stage: this.$route.params.stage,
      // 审核进度 id
      mapStageId: '',
      // 审核进度
      mapStatus: '',
      // 撤销审核是否成功标志
      revokeFlag: false,
      // 进度列表
      stepList: stepList,
      // 遮罩层标记
      show: false,
      // 提示层开关
      tipsShow: false,
      // 提示信息
      tipsText: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('SessionID')
      }
    };
  },
  created: function created() {
    // 初始化数据
    this.init();
  },
  beforeUpdate: function beforeUpdate() {
    var _this2 = this;

    // 遮罩层初始化
    this.$nextTick(function () {
      _this2.maskInit();
    });
  },

  methods: {
    init: function init() {
      var _this3 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图id
      formData.append('MapId', this.mapId);
      // 请求地图详细信息 api
      switch (this.stage) {
        // 设置开发阶段的获取地图信息接口和撤销审核申请接口
        case 'dev':
          this.apiPath.getMapInfo = '/Developer/GetMapDevInfo';
          this.apiPath.revokeApply = '/Developer/RevokeAuditDev';
          break;
        // 设置测试阶段的获取地图信息接口和撤销审核申请接口
        case 'exa':
          this.apiPath.getMapInfo = '/Developer/GetMapExaInfo';
          this.apiPath.revokeApply = '/Developer/RevokeAuditExa';
          break;
        // 设置正式阶段的获取地图信息接口和撤销审核申请接口
        case 'pub':
          this.apiPath.getMapInfo = '/Developer/GetMapPubInfo';
          this.apiPath.revokeApply = '/Developer/RevokeAuditPub';
          break;
        default:
          console.log('开发阶段匹配错误');
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + this.$api.root + this.apiPath.getMapInfo, formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              switch (_this3.stage) {
                case 'dev':
                  // 审核进度 id
                  _this3.mapStageId = res.DevInfo.Id;
                  // 获取地图审核进度
                  _this3.mapStatus = res.DevInfo.Status;
                  break;
                case 'exa':
                  // 审核进度 id
                  _this3.mapStageId = res.ExaInfo.Id;
                  // 获取地图审核进度
                  _this3.mapStatus = res.ExaInfo.Status;
                  break;
                case 'pub':
                  // 审核进度 id
                  _this3.mapStageId = res.PubInfo.Id;
                  // 获取地图审核进度
                  _this3.mapStatus = res.PubInfo.Status;
                  break;
                default:
                  console.log('获取阶段错误');
              }
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
              _this3.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    maskInit: function maskInit() {
      // 获取弹出层内容
      var oConfirmMaskContent = this.$refs.confirmMaskContent;
      // 计算左边边距
      var left = oConfirmMaskContent.offsetWidth / 2;
      // 计算上边边距
      var top = oConfirmMaskContent.offsetHeight / 2;
      // 对边距进行赋值
      oConfirmMaskContent.style.marginLeft = -left + 'px';
      oConfirmMaskContent.style.marginTop = -top + 'px';
    },

    // 关闭遮罩层
    closeMaskFn: function closeMaskFn() {
      this.show = false;
    },

    // 点击撤销审核，弹出弹出层
    revokeFn: function revokeFn() {
      this.show = !this.show;
    },

    // 确认撤销审核
    revokeConfirmFn: function revokeConfirmFn() {
      var _this4 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // // 将审核进度 id 加入表单
      formData.append('MapStageId', this.mapStageId);
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + this.$api.root + this.apiPath.revokeApply, formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 撤销成功，重置标志
              _this4.revokeFlag = true;
              var _this = _this4;
              _this4.timer = setInterval(function () {
                _this.num--;
                if (_this.num === 0) {
                  clearInterval(_this.timer);
                  _this.$router.push({ name: 'login' });
                }
              }, 1000);
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_3_assets_js_user__["a" /* delUserCookie */])();
              // 跳转到登录页
              _this4.$router.push({ name: 'login' });
              break;
            case 2:
              // 弹出提示层
              _this4.tipsShow = true;
              // 弹出提示信息
              _this4.tipsText = res.Msg;
              break;
            default:
              // 弹出提示层
              _this4.tipsShow = true;
              // 弹出提示信息
              _this4.tipsText = res.Msg;
              break;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 撤销审核成功后跳转到个人主页
    goHomeFn: function goHomeFn() {
      // 清空计时器
      clearInterval(this.timer);
      // 跳转到首页
      this.$router.push({ name: 'home' });
    },

    // 关闭提示层
    closeMaskEvFn: function closeMaskEvFn(val) {
      // 关闭弹出层
      this.tipsShow = val;
      // 是否刷新页面
      if (this.refreshFlag) {
        // 重置刷新标志
        this.refreshFlag = false;
        // 刷新页面
        this.$router.go(0);
      }
    }
  },
  components: {
    'v-confirm-mask': __WEBPACK_IMPORTED_MODULE_2_components_confirmMask_confirmMask__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_4_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "U3Pn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_basicMask_basicMask__ = __webpack_require__("/pyY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_js_user__ = __webpack_require__("xKOl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件

// 基础弹出层组件

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作

// 错误信息
var ERROR_TIPS = [{ desc: '查询角色名称不能为空' }, { desc: '删除成功' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  // 服务器管理
  name: 'serverManage',
  data: function data() {
    return {
      // 服务器模式
      modType: '',
      // 要查找的黑名单名字
      searchName: '',
      // 黑名单查询到的信息
      searchInfo: '',
      // 提示层开关
      tipsShow: false,
      // 提示信息
      tipsText: '',
      // 是否刷新页面
      refreshFlag: false,
      // 确认删除弹出层
      confirmFlag: false,
      // 要删除黑名单的id
      delBlackId: '',
      // 要删除黑名单的索引
      delBlackIndex: '',
      // 遮罩层开关
      show: false,
      // 服务器设置开关
      setupFlag: false,
      // 扩容开关
      expandFlag: false,
      // 私服能否扩容信息
      expandInfo: '',
      // 扩容服务器列表
      expandList: [{
        id: 1,
        name: '小型服务器',
        player: 12
      }, {
        id: 2,
        name: '中型服务器',
        player: 24
      }],
      // 续费开关
      renewFlag: false,
      // 续费卷列表
      ticketList: [],
      // 所有的续费卷
      totalTicketList: [],
      // 续费卷id
      ticketId: '',
      // 开服卷描述列表
      ticketInfo: [{
        id: 0,
        name: '无',
        desc: '无'
      }, {
        id: 1,
        name: '小型服务器开服券',
        desc: '小型服务器开服券'
      }, {
        id: 2,
        name: '小型服务器开服券',
        desc: '小型服务器开服券'
      }, {
        id: 3,
        name: '续费卷-小型服务器1个月',
        desc: '免费续费可同时在线12人的小型服务器1个月'
      }, {
        id: 4,
        name: '续费卷-小型服务器6个月',
        desc: '免费续费可同时在线12人的小型服务器6个月'
      }, {
        id: 5,
        name: '续费卷-中型服务器1个月',
        desc: '免费续费可同时在线50人的小型服务器1个月'
      }, {
        id: 6,
        name: '续费卷-中型服务器6个月',
        desc: '免费续费可同时在线50人的小型服务器6个月'
      }],
      // 服务器密码
      serverPwd: '',
      // 服务器是否有密码
      isServerPwd: '',
      // 是否公开房间列表
      isPublic: '',
      // 服务器信息
      serverInfo: '',
      // 黑名单标志
      blackFlag: false,
      // 黑名单数据列表
      blackList: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('SessionID')
      }
    };
  },

  computed: {
    // 服务器模式文本信息
    modTypeText: function modTypeText() {
      if (this.modType === 0) {
        return '和平模式';
      } else {
        return '混战模式';
      }
    },

    // 当前服务器类型对应的列表索引
    expandIndex: function expandIndex() {
      return this.expandInfo.ServerType - 1;
    },

    // 当前服务器类型
    serverType: function serverType() {
      switch (this.serverInfo.MaxPlayerNum) {
        case 12:
          return 1;
        case 50:
          return 2;
        default:
          return 1;
      }
    },

    // 重新排列数组
    expandListSort: function expandListSort() {
      var _this = this;

      this.expandList.forEach(function (item, index) {
        if (parseInt(_this.expandInfo.ServerType) === parseInt(item.id)) {
          _this.expandList.unshift(_this.expandList.splice(index, 1)[0]);
        }
      });
      return this.expandList;
    },

    // 扩容/降级文字
    expandBtnText: function expandBtnText() {
      switch (this.serverType) {
        case 1:
          return '扩容';
        case 2:
          return '降级';
        default:
          return '';
      }
    },

    // 切换后剩余时间
    expandToggleTime: function expandToggleTime() {
      switch (this.expandInfo.ServerType) {
        case 1:
          return parseInt(this.expandInfo.DaysRemaining / 3);
        case 2:
          return parseInt(this.expandInfo.DaysRemaining * 3);
        default:
          return parseInt(this.expandInfo.DaysRemaining / 3);
      }
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户id添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将session id 添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 查询创建的服务器 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/PersonalRoom/GetPersonalRoomInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 获取私服信息
              _this2.serverInfo = res.ServerInfo;
              // 获取服务器密码
              _this2.serverPwd = _this2.serverInfo.PassWord;
              // 获取是否公开服务器至房间列表标记
              _this2.isPublic = _this2.serverInfo.IsShow;
              // 服务器模式 0 和平 1 PVP
              _this2.modType = _this2.serverInfo.PvpType;
              // 如果有密码设置标记
              if (_this2.serverPwd !== null && _this2.serverPwd !== '') {
                _this2.isServerPwd = true;
                // 没有密码设置标记
              } else {
                _this2.isServerPwd = false;
              }
              break;
            case 1:
              // 删除用户信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              // 跳转到登录页
              _this2.$router.push({ name: 'login' });
              break;
            case 2:
              _this2.tipsShow = true;
              _this2.tipsText = res.Msg;
              break;
            default:
              _this2.tipsShow = true;
              _this2.tipsText = res.Msg;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 服务器设置
    setupFn: function setupFn() {
      // 显示弹出层
      this.show = true;
      // 显示服务器设置表单
      this.setupFlag = true;
    },

    // 保存服务器设置
    setupSaveFn: function setupSaveFn() {
      var _this3 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 初始化密码
      var passWord = '';
      // 将用户id添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将session id 添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 将服务器 id 添加到表单
      formData.append('ServerId', this.serverInfo.ServerId);
      // 是否将服务器公开房间至列表
      formData.append('ListShow', this.isPublic);
      // 如果有设置密码
      if (this.isServerPwd === 'true') {
        passWord = this.serverPwd;
      } else {
        passWord = '';
      }
      // 将密码添加到表单
      formData.append('PassWord', passWord);

      // 保存服务器设置 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/PersonalRoom/EditPersonalRoomInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 打开提示层
              _this3.tipsShow = true;
              // 提示内容
              _this3.tipsText = '修改成功';
              // 刷新页面
              _this3.refreshFlag = true;
              // 关闭服务器设置
              _this3.setupFlag = false;
              break;
            case 1:
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this3.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 服务器设置取消
    setupCancelFn: function setupCancelFn() {
      this.show = false;
      this.setupFlag = false;
    },

    // 服务器扩容
    expandFn: function expandFn() {
      var _this4 = this;

      // 打开遮罩层
      this.show = true;
      // 打开私服扩容表单
      this.expandFlag = true;
      // 实例化表单对象
      var formData = new FormData();
      // 将用户id添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将session id 添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 将服务器 id 添加到表单
      formData.append('ServerId', this.serverInfo.ServerId);

      // 私服是否可以切换 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/PersonalRoom/PersonalRoomEnlargeInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 获取服务器切换信息
              _this4.expandInfo = res;
              break;
            case 1:
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this4.$router.push({ name: 'login' });
              break;
            case 2:
              _this4.tipsShow = true;
              _this4.tipsText = res.Msg;
              break;
            default:
              _this4.tipsShow = true;
              _this4.tipsText = res.Msg;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 服务器扩容取消关闭
    expandCancelFn: function expandCancelFn() {
      // 关闭遮罩层
      this.show = false;
      // 关闭服务器扩容
      this.expandFlag = false;
    },

    // 切换服务器
    expandToggleFn: function expandToggleFn() {
      var _this5 = this;

      if (this.expandInfo.CanEnlarge) {
        // 实例化表单对象
        var formData = new FormData();
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId);
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId);
        // 将服务器 id 添加到表单
        formData.append('ServerId', this.serverInfo.ServerId);

        // 私服是否可以切换 api
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/PersonalRoom/PersonalRoomEnlarge', formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            var res = response.data;
            switch (res.Code) {
              case 0:
                var serverTYpe = '';
                switch (res.ServerType) {
                  case 1:
                    serverTYpe = '小型服务器';
                    break;
                  case 2:
                    serverTYpe = '中型服务器';
                    break;
                  default:
                    serverTYpe = '切换异常';
                }

                // 打开提示层
                _this5.tipsShow = true;
                // 提示信息
                _this5.tipsText = '\u670D\u52A1\u5668\u5DF2\u8F6C\u6362\u4E3A' + serverTYpe;
                // 开启刷新页面
                _this5.refreshFlag = true;
                break;
              case 1:
                Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
                _this5.$router.push({ name: 'login' });
                break;
              case 2:
                _this5.tipsShow = true;
                _this5.tipsText = res.Msg;
                break;
              default:
                // 打开提示层
                _this5.tipsShow = true;
                // 提示信息
                _this5.tipsText = '\u670D\u52A1\u5668\u5DF2\u8F6C\u6362\u4E3A' + serverTYpe;
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        // 获取当前时间戳
        var nowTimeStamp = Date.parse(new Date());
        // 获取最后操作时间对象
        var lastTime = new Date(this.expandInfo.OprateTime);
        // 到期时间，最后操作时间的后10天时间戳
        var overdueTime = lastTime.setDate(lastTime.getDate() + 10);
        // 如果当前时间小于到期时间
        if (overdueTime > nowTimeStamp) {
          // 获取当前时间距离过期时间的天数
          var surplusDays = Math.round((overdueTime - nowTimeStamp) / 86400000);
          // 打开提示层
          this.tipsShow = true;
          // 提示错误
          this.tipsText = '\u5207\u6362\u670D\u52A1\u5668\u540E\uFF0C10\u5929\u5185\u4E0D\u80FD\u518D\u5207\u6362\uFF0C\u5269\u4F59' + surplusDays + '\u5929';
        }
      }
    },

    // 续费
    renewFn: function renewFn() {
      var _this6 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户id添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将session id 添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 将服务器 id 添加到表单
      formData.append('ServerId', this.serverInfo.ServerId);
      // 隐藏页面滚动条
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
      // 私服续费初始化接口 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/PersonalRoom/PersonalRoomDeferInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 打开遮罩层
              _this6.show = true;
              // 打开续费表单
              _this6.renewFlag = true;
              // 将小型和中型开发卷合并到一个数组
              var newArr = res.Ticket_OneMonthList.concat(res.Ticket_SixMonthList);
              _this6.totalTicketList = newArr;
              // 将合并后的开服卷列表赋值到对象属性
              switch (res.ServerType) {
                case 1:
                  _this6.ticketList = res.Ticket_OneMonthList;
                  break;
                case 2:
                  _this6.ticketList = res.Ticket_SixMonthList;
                  break;
                default:
                  _this6.ticketList = res.Ticket_OneMonthList;
              }
              break;
            case 1:
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this6.$router.push({ name: 'login' });
              break;
            case 2:
              _this6.tipsShow = true;
              _this6.tipsText = res.Msg;
              break;
            default:
              _this6.tipsShow = true;
              _this6.tipsText = res.Msg;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 取消续费
    renewCancelFn: function renewCancelFn() {
      // 打开遮罩层
      this.show = false;
      // 打开续费表单
      this.renewFlag = false;
      // 清空开服卷
      this.ticketId = '';
      // 显示页面滚动条
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    },

    // 提交续费
    renewSubFn: function renewSubFn() {
      var _this7 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户id添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将session id 添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 将服务器 id 添加到表单
      formData.append('ServerId', this.serverInfo.ServerId);
      // 续费卷id
      formData.append('TicketIds', this.ticketId);

      if (this.ticketId === '') {
        // 打开提示层
        this.tipsShow = true;
        // 提示错误
        this.tipsText = '请选择开服卷';
      } else {
        // 私服续费 api
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/PersonalRoom/PersonalRoomDefer', formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            var res = response.data;
            switch (res.Code) {
              case 0:
                // 关闭续费表单
                _this7.renewFlag = false;
                // 清空续费卷id
                _this7.ticketId = '';
                // 打开提示层
                _this7.tipsShow = true;
                // 提示错误
                _this7.tipsText = '续费成功';
                // 刷新页面
                _this7.refreshFlag = true;
                break;
              case 1:
                Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
                _this7.$router.push({ name: 'login' });
                break;
              case 2:
                _this7.tipsShow = true;
                _this7.tipsText = res.Msg;
                break;
              default:
                _this7.tipsShow = true;
                _this7.tipsText = res.Msg;
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

    // 计算续费卷个数
    countTicket: function countTicket(index) {
      var arr = [];
      this.totalTicketList.forEach(function (item) {
        if (parseInt(index) === parseInt(item.Type)) {
          arr.push(item);
        }
      });
      return arr.length;
    },

    // 获取黑名单列表
    getBlackFn: function getBlackFn() {
      var _this8 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户id添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将session id 添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 黑名单列表 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/BlackList/GetBlackList_New', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              _this8.blackList = res.ItemList;
              break;
            case 1:
              // 删除用户信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              // 跳转到登录页
              _this8.$router.push({ name: 'login' });
              break;
            case 2:
              _this8.tipsShow = true;
              _this8.tipsText = res.Msg;
              break;
            default:
              _this8.tipsShow = true;
              _this8.tipsText = res.Msg;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 黑名单
    blackFn: function blackFn() {
      // 打开遮罩层
      this.show = true;
      // 打开黑名单设置
      this.blackFlag = true;
      // 获取黑名单列表
      this.getBlackFn();
    },

    // 添加到黑名单
    addBlackFn: function addBlackFn(id) {
      var _this9 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户id添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将session id 添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 角色 id
      formData.append('RoleId', id);
      // 黑名角色查找 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/BlackList/AddBlackList_New', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 获取黑名单列表
              _this9.getBlackFn();
              // 弹出提示信息
              _this9.tipsShow = true;
              _this9.tipsText = res.Msg;
              // 清空查询到的黑名单信息
              _this9.searchInfo = '';
              break;
            case 1:
              // 删除用户信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              // 跳转到登录页
              _this9.$router.push({ name: 'login' });
              break;
            case 2:
              _this9.tipsShow = true;
              _this9.tipsText = res.Msg;
              break;
            default:
              _this9.tipsShow = true;
              _this9.tipsText = res.Msg;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 黑名单查询
    blackSearchFn: function blackSearchFn() {
      var _this10 = this;

      // 如果输入了内容
      if (this.searchName.trim()) {
        // 实例化表单对象
        var formData = new FormData();
        // 将用户id添加到表单
        formData.append('UserID', this.formDatas.userId);
        // 将session id 添加到表单
        formData.append('SessionID', this.formDatas.sessionId);
        // 私服 id
        formData.append('ServerId', this.serverInfo.ServerId);
        // 角色名
        formData.append('RoleName', this.searchName);
        // 黑名角色查找 api
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/BlackList/SearchRole_New', formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            var res = response.data;
            switch (res.Code) {
              case 0:
                // 清空输入框查询内容
                _this10.searchName = '';
                // 获取查询到的信息
                _this10.searchInfo = res;
                // console.log(this.searchInfo)
                break;
              case 1:
                // 删除用户信息
                Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
                // 跳转到登录页
                _this10.$router.push({ name: 'login' });
                break;
              case 2:
                _this10.tipsShow = true;
                _this10.tipsText = res.Msg;
                break;
              default:
                _this10.tipsShow = true;
                _this10.tipsText = res.Msg;
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        // 打开提示层
        this.tipsShow = true;
        // 提示错误
        this.tipsText = ERROR_TIPS[0].desc;
      }
    },

    // 取消黑名单
    blackCancelFn: function blackCancelFn() {
      // 打开遮罩层
      this.show = false;
      // 打开黑名单设置
      this.blackFlag = false;
    },

    // 关闭提示层
    closeMaskEvFn: function closeMaskEvFn(val) {
      console.log(val);
      // 关闭弹出层
      this.tipsShow = val;
      // 是否刷新页面
      if (this.refreshFlag) {
        // 重置刷新标志
        this.refreshFlag = false;
        // 刷新页面
        // this.$router.go(0)
        // 更新数据
        this.init();
      }
      // 关闭操作界面
      this.show = !this.show;
    },

    // 关闭确认删除弹出层
    closeMaskFn: function closeMaskFn() {
      this.confirmFlag = false;
    },

    // 删除黑名单
    delBlackFn: function delBlackFn(id, index) {
      // 打开确认删除弹层
      this.confirmFlag = true;
      // 记录要删除的黑名单 id
      this.delBlackId = id;
      // 记录要删除黑名单的索引
      this.delBlackIndex = index;
    },

    // 确认删除黑名单
    delBlackConfirmFn: function delBlackConfirmFn() {
      var _this11 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户id添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将session id 添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 角色 id
      formData.append('Id', this.delBlackId);
      // 黑名角色查找 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/BlackList/DeleteBlackList_New', formData, {
        // 设置删除黑名单
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 关闭确认删除弹出层
              _this11.confirmFlag = false;
              // 打开提示弹出层
              _this11.tipsShow = true;
              // 提示信息
              _this11.tipsText = _this11.tipsText = ERROR_TIPS[1].desc;
              // 删除数组中对应的元素
              _this11.blackList.splice(_this11.delBlackIndex, 1);
              // 清空删除 id
              _this11.delBlackId = '';
              // 清空删除索引
              _this11.delBlackIndex = '';
              break;
            case 1:
              // 删除用户信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              // 跳转到登录页
              _this11.$router.push({ name: 'login' });
              break;
            case 2:
              _this11.tipsShow = true;
              _this11.tipsText = res.Msg;
              break;
            default:
              _this11.tipsShow = true;
              _this11.tipsText = res.Msg;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_1_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "UuNB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"income"},[_c('h3',{staticClass:"income-title"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("收入FAQ")]),_vm._v(" "),_c('span',{staticClass:"line"})]),_vm._v(" "),_c('dl',{staticClass:"qa"},[_c('dt',{staticClass:"ask"},[_vm._v("收入系统正在研发中，敬请期待。")]),_vm._v(" "),_c('dd',{staticClass:"answer"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VGXw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-2-image-1.eb25580.png";

/***/ }),

/***/ "Vr6n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.9642169.png";

/***/ }),

/***/ "W2Q3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("Haow");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9080e63e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("euYZ");
function injectStyle (ssrContext) {
  __webpack_require__("S7Og")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9080e63e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WLJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-rotate-bar"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.rotateLeft}},[_c('svg',{staticClass:"svg-icon",attrs:{"viewBox":"0 0 481.95 481.95"}},[_c('path',{attrs:{"d":"M281.7,243.8V138.2c75.9,13.5,135.4,78.6,135.4,159.8s-59.6,146.3-135.4,159.8V512\n        c105.7-13.5,189.6-102.9,189.6-214s-84-200.5-189.6-214V0L159.8,121.9L281.7,243.8z M94.8,270.9c2.7-24.4,13.5-46.1,27.1-67.7\n        L84,165.2C59.6,197.8,46.1,233,40.6,270.9H94.8z M159.8,430.7l-37.9,37.9c32.5,24.4,67.7,37.9,105.7,43.3v-54.2\n        C203.2,455.1,181.5,444.3,159.8,430.7z M94.8,325.1H40.6c2.7,37.9,19,73.1,43.3,105.7l37.9-37.9\n        C108.4,371.1,97.5,349.5,94.8,325.1z","fill":"#27ae60"}})])]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.rotateRight}},[_c('svg',{staticClass:"svg-icon",attrs:{"viewBox":"0 0 481.95 481.95"}},[_c('path',{attrs:{"d":"M331.5,114.75L216.75,0v79.05C117.3,91.8,38.25,175.95,38.25,280.5s79.05,188.7,178.5,201.45v-51    C145.35,418.2,89.25,357,89.25,280.5s56.1-137.7,127.5-150.45v99.45L331.5,114.75z M443.7,255    c-5.101-35.7-17.851-68.85-40.8-99.45l-35.7,35.7c12.75,20.4,22.95,40.8,25.5,63.75H443.7z M267.75,430.95v51    c35.7-5.101,68.85-17.851,99.45-40.8l-35.7-35.7C311.1,418.2,290.7,428.4,267.75,430.95z M367.2,369.75l35.7,35.7    c22.949-30.601,38.25-63.75,40.8-99.45h-51C390.15,328.95,379.95,349.35,367.2,369.75z","fill":"#27ae60"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WVba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_drag__ = __webpack_require__("Wx/i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_drag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_resize__ = __webpack_require__("TeCL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_loading_gif__ = __webpack_require__("HBWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lib_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_helper__ = __webpack_require__("ZKdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lib_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper__ = __webpack_require__("q+yL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue__ = __webpack_require__("Qfng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue__ = __webpack_require__("q4Kl");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// set cropbox size in image
var CROPBOX_PERCENT = 75;
var isMobile = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile;
var areaWidth = window.innerWidth - 60;
var areaHeight = window.innerHeight - 110;
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ResizeBar: __WEBPACK_IMPORTED_MODULE_5__resize_bar_vue__["a" /* default */],
    RotateBar: __WEBPACK_IMPORTED_MODULE_6__rotate_bar_vue__["a" /* default */]
  },
  props: {
    ratio: {
      type: String,
      default: '1:1'
    },
    minWidth: {
      type: Number,
      default: 50
    },
    minHeight: {
      type: Number,
      default: 50
    },
    isResize: {
      type: [Boolean],
      default: false
    },
    isRotate: {
      type: [Boolean],
      default: true
    }
  },

  data: function data() {
    return {
      src: __WEBPACK_IMPORTED_MODULE_2__lib_loading_gif___default.a,
      width: 24,
      height: 24,
      initWidth: 24,
      initHeight: 24,
      left: 0,
      top: 0,
      cropCSS: {}
    };
  },


  methods: {
    setImage: function setImage(src, w, h) {
      this.src = src;
      if (!this.originSrc) {
        this.setOriginalSrc(this.src);
      }
      if (this.ratio.indexOf(':') > 0) {
        this.ratioW = this.ratio.split(':')[0];
        this.ratioH = this.ratio.split(':')[1];
        this.ratioVal = this.ratioW / this.ratioH;
      } else {
        this.ratioW = 1;
        this.ratioH = 1;
        this.ratioVal = this.ratio;
      }
      this.natrualWidth = w;
      this.natrualHeight = h;
      this.setLayout(w, h);
      var resizeBar = this.$refs.resizeBar;
      if (this.isResize) {
        resizeBar.setProgress(100);
      } else {
        resizeBar.setProgress(50);
      }
      return this.imgChangeRatio;
    },
    setOriginalSrc: function setOriginalSrc(src) {
      this.originSrc = src;
    },
    resizeImage: function resizeImage(progress) {
      var w = void 0,
          h = void 0;
      if (this.isResize) {
        w = this.natrualWidth * this.imgChangeRatio * progress;
        h = this.natrualHeight * this.imgChangeRatio * progress;
      } else {
        w = this.initWidth + progress * (this.natrualWidth - this.initWidth);
        h = this.initHeight + progress * (this.natrualHeight - this.initHeight);
      }
      if (w <= this.minWidth || h < this.minHeight) {
        return;
      }
      this.left += (this.width - w) / 2;
      this.top += (this.height - h) / 2;
      this.width = w;
      this.height = h;
      this.imgChangeRatio = this.width / this.natrualWidth;
    },
    rotateImage: function rotateImage(degress) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_4__lib_canvas_helper___default.a.rotate2(this.originSrc, degress, function (data, w, h) {
        _this.setImage(data, w, h);
      });
      //this.src = src;
    },
    setLayout: function setLayout(w, h) {
      var H = areaHeight,
          W = areaWidth,
          width = w,
          height = h,
          marginLeft = 0,
          marginTop = 0;
      // caculate the image ratio
      var R = width / height;
      var Rs = W / H;
      if (R > Rs) {
        height = H;
        width = H * R;
        marginLeft = (W - H * R) / 2;
      } else {
        width = H * R, height = H;
        marginLeft = (W - H * R) / 2;
      }
      this._setStyle(width, height, marginLeft, marginTop, R, true);
    },
    _setStyle: function _setStyle(w, h, ml, mt, r, isInit) {
      var $container = this.$el.querySelector('.g-crop-image-principal');
      if (!isInit) {
        this.marginLeft = this.marginLeft + (this.width - w) / 2;
        this.marginTop = this.marginTop + (this.height - h) / 2;
      }
      $container.style.cssText = 'width:' + w + 'px;height:' + h + 'px;margin-left:' + ml + 'px;' + 'margin-top:' + mt + 'px';
      this.setCropBox(w, h);
      if (this.isResize) {
        this.width = w;
        this.height = h;
      } else {
        if (r >= this.cropCSS.width / this.cropCSS.height) {
          this.height = this.cropCSS.height;
          this.width = this.height * r;
        } else {
          this.width = this.cropCSS.width;
          this.height = this.width / r;
        }
        this.initWidth = this.width;
        this.initHeight = this.height;
        this.left = (w - this.width) / 2;
        this.top = (h - this.height) / 2;
      }
      this.imgChangeRatio = this.width / this.natrualWidth;
    },
    setCropBox: function setCropBox(w, h, r) {
      if (this.isResize) {
        return;
      }
      var $selectCropBox = this.__find('.crop-box');
      var $wrap = this.$el;
      var imageWidth = w,
          imageHeight = h,
          ratioW = this.ratioW,
          ratioH = this.ratioH;
      var cropWidth = imageWidth;
      if (areaWidth < w) {
        cropWidth = areaWidth;
      }
      var baseCropWidth = cropWidth / 100 * CROPBOX_PERCENT;
      var CSSObj = {
        width: baseCropWidth,
        height: baseCropWidth / ratioW * ratioH
      };
      CSSObj.left = (imageWidth - baseCropWidth) / 2;
      CSSObj.top = (imageHeight - CSSObj.height) / 2;
      $selectCropBox.style.cssText = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.setCssText(CSSObj);
      if (CSSObj.height > imageHeight) {
        var baseCropHeight = imageHeight / 100 * CROPBOX_PERCENT;
        CSSObj.height = baseCropHeight;
        CSSObj.width = CSSObj.height * ratioW / ratioH;
        CSSObj.left = (imageWidth - CSSObj.width) / 2, CSSObj.top = (imageHeight - CSSObj.height) / 2, $selectCropBox.style.cssText = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.setCssText(CSSObj);
      };
      this.cropCSS = CSSObj;
    },
    getCropData: function getCropData() {
      // keep compatible with old api
      if (this.isResize) {
        return {
          imgChangeRatio: this.imgChangeRatio,
          toCropImgX: 0,
          toCropImgY: 0,
          toCropImgW: this.natrualWidth,
          toCropImgH: this.natrualHeight
        };
      }
      return {
        toCropImgX: (this.cropCSS.left - this.left) / this.imgChangeRatio,
        toCropImgY: (this.cropCSS.top - this.top) / this.imgChangeRatio,
        toCropImgW: this.cropCSS.width / this.imgChangeRatio,
        toCropImgH: this.cropCSS.height / this.imgChangeRatio
      };
    },
    getCropImage: function getCropImage() {
      return this.$refs['crop-image'];
    },
    __find: function __find(str) {
      var dq = this.$el;
      return dq.querySelector(str);
    },

    // resize and drag move
    resize: function resize(e) {
      e.stopPropagation();
      if (!this.ratio.indexOf(':')) {
        return;
      }
      var $el = e.target.parentElement;
      var $container = this.__find('.g-crop-image-principal');
      if (this._$container) {
        this._$container = container;
      }
      var self = this;
      var coor = {
        x: __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile ? e.touches[0].clientX : e.clientX,
        y: __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile ? e.touches[0].clientY : e.clientY,
        w: $el.offsetWidth,
        h: $el.offsetHeight
      };
      this.el = $el;
      this.container = $container;
      var maxCoor = this._getMaxCropAreaWidth();
      var move = function move(ev) {
        var newCropStyle = __WEBPACK_IMPORTED_MODULE_1__lib_resize___default()(ev, self.el, $container, coor, self.ratioVal);
        if (newCropStyle && (newCropStyle.width <= maxCoor.maxWidth || newCropStyle.height <= maxCoor.maxHeight)) {
          self.cropCSS.width = newCropStyle.width;
          self.cropCSS.height = newCropStyle.height;
        }
      };
      var end = function end(ev) {
        this.el = null;
        if (__WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', end, false);
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', end, false);
      };
      if (__WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', end, false);
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', end, false);
    },
    _getMaxCropAreaWidth: function _getMaxCropAreaWidth() {
      var $cropBox = this.__find('.crop-box');
      if (this.width > this.height) {
        return {
          maxWidth: this.height * this.ratioW / this.ratioH,
          maxHeight: this.height
        };
      }
      return {
        maxWidth: this.width,
        maxHeight: this.width * this.ratioH / this.ratioW
      };
    },
    drag: function drag(e) {
      e.preventDefault();
      var $el = this.__find('.image-wrap');
      this.el = $el;
      var $cropBox = this.__find('.crop-box');
      var $container = e.currentTarget;
      var self = this;
      var isMobile = __WEBPACK_IMPORTED_MODULE_3__lib_helper___default.a.isMobile;
      var coor = {
        x: (isMobile ? e.touches[0]['clientX'] : e.clientX) - $el.offsetLeft,
        y: (isMobile ? e.touches[0]['clientY'] : e.clientY) - $el.offsetTop,
        maxLeft: $cropBox.offsetLeft,
        maxTop: $cropBox.offsetTop,
        minLeft: $cropBox.offsetWidth + $cropBox.offsetLeft - $el.offsetWidth,
        minTop: $cropBox.offsetHeight + $cropBox.offsetTop - $el.offsetHeight
      };
      var move = function move(ev) {
        var newCropStyle = __WEBPACK_IMPORTED_MODULE_0__lib_drag___default()(ev, self.el, coor);
        if (newCropStyle) {
          self.left = newCropStyle.left;
          self.top = newCropStyle.top;
        }
      };
      var stopMove = function stopMove(ev) {
        self.el = null;
        if (isMobile) {
          document.removeEventListener('touchmove', move, false);
          document.removeEventListener('touchend', stopMove, false);
          return;
        }
        document.removeEventListener('mousemove', move, false);
        document.removeEventListener('mouseup', stopMove, false);
      };
      if (isMobile) {
        document.addEventListener('touchmove', move, false);
        document.addEventListener('touchend', stopMove, false);
        return;
      }
      document.addEventListener('mousemove', move, false);
      document.addEventListener('mouseup', stopMove, false);
    }
  }

});

/***/ }),

/***/ "XiTT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_devMapinspect_vue__ = __webpack_require__("lZHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c968b69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_devMapinspect_vue__ = __webpack_require__("n3T7");
function injectStyle (ssrContext) {
  __webpack_require__("vf9b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_devMapinspect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c968b69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_devMapinspect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y8Ma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-menu"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"faq-list clearfix"},[_c('li',{staticClass:"list-item"},[_c('router-link',{staticClass:"link-item",attrs:{"to":"/faq/faqNew"}},[_c('i',{staticClass:"icon icon-phones"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("新手教程")])])],1),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('router-link',{staticClass:"link-item",attrs:{"to":"/faq/pluginFaq"}},[_c('i',{staticClass:"icon icon-puzzle"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("插件FAQ")])])],1),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('router-link',{staticClass:"link-item",attrs:{"to":"/faq/backstage"}},[_c('i',{staticClass:"icon icon-pc"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("后台FAQ")])])],1),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('router-link',{staticClass:"link-item",attrs:{"to":"/faq/income"}},[_c('i',{staticClass:"icon icon-money"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("收入FAQ")])])],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"qq-group"},[_vm._v("QQ1群:546241346")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"faq-title"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("FAQ")]),_vm._v(" "),_c('span',{staticClass:"line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"faq-title"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("开发QQ群")]),_vm._v(" "),_c('span',{staticClass:"line"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YJUW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pubMapinspect_vue__ = __webpack_require__("/gCT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1806718e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pubMapinspect_vue__ = __webpack_require__("kExR");
function injectStyle (ssrContext) {
  __webpack_require__("qLkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pubMapinspect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1806718e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pubMapinspect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_login_login__ = __webpack_require__("W2Q3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_createServer_createServer__ = __webpack_require__("FY9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_serverManage_serverManage__ = __webpack_require__("OZfl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_home_home__ = __webpack_require__("zKIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_developerAgreement_developerAgreement__ = __webpack_require__("lTBt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_developerInfo_developerInfo__ = __webpack_require__("HB59");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_developerSuccess_developerSuccess__ = __webpack_require__("/2IE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_developerStatus_developerStatus__ = __webpack_require__("nTJ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_downloadPlugin_downloadPlugin__ = __webpack_require__("/h22");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_developmentFile_developmentFile__ = __webpack_require__("umVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_mapMod_mapMod__ = __webpack_require__("tPdr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_selfMod_selfMod__ = __webpack_require__("y0yL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_devMapinspect_devMapinspect__ = __webpack_require__("XiTT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_views_testMapinspect_testMapinspect__ = __webpack_require__("2RhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_pubMapinspect_pubMapinspect__ = __webpack_require__("YJUW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_views_examineFail_examineFail__ = __webpack_require__("4ZrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_views_toExamine_toExamine__ = __webpack_require__("EWHj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_mapInfoImperfect_mapInfoImperfect__ = __webpack_require__("YsCa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_mapShowStatus_mapShowStatus__ = __webpack_require__("oecS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_views_comment_comment__ = __webpack_require__("pY+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_views_faq_faq__ = __webpack_require__("9G6Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_views_faqNew_faqNew__ = __webpack_require__("AmPc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_views_pluginFaq_pluginFaq__ = __webpack_require__("LebW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_views_backstage_backstage__ = __webpack_require__("16Cq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_views_income_income__ = __webpack_require__("lW1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_views_pdf_pdf__ = __webpack_require__("Z6IH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_views_rootDoc_rootDoc__ = __webpack_require__("L+BW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_views_language_language__ = __webpack_require__("9UVs");
// 引入 vue

// 引入路由

// 登录页面

// 创建服务器

// 私服管理

// 个人主页主页面

// 开发者协议

// 开发者信息

// 开发者申请成功

// 开发者申请状态

// 下载开发插件

// 开发文档

// 我的地图mod

// 我的私服mod

// 开发区地图审核

// 测试区地图审核

// 正式区地图审核

// 审核失败

// 地图审核中

// 地图信息不完善提示

// 地图查看

// 游戏内评论

// faq

// 新手教程

// 插件 faq

// 后台 faq

// 收入 faq

// pdf 预览页面

// root 相关文档页面

// 语言切换


// 注册路由
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // 使用 / 方式切换路径，默认使用哈希 #
  // mode: 'history',
  linkActiveClass: 'active',
  routes: [
  // 根目录
  {
    path: '/',
    redirect: {
      name: 'login'
    },
    component: __WEBPACK_IMPORTED_MODULE_2_views_login_login__["a" /* default */]
  },
  // 登录页
  {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2_views_login_login__["a" /* default */]
  },
  // 个人主页主路由
  {
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_5_views_home_home__["a" /* default */],
    redirect: '/home/mapMod',
    children: [
    // 我的地图MOD
    {
      path: 'mapMod',
      name: 'mapMod',
      component: __WEBPACK_IMPORTED_MODULE_12_views_mapMod_mapMod__["a" /* default */]
    },
    // 我的私服MOD
    {
      path: 'selfMod',
      name: 'selfMod',
      component: __WEBPACK_IMPORTED_MODULE_13_views_selfMod_selfMod__["a" /* default */]
    }]
  },
  // 创建服务器
  {
    path: '/createServer',
    name: 'createServer',
    component: __WEBPACK_IMPORTED_MODULE_3_views_createServer_createServer__["a" /* default */]
  },
  // 游戏管理
  {
    path: '/serverManage',
    name: 'serverManage',
    component: __WEBPACK_IMPORTED_MODULE_4_views_serverManage_serverManage__["a" /* default */]
  },
  // 开发者申请协议页面
  {
    path: '/developerAgreement',
    name: 'developerAgreement',
    component: __WEBPACK_IMPORTED_MODULE_6_views_developerAgreement_developerAgreement__["a" /* default */]
  },
  // 开发者申请信息页面
  {
    path: '/developerInfo',
    name: 'developerInfo',
    component: __WEBPACK_IMPORTED_MODULE_7_views_developerInfo_developerInfo__["a" /* default */]
  },
  // 开发者申请成功页面
  {
    path: '/developerSuccess',
    name: 'developerSuccess',
    component: __WEBPACK_IMPORTED_MODULE_8_views_developerSuccess_developerSuccess__["a" /* default */]
  },
  // 开发者申请状态
  {
    path: '/developerStatus',
    name: 'developerStatus',
    component: __WEBPACK_IMPORTED_MODULE_9_views_developerStatus_developerStatus__["a" /* default */]
  },
  // 下载开发插件
  {
    path: '/downloadPlugin',
    name: 'downloadPlugin',
    component: __WEBPACK_IMPORTED_MODULE_10_views_downloadPlugin_downloadPlugin__["a" /* default */]
  },
  // 下载开发插件
  {
    path: '/developmentFile/:pid',
    name: 'developmentFile',
    component: __WEBPACK_IMPORTED_MODULE_11_views_developmentFile_developmentFile__["a" /* default */]
  },
  // 开发区地图审核
  {
    path: '/devMapinspect/:mapId/:stage',
    name: 'devMapinspect',
    component: __WEBPACK_IMPORTED_MODULE_14_views_devMapinspect_devMapinspect__["a" /* default */]
  },
  // 测试地图审核
  {
    path: '/testMapinspect/:mapId/:stage',
    name: 'testMapinspect',
    component: __WEBPACK_IMPORTED_MODULE_15_views_testMapinspect_testMapinspect__["a" /* default */]
  },
  // 正式区地图审核
  {
    path: '/pubMapinspect/:mapId/:stage',
    name: 'pubMapinspect',
    component: __WEBPACK_IMPORTED_MODULE_16_views_pubMapinspect_pubMapinspect__["a" /* default */]
  },
  // 地图审核失败
  {
    path: '/examineFail/:mapId/:stage',
    name: 'examineFail',
    component: __WEBPACK_IMPORTED_MODULE_17_views_examineFail_examineFail__["a" /* default */]
  },
  // 审核中
  {
    path: '/toExamine/:mapId/:stage',
    name: 'toExamine',
    component: __WEBPACK_IMPORTED_MODULE_18_views_toExamine_toExamine__["a" /* default */]
  },
  // 地图信息不完善提示
  {
    path: '/mapInfoImperfect/:mapId/:stage',
    name: 'mapInfoImperfect',
    component: __WEBPACK_IMPORTED_MODULE_19_views_mapInfoImperfect_mapInfoImperfect__["a" /* default */]
  },
  // 地图信息查看
  {
    path: '/mapShowStatus/:mapId/:stage',
    name: 'mapShowStatus',
    component: __WEBPACK_IMPORTED_MODULE_20_views_mapShowStatus_mapShowStatus__["a" /* default */]
  },
  // 游戏内评论
  {
    path: '/comment/:accountId/:mapId/:passKey',
    name: 'comment',
    component: __WEBPACK_IMPORTED_MODULE_21_views_comment_comment__["a" /* default */]
  },
  // faq
  {
    path: '/faq',
    name: 'faq',
    component: __WEBPACK_IMPORTED_MODULE_22_views_faq_faq__["a" /* default */],
    redirect: '/faq/faqNew',
    children: [
    // 新手教程
    {
      path: 'faqNew',
      name: 'faqNew',
      component: __WEBPACK_IMPORTED_MODULE_23_views_faqNew_faqNew__["a" /* default */]
    },
    // 插件 faq
    {
      path: 'pluginFaq',
      name: 'pluginFaq',
      component: __WEBPACK_IMPORTED_MODULE_24_views_pluginFaq_pluginFaq__["a" /* default */]
    },
    // 后台 faq
    {
      path: 'backstage',
      name: 'backstage',
      component: __WEBPACK_IMPORTED_MODULE_25_views_backstage_backstage__["a" /* default */]
    },
    // 后台 faq
    {
      path: 'income',
      name: 'income',
      component: __WEBPACK_IMPORTED_MODULE_26_views_income_income__["a" /* default */]
    }]
  },
  // pdf 预览页面
  {
    path: '/pdf/:name/:pid',
    name: 'pdf',
    component: __WEBPACK_IMPORTED_MODULE_27_views_pdf_pdf__["a" /* default */]
  },
  // rootDoc
  {
    path: '/rootDoc',
    name: 'rootDoc',
    component: __WEBPACK_IMPORTED_MODULE_28_views_rootDoc_rootDoc__["a" /* default */]
  },
  // 语言切换
  {
    path: '/language',
    name: 'language',
    component: __WEBPACK_IMPORTED_MODULE_29_views_language_language__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YsCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapInfoImperfect_vue__ = __webpack_require__("Ik4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5fcda6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapInfoImperfect_vue__ = __webpack_require__("Miij");
function injectStyle (ssrContext) {
  __webpack_require__("j6jB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapInfoImperfect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5fcda6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapInfoImperfect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z6IH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdf_vue__ = __webpack_require__("nAmY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa92bf3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pdf_vue__ = __webpack_require__("7N/n");
function injectStyle (ssrContext) {
  __webpack_require__("kf4d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa92bf3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pdf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZH/w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zln7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZrcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"developer-status"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"apply-result"},[_vm._v("审核中")]),_vm._v(" "),_c('p',{staticClass:"apply-desc"},[_vm._v("等待审核中，请加入官方开发者审核QQ群，联系管理员通过审核。(进群请务必查看置顶公告)")]),_vm._v(" "),_c('p',{staticClass:"qq-group"},[_vm._v("审核1群：546241346")]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('router-link',{staticClass:"item go-home",attrs:{"to":"/home"}},[_vm._v("返回开发者首页")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"head"},[_c('i',{staticClass:"icon-notice"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aOvb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.7165c76.png";

/***/ }),

/***/ "ayyW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // 审核通过页面
  name: 'developerSuccess',
  methods: {
    goHomeFn: function goHomeFn() {
      this.$router.push({ path: 'home' });
    }
  }
});

/***/ }),

/***/ "bY1t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cHPI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.4538cc3.png";

/***/ }),

/***/ "ciBS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/18.5a44097.png";

/***/ }),

/***/ "cnnt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "cuet":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-2-image-2.9924aa2.png";

/***/ }),

/***/ "diup":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmMask_vue__ = __webpack_require__("pEiu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70acbf61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmMask_vue__ = __webpack_require__("w+iX");
function injectStyle (ssrContext) {
  __webpack_require__("L9UR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmMask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70acbf61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmMask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dm8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eGfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"developer-success"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"apply-result"},[_vm._v("申请成功")]),_vm._v(" "),_c('p',{staticClass:"apply-desc"},[_vm._v("恭喜您已通过验证，成为创造与魔法开发者的一员。")]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('router-link',{staticClass:"item go-course",attrs:{"to":"/faq"}},[_vm._v("阅读开发者新手教程")]),_vm._v(" "),_c('router-link',{staticClass:"item go-home",attrs:{"to":"/home"}},[_vm._v("返回开发者首页")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"head"},[_c('i',{staticClass:"icon-success"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ecrR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "euYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"login"},[_c('v-developer-header',[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("创造与魔法开发者管理系统")])]),_vm._v(" "),_c('form',{staticClass:"form-content",attrs:{"action":"#"}},[_c('dl',{staticClass:"form-controller"},[_c('dt',{staticClass:"title"},[_vm._v("账号：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.userName),expression:"formDatas.userName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-input",attrs:{"name":"heroUser","type":"text"},domProps:{"value":(_vm.formDatas.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formDatas, "userName", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"form-error-tips"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('heroUser')),expression:"errors.has('heroUser')"}]},[_vm._v(_vm._s(_vm.errors.first('heroUser')))])])]),_vm._v(" "),_c('dd',{staticClass:"right"})]),_vm._v(" "),_c('dl',{staticClass:"form-controller"},[_c('dt',{staticClass:"title"},[_vm._v("密码：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.passWord),expression:"formDatas.passWord"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-input",attrs:{"name":"password","type":"password"},domProps:{"value":(_vm.formDatas.passWord)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formDatas, "passWord", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"form-error-tips"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}]},[_vm._v(_vm._s(_vm.errors.first('password')))])])]),_vm._v(" "),_c('dd',{staticClass:"right"})]),_vm._v(" "),_c('dl',{staticClass:"form-controller"},[_c('dt',{staticClass:"title"},[_vm._v("常用手机操作系统：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('a',{staticClass:"phone-system",class:{ 'active': _vm.formDatas.systemType === '106' },attrs:{"href":"javascript: void(0)"},on:{"click":_vm.appleFn},model:{value:(_vm.formDatas.systemType),callback:function ($$v) {_vm.$set(_vm.formDatas, "systemType", $$v)},expression:"formDatas.systemType"}},[_vm._v("IOS")]),_vm._v(" "),_c('a',{staticClass:"phone-system",class:{ 'active': _vm.formDatas.systemType === '85' },attrs:{"href":"javascript: void(0)"},on:{"click":_vm.androidFn},model:{value:(_vm.formDatas.systemType),callback:function ($$v) {_vm.$set(_vm.formDatas, "systemType", $$v)},expression:"formDatas.systemType"}},[_vm._v("安卓")])]),_vm._v(" "),_c('dd',{staticClass:"right phone-tips-box"},[_c('a',{staticClass:"often-system",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.tipsFn}},[_vm._v("什么是常用手机操作系统？")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipsFlag),expression:"tipsFlag"}],staticClass:"phone-tips"},[_c('h3',{staticClass:"title"},[_vm._v("常用手机操作系统")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('i',{staticClass:"icon-arrow-bottom"})])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"error-tips"},[_vm._v(_vm._s(_vm.formErrot))]),_vm._v(" "),_c('div',{staticClass:"sign-in"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.loginFn}},[_vm._v("登录")])])]),_vm._v(" "),_c('v-loading',{ref:"loading",attrs:{"show":_vm.loading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"desc"},[_vm._v("\n            受限于IOS和安卓不同平台需要分别建立子账号的限制，我们的开发者账户也需要区分IOS和安卓，以便于通过手机端访问开发者管理系统。\n            "),_c('span',{staticClass:"proposal"},[_vm._v("建议您根据平时经常用来玩《创造与魔法》游戏的设备类型进行选择。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handle"},[_c('a',{staticClass:"forget-pwd",attrs:{"href":"http://i.yingxiong.com/pass/getpassword"}},[_vm._v("忘记密码？")]),_vm._v(" "),_c('a',{staticClass:"new-reg",attrs:{"href":"http://i.yingxiong.com/pass/register"}},[_vm._v("新用户注册")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fci3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/17.ea2cf14.png";

/***/ }),

/***/ "fjgk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fk/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_js_user__ = __webpack_require__("xKOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_loading_loading__ = __webpack_require__("qqiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_basicMask_basicMask__ = __webpack_require__("/pyY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作

// lading 加载组件

// 基础弹出层组件

// 分页长度
var PAGE_SIZE = 10;
// 禁用词
// const DISABLE_WORDS = ['哈哈', '呵呵']
// 错误提示
var ERROR_TIPS = [{ desc: '网络错误' }, { desc: '评论内容不能为空且不能少于少于五个字' }, { desc: '有敏感词' }, { desc: '未知错误' }];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comment',
  data: function data() {
    return {
      // 屏蔽字标记
      // disableFlag: false,
      // 提示层开关
      tipsShow: false,
      // 提示信息
      tipsText: '',
      // 留言弹出层标志
      leavingFlag: false,
      // 禁止滚动加载数据
      busy: true,
      // 是否显示 loading 加载
      loading: false,
      // 评论信息
      commentInfo: '',
      // 地图信息
      mapInfo: '',
      // 分页提示信息
      loadMoreText: '向上滑动查看更多 ',
      // 点赞或评论标记 0 评论 1 点赞
      admireFlag: false,
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('SessionID'),
        // 用户 id
        accountId: this.$route.params.accountId,
        // 地图 id
        mapId: this.$route.params.mapId,
        // xxxid
        passKey: this.$route.params.passKey,
        // 评论内容
        leavingContent: '',
        // 当前分页
        page: 1,
        // 分页长度
        pageSize: PAGE_SIZE
      }
    };
  },

  computed: {
    // 评论或点赞 0 评论 1 点赞
    admireVal: function admireVal() {
      if (this.admireFlag) {
        return 1;
      } else {
        return 0;
      }
    }
  },
  created: function created() {
    // 页面加载初始化数据
    this.init();
  },
  mounted: function mounted() {
    var _this = this;

    // axios 前置拦截器
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(function (config) {
      // 显示 loading 提示层
      _this.loading = true;
      return config;
    });
    // axios 后置拦截器
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function (response) {
      // 关闭 loading 提示层
      _this.loading = false;
      return response;
    });
  },

  methods: {
    // 初始化
    init: function init() {
      // 加载评论数据
      this.getCommentInfoFn();
      // 获取地图数据
      this.getMapInfoFn();
    },

    // 添加留言
    addLeavingFn: function addLeavingFn() {
      var _this2 = this;

      // 打开留言弹出层
      this.leavingFlag = true;
      // 弹出显示完毕后
      this.$nextTick(function () {
        // 获取留言输入框的焦点
        _this2.$refs.leavingText.focus();
      });
    },

    // 关闭浏览弹出层
    colseLeavingFn: function colseLeavingFn() {
      this.leavingFlag = false;
    },

    // 获取地图相关信息
    getMapInfoFn: function getMapInfoFn() {
      var _this3 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('userId', this.formDatas.userId);
      // 将session id表单
      formData.append('sessionId', this.formDatas.sessionId);
      // 用户 id
      formData.append('AccountId', this.formDatas.accountId);
      // 地图 id
      formData.append('MapId', this.formDatas.mapId);
      // xxxid
      formData.append('PassKey', this.formDatas.passKey);
      // 当前分页
      formData.append('pageIndex', this.formDatas.page);
      // 分页长度
      formData.append('pageSize', this.formDatas.pageSize);
      // 获取地图信息 api
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$api.root + '/MapReview/GetMapInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              _this3.mapInfo = res;
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_2_assets_js_user__["a" /* delUserCookie */])();
              // 返回登录页面
              _this3.$router.push({ name: 'login' });
              break;
            case 2:
              // 获取错误信息
              _this3.tipsText = res.Msg;
              // 提示层开关
              _this3.tipsShow = true;
              break;
            default:
              // 获取错误信息
              _this3.tipsText = ERROR_TIPS[0].desc;
              // 提示层开关
              _this3.tipsShow = true;
          }
        }
      }).catch(function (error) {
        // 获取错误信息
        _this3.tipsText = ERROR_TIPS[0].desc;
        // 提示层开关
        _this3.tipsShow = true;
        console.log(error);
      });
    },

    // 获取评论信息
    getCommentInfoFn: function getCommentInfoFn(flag) {
      var _this4 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('userId', this.formDatas.userId);
      // 将session id表单
      formData.append('sessionId', this.formDatas.sessionId);
      // 用户 id
      formData.append('AccountId', this.formDatas.accountId);
      // 地图 id
      formData.append('MapId', this.formDatas.mapId);
      // xxxid
      formData.append('PassKey', this.formDatas.passKey);
      // 当前分页
      formData.append('pageIndex', this.formDatas.page);
      // 分页长度
      formData.append('pageSize', this.formDatas.pageSize);
      // 请求评论信息 api
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$api.root + '/MapReview/GetReviewList', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // this.commentInfo = res.ItemList
              // 分页调用
              if (flag) {
                if (res.ItemList !== null) {
                  // 分页数据累加
                  _this4.commentInfo = _this4.commentInfo.concat(res.ItemList);
                  // 如果没有数据了
                  if (res.ItemList.length === 0) {
                    // 禁止滚动加载数据
                    _this4.busy = true;
                    // 修改提示信息
                    _this4.loadMoreText = '没有更多评论了';
                    // 如果有数据
                  } else {
                    // 开启滚动加载数据
                    _this4.busy = false;
                  }
                }
                // 其他调用
              } else {
                // 将数据赋值到属性
                _this4.commentInfo = res.ItemList;
                // 开启滚动加载数据
                _this4.busy = false;
              }
              break;
            case 1:
              // 删除登录信息
              // delUserCookie()
              // this.$router.push({name: 'login'})
              break;
            case 2:
              // 获取错误信息
              _this4.tipsText = res.Msg;
              // 提示层开关
              _this4.tipsShow = true;
              break;
            default:
              // 获取错误信息
              _this4.tipsText = ERROR_TIPS[3].desc;
              // 提示层开关
              _this4.tipsShow = true;
          }
        }
      }).catch(function (error) {
        // 获取错误信息
        _this4.tipsText = ERROR_TIPS[0].desc;
        // 提示层开关
        _this4.tipsShow = true;
        console.log(error);
      });
    },

    // 分页加载
    loadMore: function loadMore() {
      var _this5 = this;

      // 禁止滚动加载
      this.busy = true;

      setTimeout(function () {
        // 分页自增
        _this5.formDatas.page++;
        // 加载商品数据
        _this5.getCommentInfoFn(true);
      }, 500);
    },

    // 回复评论
    subCommentFn: function subCommentFn() {
      var _this6 = this;

      // 评论不能为空且不能少于五个字
      if (this.formDatas.leavingContent !== '' && this.formDatas.leavingContent.length >= 5) {
        /*
        for (let i = 0; i < DISABLE_WORDS.length; i++) {
          // 有过滤词汇
          if (this.formDatas.leavingContent.indexOf(DISABLE_WORDS[i]) >= 0) {
            // 有屏蔽的关键词
            this.disableFlag = true
            // 错误提示
            this.tipsText = ERROR_TIPS[2].desc
            // 提示层开关
            this.tipsShow = true
            break
          // 过滤词检测通过
          } else {
            // 取消屏蔽字标记
            this.disableFlag = false
          }
        }
        */
        // 实例化表单对象
        var formData = new FormData();
        // 将用户名添加到表单
        formData.append('userId', this.formDatas.userId);
        // 将session id表单
        formData.append('sessionId', this.formDatas.sessionId);
        // 用户 id
        formData.append('AccountId', this.formDatas.accountId);
        // 地图 id
        formData.append('MapId', this.formDatas.mapId);
        // xxxid
        formData.append('PassKey', this.formDatas.passKey);
        // 评论内容
        formData.append('Content', this.formDatas.leavingContent);
        // 评论或点赞 0 评论 1 点赞
        formData.append('ReviewType', 0);
        // 评论的同时是否点赞
        formData.append('AdmireNum', this.admireVal);
        // 评论 api
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$api.root + '/MapReview/CreateReview', formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            var res = response.data;
            switch (res.Code) {
              case 0:
                _this6.leavingFlag = false;
                // 清空留言
                _this6.formDatas.leavingContent = '';
                // 初始化分页
                _this6.formDatas.page = 1;
                // 加载评论数据
                _this6.init();
                break;
              case 1:
                // 删除登录信息
                Object(__WEBPACK_IMPORTED_MODULE_2_assets_js_user__["a" /* delUserCookie */])();
                _this6.$router.push({ name: 'login' });
                break;
              case 2:
                // 获取错误信息
                _this6.tipsText = res.Msg;
                // 提示层开关
                _this6.tipsShow = true;
                break;
              default:
                // 获取错误信息
                _this6.tipsText = ERROR_TIPS[3].desc;
                // 提示层开关
                _this6.tipsShow = true;
            }
          }
        }).catch(function (error) {
          // 获取错误信息
          _this6.tipsText = ERROR_TIPS[0].desc;
          // 提示层开关
          _this6.tipsShow = true;
          console.log(error);
        });
      } else {
        // 错误提示
        this.tipsText = ERROR_TIPS[1].desc;
        // 提示层开关
        this.tipsShow = true;
      }
    },

    // 关闭提示层
    closeMaskEvFn: function closeMaskEvFn(val) {
      // 关闭弹出层
      this.tipsShow = val;
    }
  },
  components: {
    'v-loading': __WEBPACK_IMPORTED_MODULE_3_components_loading_loading__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_4_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 配置API接口地址
/* harmony default export */ __webpack_exports__["a"] = ({
  // api接口地址
  root: "http://developerinnerapism.xs-servers.com",
  // 图片服务器接口地址
  upload: "http://developerinnerapism.xs-servers.com"
});

/***/ }),

/***/ "hfl/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iGyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_core_image_upload__ = __webpack_require__("ngqk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_js_user__ = __webpack_require__("xKOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_basicMask_basicMask__ = __webpack_require__("/pyY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件

// 图片上传组件

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作

// 遮罩提示层


/* harmony default export */ __webpack_exports__["a"] = ({
  // 测试区地图审核页面
  name: 'devMapinspect',
  data: function data() {
    return {
      // 匹配模式
      tempInfo: '',
      // 创建时间
      createTime: '',
      // 提交时间
      submitTime: '',
      // 地图信息
      mapInfo: '',
      // 地图id
      mapId: this.$route.params.mapId,
      // 地图进行阶段
      stage: this.$route.params.stage,
      // 请求地图信息接口
      apiPath: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('SessionID')
      },
      // 默认显示图片
      defaultPic: '/static/img/default-main-image.png'
    };
  },

  computed: {
    setpText: function setpText() {
      switch (this.stage) {
        // 设置开发阶段的获取地图信息接口和撤销审核申请接口
        case 'dev':
          return '开发';
        // 设置测试阶段的获取地图信息接口和撤销审核申请接口
        case 'exa':
          return '测试';
        // 设置正式阶段的获取地图信息接口和撤销审核申请接口
        case 'pub':
          return '正式';
        default:
          return '未知';
      }
    }
  },
  created: function created() {
    console.log(this.$route.params);
    this.init();
  },

  methods: {
    // 初始化数据
    init: function init() {
      var _this = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图id
      formData.append('MapId', this.mapId);
      // 请求地图详细信息 api
      switch (this.stage) {
        // 设置开发阶段的获取地图信息接口和撤销审核申请接口
        case 'dev':
          this.apiPath = '/Developer/GetMapDevInfo';
          break;
        // 设置测试阶段的获取地图信息接口和撤销审核申请接口
        case 'exa':
          this.apiPath = '/Developer/GetMapExaInfo';
          break;
        // 设置正式阶段的获取地图信息接口和撤销审核申请接口
        case 'pub':
          this.apiPath = '/Developer/GetMapPubInfo';
          break;
        default:
          console.log('开发阶段匹配错误');
      }
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('' + this.$api.root + this.apiPath, formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 请求地图详细信息 api
              switch (_this.stage) {
                // 设置开发阶段的获取地图信息接口和撤销审核申请接口
                case 'dev':
                  // 将地图信息赋值到对象属性
                  _this.mapInfo = res.DevInfo;
                  // 创建时间
                  _this.createTime = res.CreateTime;
                  // 提交时间
                  _this.submitTime = res.SubmitTime;
                  // 获取匹配模式
                  if (res.TeamList[0]) {
                    _this.tempInfo = res.TeamList[0];
                  }
                  break;
                // 设置测试阶段的获取地图信息接口和撤销审核申请接口
                case 'exa':
                  // 将地图信息赋值到对象属性
                  _this.mapInfo = res.ExaInfo;
                  // 创建时间
                  _this.createTime = res.CreateTime;
                  // 提交时间
                  _this.submitTime = res.SubmitTime;
                  // 获取匹配模式
                  if (res.TeamList[0]) {
                    _this.tempInfo = res.TeamList[0];
                  }
                  break;
                // 设置正式阶段的获取地图信息接口和撤销审核申请接口
                case 'pub':
                  // 获取匹配模式
                  _this.tempInfo = res.TeamList;
                  // 创建时间
                  _this.createTime = res.CreateTime;
                  // 提交时间
                  _this.submitTime = res.SubmitTime;
                  // 将地图信息赋值到对象属性
                  if (res.TeamList[0]) {
                    _this.tempInfo = res.TeamList[0];
                  }
                  break;
                default:
                  console.log('开发阶段匹配错误');
              }
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */],
    'vue-core-image-upload': __WEBPACK_IMPORTED_MODULE_1_vue_core_image_upload__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_5_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "iJuZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"comment"},[_c('dl',{staticClass:"map-info-box"},[_c('dt',{staticClass:"title clearfix"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"right"},[_c('span',{staticClass:"item"},[_vm._v(_vm._s(_vm.mapInfo.MapName))]),_vm._v(" "),_c('span',{staticClass:"item"},[_vm._v("作者昵称："+_vm._s(_vm.mapInfo.Developer))])])]),_vm._v(" "),_c('dd',{staticClass:"info"},[_c('span',{staticClass:"item"},[_vm._v("地图ID："+_vm._s(_vm.mapInfo.MapId))]),_vm._v(" "),_c('span',{staticClass:"item"},[_vm._v("作者ID："+_vm._s(_vm.mapInfo.DeveloperId))])]),_vm._v(" "),_c('dd',{staticClass:"time"},[_c('span',{staticClass:"item"}),_vm._v(" "),_c('span',{staticClass:"item"},[_vm._v("创建日期："+_vm._s(_vm.mapInfo.CreateTime))])])]),_vm._v(" "),_c('dl',{staticClass:"comment-info-box"},[_c('dt',{staticClass:"comment-info"},[_c('i',{staticClass:"icon-comment"}),_vm._v(" "),_c('span',{staticClass:"item"},[_vm._v("评论")]),_vm._v(" "),_c('span',{staticClass:"item"},[_vm._v("留言数："+_vm._s(_vm.mapInfo.ReviewNum))])]),_vm._v(" "),_c('dd',{staticClass:"leaving-count"},[_c('span',[_vm._v("点赞数："+_vm._s(_vm.mapInfo.AdmireNum))])]),_vm._v(" "),_c('dd',{staticClass:"leaving-btn-box"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.addLeavingFn}},[_c('span',{staticClass:"text"},[_vm._v("发布评论")])])])]),_vm._v(" "),_c('ul',{staticClass:"leaving-list"},_vm._l((_vm.commentInfo),function(item){return _c('li',{staticClass:"list-item clearfix"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"top"},[_c('span',[_vm._v(_vm._s(item.NickName))]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(item.CreateTimeStr))]),_vm._v(" "),_c('a',{staticClass:"fabulous-btn",attrs:{"href":"javascript: void(0)"}},[_c('i',{class:{ 'icon-fabulous-blue' : item.AdmireNum === 1 }})])]),_vm._v(" "),_c('p',{staticClass:"bottom"},[_vm._v(_vm._s(item.Content))])])])})),_vm._v(" "),_c('p',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"load-more more",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"10"}},[_vm._v(_vm._s(_vm.loadMoreText)+" ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.leavingFlag),expression:"leavingFlag"}],staticClass:"add-leaving-box"},[_c('h3',{staticClass:"title"},[_c('a',{staticClass:"go-back",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.colseLeavingFn}},[_c('i',{staticClass:"icon-go-back"})]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("添加评论")]),_vm._v(" "),_c('a',{staticClass:"release",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.subCommentFn}},[_vm._v("发布")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',{staticClass:"desc"},[_vm._v("\n        是否为游戏点赞：\n        "),_c('i',{class:_vm.admireFlag ? 'icon-fabulous-blue' : 'icon-fabulous-yellow',attrs:{"onselectstart":"return false"},on:{"click":function($event){_vm.admireFlag = !_vm.admireFlag}}})]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.leavingContent),expression:"formDatas.leavingContent"}],ref:"leavingText",staticClass:"leaving-content",attrs:{"placeholder":"请写下您的宝贵意见","maxlength":"100"},domProps:{"value":(_vm.formDatas.leavingContent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formDatas, "leavingContent", $event.target.value)}}})])]),_vm._v(" "),_c('v-loading',{attrs:{"show":_vm.loading}}),_vm._v(" "),_c('v-basic-mask',{attrs:{"show":_vm.tipsShow},on:{"closeMaskEv":_vm.closeMaskEvFn}},[_c('span',{attrs:{"slot":"desc"},slot:"desc"},[_vm._v(_vm._s(_vm.tipsText))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"left"},[_c('img',{staticClass:"image",attrs:{"src":__webpack_require__("DKKg"),"alt":"头像"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('img',{staticClass:"image",attrs:{"src":__webpack_require__("DKKg"),"alt":"头像"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iQe6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "j6jB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kExR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pub-mapinspect"},[_c('v-login-info'),_vm._v(" "),_c('div',{staticClass:"form-content"},[_c('h1',{staticClass:"map-title"},[_vm._v("地图MOD正式区审核")]),_vm._v(" "),_c('form',{attrs:{"action":"javascript: void(0)"}},[_c('dl',{staticClass:"form-box"},[_c('dt',{staticClass:"title"},[_vm._v("地图ID：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_vm._v(_vm._s(_vm.mapInfo.MapId))])]),_vm._v(" "),_c('dl',{staticClass:"form-box"},[_c('dt',{staticClass:"title"},[_vm._v("地图名字：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapName),expression:"mapName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"map-name",attrs:{"name":"mapName","type":"text"},domProps:{"value":(_vm.mapName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mapName=$event.target.value}}})])]),_vm._v(" "),_c('dl',{staticClass:"form-box form-box-tag clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏标签：")]),_vm._v(" "),_c('dd',{staticClass:"tag-content clearfix"},[_c('ul',{staticClass:"tag-list-box"},_vm._l((_vm.tags),function(item,index){return _c('li',{staticClass:"tag"},[_vm._v("\n              "+_vm._s(item)+"\n              "),_c('a',{staticClass:"close-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delTagFn(index)}}},[_c('i',{staticClass:"icon-close"})])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tagAddFlag),expression:"tagAddFlag"}],staticClass:"add-tag-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tagVal),expression:"tagVal"}],ref:"addTagInput",staticClass:"add-tag-input",attrs:{"type":"text","maxlength":"3"},domProps:{"value":(_vm.tagVal)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.addTagFn($event)},"input":function($event){if($event.target.composing){ return; }_vm.tagVal=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"add-tag-btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.addTagFn}},[_vm._v("添加")])]),_vm._v(" "),_c('p',{staticClass:"tag-desc"},[_vm._v("可以填写最多三个标签，每个标签3个字")])])]),_vm._v(" "),_c('dl',{staticClass:"form-box game-desc clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏介绍：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapDesc),expression:"mapDesc"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"desc",attrs:{"name":"gameDesc","maxlength":"500"},domProps:{"value":(_vm.mapDesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mapDesc=$event.target.value}}},[_vm._v("游戏介绍")])])]),_vm._v(" "),_c('dl',{staticClass:"form-box game-desc clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("更细内容：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapUpdate),expression:"mapUpdate"}],staticClass:"desc",attrs:{"name":"contentUpdate","maxlength":"300"},domProps:{"value":(_vm.mapUpdate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mapUpdate=$event.target.value}}},[_vm._v("更细介绍")])])]),_vm._v(" "),_c('p',{staticClass:"main-ganme-desc"},[_c('span',[_vm._v("游戏主图：")]),_vm._v("\n        请上传1张截图支持JPG格式。截图尺寸要求：必须为306*172，单张图片不能超过1M。\n        "),_c('a',{staticClass:"demo",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.demo1Fn}},[_vm._v("\n          查看示例\n          "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.demoFlag1),expression:"demoFlag1"}],staticClass:"demo-image1",attrs:{"src":__webpack_require__("L4vx"),"alt":"示例"}})])]),_vm._v(" "),_c('div',{staticClass:"game-pic"},[_c('ul',{staticClass:"pic-list-box pic-list1 clearfix"},[_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 0)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[0].picture ? _vm.picList[0].picture : _vm.defaultPic,"alt":"上传主图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[0].picture),expression:"!picList[0].picture"}],staticClass:"upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":306,"maxHeight":172,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"imageuploading":_vm.imageuploading,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[0].picture),expression:"picList[0].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(0)}}},[_vm._v("删除图片")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageLoadingFlag),expression:"imageLoadingFlag"}],staticClass:"upload-image-loading"},[_c('img',{staticClass:"loading-svg",attrs:{"src":"/static/loading/loading-spinning-bubbles.svg","alt":"加载中"}})])],1)]),_vm._v(" "),_c('li',{staticClass:"item"}),_vm._v(" "),_c('li',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"pic-list"},[_c('p',{staticClass:"pic-desc"},[_vm._v("游戏截图：请上传3—5张截图。")]),_vm._v(" "),_c('p',{staticClass:"pic-desc pic-demo-box"},[_c('span',[_vm._v("截请上传3-5张截图支持JPG格式。截图尺寸要求：必须为800*450，单张图片不能超过1M。")]),_vm._v(" "),_c('a',{staticClass:"demo",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.demo2Fn}},[_vm._v("\n              查看示例\n              "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.demoFlag2),expression:"demoFlag2"}],staticClass:"demo-image2",attrs:{"src":__webpack_require__("L4vx"),"alt":"示例"}})])]),_vm._v(" "),_c('ul',{staticClass:"pic-list-box pic-list1 clearfix"},[_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 1)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[1].picture ? _vm.picList[1].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[1].picture),expression:"!picList[1].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[1].picture),expression:"picList[1].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(1)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 2)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[2].picture ? _vm.picList[2].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[2].picture),expression:"!picList[2].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[2].picture),expression:"picList[2].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(2)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 3)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[3].picture ? _vm.picList[3].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[3].picture),expression:"!picList[3].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[3].picture),expression:"picList[3].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(3)}}},[_vm._v("删除图片")])],1)])]),_vm._v(" "),_c('ul',{staticClass:"pic-list-box pic-list2 clearfix"},[_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 4)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[4].picture ? _vm.picList[4].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[4].picture),expression:"!picList[4].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[4].picture),expression:"picList[4].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(4)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 5)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[5].picture ? _vm.picList[5].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[5].picture),expression:"!picList[5].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[5].picture),expression:"picList[5].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(5)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item"})])])]),_vm._v(" "),_c('p',{staticClass:"on-line-info"},[_vm._v("\n        您的测试区版本上线日期：2017-10-31  1:00:00\n        "),_c('span',[_vm._v("版本号："+_vm._s(_vm.mapVersion))])]),_vm._v(" "),_c('p',{staticClass:"errot-desc"},[_vm._v(_vm._s(_vm.formErrot))]),_vm._v(" "),_c('div',{staticClass:"submit-examine"},[_c('a',{staticClass:"submit-examine-btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.mapSubexamine}},[_vm._v("提交审核")])])])]),_vm._v(" "),_c('v-basic-mask',{ref:"basicMask",attrs:{"show":_vm.maskFlag},on:{"closeMaskEv":_vm.closeMaskFn}},[_c('span',{attrs:{"slot":"desc"},slot:"desc"},[_vm._v(_vm._s(_vm.uploadPicTps))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kJAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kOlq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-3-image-1.1d55793.png";

/***/ }),

/***/ "kcYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"g-core-image-upload-btn"},[_vm._t("default",[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasImage),expression:"!hasImage"}],staticClass:"g-core-image-upload-form",staticStyle:{"display":"block","cursor":"pointer","position":"absolute","left":"0px","top":"0px","width":"1242px","height":"61px","opacity":"0","margin":"0px","padding":"0px","overflow":"hidden"},attrs:{"method":"post","enctype":"multipart/form-data","action":"/api2/common_user/cropHeadUrl"}},[_c('input',{staticStyle:{"width":"100%","height":"100%"},attrs:{"disabled":_vm.uploading,"id":'g-core-upload-input-' + _vm.formID,"name":_vm.name,"multiple":_vm.multiple,"type":"file","accept":_vm.inputAccept},on:{"change":_vm.change,"dragover":_vm.dragover,"dragenter":_vm.dragover,"dragleave":_vm.dragleave,"dragend":_vm.dragleave,"drop":_vm.dragleave}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasImage),expression:"hasImage"}],staticClass:"g-core-image-corp-container",attrs:{"id":'vciu-modal-' + _vm.formID}},[_c('crop',{ref:"cropBox",attrs:{"is-resize":_vm.resize && !_vm.crop,"ratio":_vm.cropRatio,"is-rotate":_vm.rotate}}),_vm._v(" "),_c('div',{staticClass:"info-aside"},[_c('p',{staticClass:"btn-groups rotate-groups",staticStyle:{"display":"none"}},[_c('button',{staticClass:"btn btn-rotate",attrs:{"type":"button"},on:{"click":_vm.doRotate}},[_vm._v("↺")]),_vm._v(" "),_c('button',{staticClass:"btn btn-reverserotate",attrs:{"type":"button"},on:{"click":_vm.doReverseRotate}},[_vm._v("↻")])]),_vm._v(" "),(_vm.crop)?_c('p',{staticClass:"btn-groups"},[_c('button',{staticClass:"btn btn-upload",attrs:{"type":"button"},on:{"click":_vm.doCrop}},[_vm._v(_vm._s(_vm.cropBtn.ok))]),_vm._v(" "),_c('button',{staticClass:"btn btn-cancel",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cropBtn.cancel))])]):_vm._e(),_vm._v(" "),(_vm.resize && !_vm.crop)?_c('p',{staticClass:"btn-groups"},[_c('button',{staticClass:"btn btn-upload",attrs:{"type":"button"},on:{"click":_vm.doResize}},[_vm._v(_vm._s(_vm.ResizeBtn.ok))]),_vm._v(" "),_c('button',{staticClass:"btn btn-cancel",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.ResizeBtn.cancel))])]):_vm._e()])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kf4d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l6Hr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"developer-header"},[_c('header',{staticClass:"head"},[_c('h1',{staticClass:"logo-box"},[_c('a',{staticClass:"logo-link",attrs:{"href":"#"}},[_c('img',{staticClass:"logo-image",attrs:{"src":__webpack_require__("z4Eo"),"alt":"logo"}})])]),_vm._v(" "),_c('p',{staticClass:"head-desc"},[_vm._v("创造与魔法开发者管理系统")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lTBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerAgreement_vue__ = __webpack_require__("IX/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8ec3ee6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerAgreement_vue__ = __webpack_require__("Fmar");
function injectStyle (ssrContext) {
  __webpack_require__("11ap")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerAgreement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8ec3ee6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerAgreement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lW1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_income_vue__ = __webpack_require__("nuWx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de17e626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_income_vue__ = __webpack_require__("UuNB");
function injectStyle (ssrContext) {
  __webpack_require__("Du0Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_income_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de17e626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_income_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lZHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_core_image_upload__ = __webpack_require__("ngqk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_js_user__ = __webpack_require__("xKOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_basicMask_basicMask__ = __webpack_require__("/pyY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件

// 图片上传组件

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作

// 遮罩提示层

var ERROR_TIPS = [{ desc: '表单验证失败' }, { desc: '最少上传3张游戏截图' }, { desc: '网络错误' }, { desc: '请上传游戏主图' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  // 测试区地图审核页面
  name: 'devMapinspect',
  data: function data() {
    return {
      // 遮罩层
      maskFlag: false,
      // 上传图片时的错误信息
      uploadPicTps: '',
      // loading 加载层开关
      imageLoadingFlag: false,
      // 地图版本信息
      mapVersion: '',
      // 游戏类型
      mapType: 1,
      // 地图信息
      mapInfo: '',
      // 地图id
      mapId: this.$route.params.mapId,
      // 地图进行阶段
      stage: this.$route.params.stage,
      // 请求地图信息接口
      apiPath: '',
      // 地图标签
      tags: [],
      // 添加地图标标签输入框默认值
      tagVal: '',
      // 地图名称
      mapName: '',
      // 地图描述
      mapDesc: '',
      // 地图更新内容
      mapUpdate: '',
      // 图片demo1
      demoFlag1: false,
      // 图片demo2
      demoFlag2: false,
      // 表单错误信息
      formErrot: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('SessionID')
      },
      // 默认显示图片
      defaultPic: '/static/img/default-image.png',
      // 上传图片信息列表
      picList: [{ picture: '' }, { picture: '' }, { picture: '' }, { picture: '' }, { picture: '' }, { picture: '' }],
      // 图片上传参数列表
      picData: {
        // 用户id
        UserID: '',
        // session id
        SessionID: '',
        // 地图进度阶段id
        Stage: '',
        // 地图 id
        MapStageId: '',
        // 地图索引
        PictureIndex: '',
        // 上传地图后要替换的图片位置
        picReplace: ''
      }
    };
  },

  computed: {
    // 地图标签输入框 显示\隐藏 标志
    tagAddFlag: function tagAddFlag() {
      if (this.tags.length >= 3) {
        return false;
      } else {
        return true;
      }
    },

    // 计算上传图片的数量
    countPicList: function countPicList() {
      var tempArr = [];
      // 过滤
      this.picList.forEach(function (item, index) {
        // 跳过游戏主图
        if (index !== 0) {
          if (item.picture !== '') {
            tempArr.push(item);
          }
        }
      });
      // 返回过滤后数组的长度
      return tempArr.length;
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    // 初始化数据
    init: function init() {
      var _this = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图id
      formData.append('MapId', this.mapId);
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/Developer/GetMapDevInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 将地图信息赋值到对象属性
              _this.mapInfo = res.DevInfo;
              // 游戏主图
              _this.picList[0].picture = _this.mapInfo.MainPicture;
              // 获取图片默认地址
              _this.picList[1].picture = _this.mapInfo.Picture1;
              _this.picList[2].picture = _this.mapInfo.Picture2;
              _this.picList[3].picture = _this.mapInfo.Picture3;
              _this.picList[4].picture = _this.mapInfo.Picture4;
              _this.picList[5].picture = _this.mapInfo.Picture5;
              // 设置地图当前进行阶段的id
              _this.picData.MapStageId = _this.mapInfo.Id;
              // 设置图片上传时的地图进行阶段id
              _this.picData.Stage = _this.stage;
              // 地图名称
              _this.mapName = _this.mapInfo.MapName;
              // 地图描述信息
              _this.mapDesc = _this.mapInfo.Note;
              // 地图更新内容
              _this.mapUpdate = _this.mapInfo.UpdateContent;
              // 地图版本你信息
              _this.mapVersion = _this.mapInfo.MapVersion;
              // 如果标签不是为空
              if (_this.mapInfo.MapTag !== null) {
                // 将字符串拆分成数组
                _this.tags = _this.mapInfo.MapTag.split(',');
              }
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 图片上传回调函数
    imageuploaded: function imageuploaded(res) {
      switch (res.Code) {
        case 0:
          // 关闭图片上传 loading 加载层
          this.imageLoadingFlag = false;
          // 将返回的图片地址设置到图片上
          this.picReplace[0].src = res.ImgUrl;
          // 对数组中的图片信息进行赋值
          this.picList[this.picData.PictureIndex].picture = res.ImgUrl;
          // 清空错误信息
          this.formErrot = '';
          break;
        case 1:
          // 删除登录信息
          Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
          this.$router.push({ name: 'login' });
          break;
        case 2:
          // 弹出错误提示信息
          // this.uploadPicTps = res.Msg
          // 弹出提示层
          // this.maskFlag = true
          this.formErrot = res.Msg;
          break;
        default:
          // 其他错误
          this.formErrot = res.Msg;
          console.log(res.Code);
          console.log(res.Msg);
      }
    },

    // 图片上传过程中
    imageuploading: function imageuploading() {
      // 打开 loading 加载层
      this.imageLoadingFlag = true;
    },

    // 文件上传时出现错误
    errorhandle: function errorhandle(error) {
      // 检查错误
      switch (error) {
        case 'FILE IS TOO LARGER MAX FILE IS 1.00MB':
          this.uploadPicTps = '文件大小不能超过1M';
          break;
        case 'access_denied':
          this.uploadPicTps = '网络错误';
          break;
        default:
          this.uploadPicTps = error;
      }
      // 弹出错误提示
      this.maskFlag = true;
    },

    // 关闭错误提示层
    closeMaskFn: function closeMaskFn() {
      this.maskFlag = false;
    },

    // 点击上传图片时设置参数
    picUploadFn: function picUploadFn(event, index) {
      // 设置图片索引
      this.picData.PictureIndex = index;
      // 设置上传参数用户id
      this.picData.UserID = this.formDatas.userId;
      // 设置上传参数 session id
      this.picData.SessionID = this.formDatas.sessionId;
      // 上传后替换图片的位置
      this.picReplace = event.currentTarget.getElementsByClassName('hook-item-pic');
    },

    // 删除图片
    delPicFn: function delPicFn(index) {
      var _this2 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图进行阶段
      formData.append('Stage', this.picData.Stage);
      // 地图进行阶段id
      formData.append('MapStageId', this.picData.MapStageId);
      // 图片索引
      formData.append('PictureIndex', index);
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.upload + '/Developer/DeleteMapPicture', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 清空图片信息
              _this2.picList[_this2.picData.PictureIndex].picture = '';
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this2.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 添加地图标签
    addTagFn: function addTagFn() {
      // 清空输入内容的空格
      var tag = this.tagVal.trim();
      // 如果地图标签有内容输入
      if (tag !== '') {
        // 添加到数组
        this.tags.push(this.tagVal);
        // 清空输入框
        this.tagVal = '';
        // 获取输入框焦点
        this.$refs.addTagInput.focus();
      }
    },

    // 删除地图标签
    delTagFn: function delTagFn(index) {
      // console.log(index)
      this.tags.splice(index, 1);
    },

    // 地图提交审核
    mapSubexamine: function mapSubexamine() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        // 表单是否有错误信息
        var isError = _this3.errors.any();
        if (isError) {
          // 获取所有错误信息的数组列表
          var formErrors = _this3.$validator.errors.all();
          // 返回第一个错误信息
          _this3.formErrot = formErrors[0];
        } else {
          if (_this3.picList[0].picture !== '') {
            // 判断上传游戏截图的数量
            if (_this3.countPicList >= 3) {
              // 实例化表单对象
              var formData = new FormData();
              // 将用户名添加到表单
              formData.append('UserID', _this3.formDatas.userId);
              // 将密码添加到表单
              formData.append('SessionID', _this3.formDatas.sessionId);
              // 地图id
              formData.append('MapId', _this3.mapId);
              // 地图名称
              formData.append('MapName', _this3.mapName);
              // 地图进行阶段
              formData.append('Stage', _this3.picData.Stage);
              // 地图标签
              formData.append('MapTag', _this3.tags.join(','));
              // 地图进行阶段id
              formData.append('MapStageId', _this3.picData.MapStageId);
              // 地图类型
              formData.append('MapType', _this3.mapType);
              // 地图描述
              formData.append('Note', _this3.mapDesc);
              // 更新内容
              formData.append('UpdateContent', _this3.mapUpdate);
              // 地图版本
              formData.append('MapVersion', _this3.mapInfo.MapVersion);
              // 请求地图详细信息 api
              __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$api.root + '/Developer/SubmitAuditDev', formData, {
                // 设置请求为表单提交
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then(function (response) {
                // http 请求成功
                if (response.status === 200) {
                  // 获取接口数据
                  var res = response.data;
                  switch (res.Code) {
                    case 0:
                      // 跳转到审核中页面
                      _this3.$router.push({ name: 'toExamine', params: { mapId: _this3.mapId, stage: _this3.stage } });
                      break;
                    case 1:
                      // 删除登录信息
                      Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
                      _this3.$router.push({ name: 'login' });
                      break;
                    default:
                      console.log(res.Code);
                      console.log(res.Msg);
                  }
                }
              }).catch(function (error) {
                _this3.formErrot = ERROR_TIPS[2].desc;
                console.log(error);
              });
            } else {
              // 提示上传图片数量的信息
              _this3.formErrot = ERROR_TIPS[1].desc;
            }
          } else {
            // 提示上传游戏主图
            _this3.formErrot = ERROR_TIPS[3].desc;
          }
        }
      }).catch(function () {
        _this3.formErrot = ERROR_TIPS[0].desc;
      });
    },

    // demo图示1
    demo1Fn: function demo1Fn() {
      this.demoFlag1 = !this.demoFlag1;
    },

    // demo图示2
    demo2Fn: function demo2Fn() {
      this.demoFlag2 = !this.demoFlag2;
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */],
    'vue-core-image-upload': __WEBPACK_IMPORTED_MODULE_1_vue_core_image_upload__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_5_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "laqr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lv+N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-2-image-3.62f76ab.png";

/***/ }),

/***/ "m16g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faqLeft_vue__ = __webpack_require__("uGtc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7774e8c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faqLeft_vue__ = __webpack_require__("Y8Ma");
function injectStyle (ssrContext) {
  __webpack_require__("nDd/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faqLeft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7774e8c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faqLeft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n3T7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"dev-mapinspect"},[_c('v-login-info'),_vm._v(" "),_c('div',{staticClass:"form-content"},[_c('h1',{staticClass:"map-title"},[_vm._v("地图MOD测试区审核")]),_vm._v(" "),_c('form',{attrs:{"action":"javascript: void(0)"}},[_c('dl',{staticClass:"form-box"},[_c('dt',{staticClass:"title"},[_vm._v("地图ID：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_vm._v(_vm._s(_vm.mapInfo.MapId))])]),_vm._v(" "),_c('dl',{staticClass:"form-box"},[_c('dt',{staticClass:"title"},[_vm._v("地图名字：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapName),expression:"mapName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"map-name",attrs:{"name":"mapName","type":"text"},domProps:{"value":(_vm.mapName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mapName=$event.target.value}}})])]),_vm._v(" "),_c('dl',{staticClass:"form-box form-box-tag clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏标签：")]),_vm._v(" "),_c('dd',{staticClass:"tag-content clearfix"},[_c('ul',{staticClass:"tag-list-box"},_vm._l((_vm.tags),function(item,index){return _c('li',{staticClass:"tag"},[_vm._v("\n              "+_vm._s(item)+"\n              "),_c('a',{staticClass:"close-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delTagFn(index)}}},[_c('i',{staticClass:"icon-close"})])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tagAddFlag),expression:"tagAddFlag"}],staticClass:"add-tag-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tagVal),expression:"tagVal"}],ref:"addTagInput",staticClass:"add-tag-input",attrs:{"type":"text","maxlength":"3"},domProps:{"value":(_vm.tagVal)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.addTagFn($event)},"input":function($event){if($event.target.composing){ return; }_vm.tagVal=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"add-tag-btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.addTagFn}},[_vm._v("添加")])]),_vm._v(" "),_c('p',{staticClass:"tag-desc"},[_vm._v("可以填写最多三个标签，每个标签3个字")])])]),_vm._v(" "),_c('dl',{staticClass:"form-box game-desc clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("游戏介绍：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapDesc),expression:"mapDesc"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"desc",attrs:{"name":"gameDesc","maxlength":"500"},domProps:{"value":(_vm.mapDesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mapDesc=$event.target.value}}},[_vm._v("游戏介绍")])])]),_vm._v(" "),_c('dl',{staticClass:"form-box game-desc clearfix"},[_c('dt',{staticClass:"title"},[_vm._v("更细内容：")]),_vm._v(" "),_c('dd',{staticClass:"content"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapUpdate),expression:"mapUpdate"}],staticClass:"desc",attrs:{"name":"contentUpdate","maxlength":"300"},domProps:{"value":(_vm.mapUpdate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mapUpdate=$event.target.value}}},[_vm._v("更细介绍")])])]),_vm._v(" "),_c('p',{staticClass:"main-ganme-desc"},[_c('span',[_vm._v("游戏主图：")]),_vm._v("\n        请上传1张截图支持JPG格式。截图尺寸要求：必须为306*172，单张图片不能超过1M。\n        "),_c('a',{staticClass:"demo",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.demo1Fn}},[_vm._v("\n          查看示例\n          "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.demoFlag1),expression:"demoFlag1"}],staticClass:"demo-image1",attrs:{"src":__webpack_require__("wc9d"),"alt":"示例"}})])]),_vm._v(" "),_c('div',{staticClass:"game-pic"},[_c('ul',{staticClass:"pic-list-box pic-list1 clearfix"},[_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 0)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[0].picture ? _vm.picList[0].picture : _vm.defaultPic,"alt":"上传主图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[0].picture),expression:"!picList[0].picture"}],staticClass:"upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":306,"maxHeight":174,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"imageuploading":_vm.imageuploading,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[0].picture),expression:"picList[0].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(0)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item"}),_vm._v(" "),_c('li',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"pic-list"},[_c('p',{staticClass:"pic-desc"},[_vm._v("游戏截图：请上传3—5张截图。")]),_vm._v(" "),_c('p',{staticClass:"pic-desc pic-demo-box"},[_c('span',[_vm._v("截请上传3-5张截图支持JPG格式。截图尺寸要求：必须为800*450，单张图片不能超过1M。")]),_vm._v(" "),_c('a',{staticClass:"demo",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.demo2Fn}},[_vm._v("\n              查看示例\n              "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.demoFlag2),expression:"demoFlag2"}],staticClass:"demo-image2",attrs:{"src":__webpack_require__("wc9d"),"alt":"示例"}})])]),_vm._v(" "),_c('ul',{staticClass:"pic-list-box pic-list1 clearfix"},[_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 1)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[1].picture ? _vm.picList[1].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[1].picture),expression:"!picList[1].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[1].picture),expression:"picList[1].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(1)}}},[_vm._v("删除图片")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageLoadingFlag),expression:"imageLoadingFlag"}],staticClass:"upload-image-loading"},[_c('img',{staticClass:"loading-svg",attrs:{"src":"/static/loading/loading-spinning-bubbles.svg","alt":"加载中"}})])],1)]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 2)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[2].picture ? _vm.picList[2].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[2].picture),expression:"!picList[2].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[2].picture),expression:"picList[2].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(2)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 3)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[3].picture ? _vm.picList[3].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[3].picture),expression:"!picList[3].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[3].picture),expression:"picList[3].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(3)}}},[_vm._v("删除图片")])],1)])]),_vm._v(" "),_c('ul',{staticClass:"pic-list-box pic-list2 clearfix"},[_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 4)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[4].picture ? _vm.picList[4].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[4].picture),expression:"!picList[4].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[4].picture),expression:"picList[4].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(4)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){_vm.picUploadFn($event, 5)}}},[_c('div',{staticClass:"item-pic-box"},[_c('img',{staticClass:"item-pic hook-item-pic upload-images",attrs:{"src":_vm.picList[5].picture ? _vm.picList[5].picture : _vm.defaultPic,"alt":"游戏截图"}}),_vm._v(" "),_c('vue-core-image-upload',{directives:[{name:"show",rawName:"v-show",value:(!_vm.picList[5].picture),expression:"!picList[5].picture"}],staticClass:"btn btn-primary upload-pic-btn pic-btn",attrs:{"text":"上传图片","data":_vm.picData,"maxFileSize":1048576,"inputOfFile":"FileName","extensions":"jpg","inputAccept":"image/jpg,image/jpeg","crop":"local","maxWidth":800,"maxHeight":450,"cropRatio":"16:9","url":((_vm.$api.upload) + "/Developer/UploadFile")},on:{"imageuploaded":_vm.imageuploaded,"errorhandle":_vm.errorhandle}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.picList[5].picture),expression:"picList[5].picture"}],staticClass:"del-pic-btn pic-btn",attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.delPicFn(5)}}},[_vm._v("删除图片")])],1)]),_vm._v(" "),_c('li',{staticClass:"item"})])])]),_vm._v(" "),_c('p',{staticClass:"on-line-info"},[_vm._v("\n        您的测试区版本上线日期：2017-10-31  1:00:00\n        "),_c('span',[_vm._v("版本号："+_vm._s(_vm.mapVersion))])]),_vm._v(" "),_c('p',{staticClass:"errot-desc"},[_vm._v(_vm._s(_vm.formErrot))]),_vm._v(" "),_c('div',{staticClass:"submit-examine"},[_c('a',{staticClass:"submit-examine-btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.mapSubexamine}},[_vm._v("提交审核")])])])]),_vm._v(" "),_c('v-basic-mask',{ref:"basicMask",attrs:{"show":_vm.maskFlag},on:{"closeMaskEv":_vm.closeMaskFn}},[_c('span',{attrs:{"slot":"desc"},slot:"desc"},[_vm._v(_vm._s(_vm.uploadPicTps))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nAmY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pdf',
  data: function data() {
    return {
      // pdf 打开路径
      url: '/static/pdfjs/web/viewer.html?file=' + this.$route.params.name + '.pdf'
    };
  },

  methods: {
    // 返回目录页面
    goBackFn: function goBackFn() {
      this.$router.push({ path: '/developmentFile/' + this.$route.params.pid });
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */]
  }
});

/***/ }),

/***/ "nDd/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nTJ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerStatus_vue__ = __webpack_require__("EsPj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaa0647_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerStatus_vue__ = __webpack_require__("ZrcC");
function injectStyle (ssrContext) {
  __webpack_require__("fjgk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developerStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaa0647_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developerStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nXej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"development-file"},[_c('v-login-info'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('nav',{staticClass:"nav"},[_c('span',{staticClass:"nav-home",on:{"click":function($event){_vm.cdDirFn(0)}}},[_vm._v("说明文档")]),_vm._v(" "),_vm._l((_vm.navList),function(item){return _c('span',{staticClass:"nav-item"},[_vm._v("/ "+_vm._s(item.text)+" /")])})],2),_vm._v(" "),_vm._l((_vm.listData),function(item,index){return _c('div',{staticClass:"dir-box"},[(item.type === 1)?_c('div',{staticClass:"dir-style",on:{"click":function($event){_vm.cdDirFn(item.id)}}},[_c('i',{staticClass:"icon-folder"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.text))])]):_c('div',{staticClass:"file-style",on:{"click":function($event){_vm.openFn(item.name, item.pid)}}},[_c('i',{staticClass:"icon-file-pdf"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.text))])])])})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ngqk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_core_image_upload_vue__ = __webpack_require__("qsOD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_26150c56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_core_image_upload_vue__ = __webpack_require__("kcYt");
function injectStyle (ssrContext) {
  __webpack_require__("nhDN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_core_image_upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_26150c56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_core_image_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nhDN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nuWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // 收入 faq
  name: 'income'
});

/***/ }),

/***/ "oecS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapShowStatus_vue__ = __webpack_require__("iGyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2cbcbb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapShowStatus_vue__ = __webpack_require__("ENjG");
function injectStyle (ssrContext) {
  __webpack_require__("qSLe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapShowStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2cbcbb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapShowStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "opPI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p83Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"create-server"},[_c('v-login-info'),_vm._v(" "),_c('div',{staticClass:"create-server-content"},[_c('h3',{staticClass:"create-server-title"},[_vm._v("创建服务器")]),_vm._v(" "),_c('form',{attrs:{"action":"javascript: void(0)"}},[_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"item-title"},[_vm._v("服务器名字：")]),_vm._v(" "),_c('dd',{staticClass:"item-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.severName),expression:"formDatas.severName"},{name:"validate",rawName:"v-validate",value:('required|min:2|max:7'),expression:"'required|min:2|max:7'"}],staticClass:"form-input server-name",attrs:{"name":"serverName","type":"text"},domProps:{"value":(_vm.formDatas.severName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formDatas, "severName", $event.target.value)}}})])]),_vm._v(" "),_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"item-title"},[_vm._v("游戏模式：")]),_vm._v(" "),_c('dd',{staticClass:"item-content"},[_c('div',{staticClass:"radio-item"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.rootType),expression:"formDatas.rootType"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"pve","name":"serverType","type":"radio","value":"false"},domProps:{"checked":_vm._q(_vm.formDatas.rootType,"false")},on:{"change":function($event){_vm.$set(_vm.formDatas, "rootType", "false")}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('span',[_vm._v("和平房间模式")])]),_vm._v(" "),_c('div',{staticClass:"radio-item"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.rootType),expression:"formDatas.rootType"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"pvp","name":"serverType","type":"radio","value":"true"},domProps:{"checked":_vm._q(_vm.formDatas.rootType,"true")},on:{"change":function($event){_vm.$set(_vm.formDatas, "rootType", "true")}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("混战房间模式")])])])]),_vm._v(" "),_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"item-title"},[_vm._v("密码设置：")]),_vm._v(" "),_c('dd',{staticClass:"item-content"},[_c('div',{staticClass:"radio-item"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.serverIsPwd),expression:"formDatas.serverIsPwd"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"noPwd","name":"pwd","type":"radio","value":"false"},domProps:{"checked":_vm._q(_vm.formDatas.serverIsPwd,"false")},on:{"change":function($event){_vm.$set(_vm.formDatas, "serverIsPwd", "false")}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("无密码")])]),_vm._v(" "),_c('div',{staticClass:"radio-item"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.serverIsPwd),expression:"formDatas.serverIsPwd"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"hasPwd","name":"pwd","type":"radio","value":"true"},domProps:{"checked":_vm._q(_vm.formDatas.serverIsPwd,"true")},on:{"change":function($event){_vm.$set(_vm.formDatas, "serverIsPwd", "true")}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("有密码")]),_vm._v(" "),_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.serverPwd),expression:"formDatas.serverPwd"}],staticClass:"server-pwd",attrs:{"type":"password"},domProps:{"value":(_vm.formDatas.serverPwd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formDatas, "serverPwd", $event.target.value)}}})])])])]),_vm._v(" "),_c('dl',{staticClass:"form-item clearfix"},[_c('dt',{staticClass:"item-title"},[_vm._v("公开房间列表:")]),_vm._v(" "),_c('dd',{staticClass:"item-content"},[_c('div',{staticClass:"radio-item radio-inline"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.serverIsPublic),expression:"formDatas.serverIsPublic"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"pub","name":"rootList","type":"radio","value":"true"},domProps:{"checked":_vm._q(_vm.formDatas.serverIsPublic,"true")},on:{"change":function($event){_vm.$set(_vm.formDatas, "serverIsPublic", "true")}}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("公开")])]),_vm._v(" "),_c('div',{staticClass:"radio-item radio-inline"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.serverIsPublic),expression:"formDatas.serverIsPublic"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"noPub","name":"rootList","type":"radio","value":"false"},domProps:{"checked":_vm._q(_vm.formDatas.serverIsPublic,"false")},on:{"change":function($event){_vm.$set(_vm.formDatas, "serverIsPublic", "false")}}}),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("不公开")])])])]),_vm._v(" "),_c('dl',{staticClass:"form-item server-type clearfix"},[_c('dt',{staticClass:"item-title"},[_vm._v("服务器套餐：")]),_vm._v(" "),_c('dd',{staticClass:"item-content"},[_c('div',{staticClass:"radio-item radio-inline"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.serverType),expression:"formDatas.serverType"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"small","name":"serverPackage","type":"radio","value":"1"},domProps:{"checked":_vm._q(_vm.formDatas.serverType,"1")},on:{"change":function($event){_vm.$set(_vm.formDatas, "serverType", "1")}}}),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("小型服")])]),_vm._v(" "),_c('div',{staticClass:"radio-item radio-inline"},[_c('span',{staticClass:"base-radio-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDatas.serverType),expression:"formDatas.serverType"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"base-radio",attrs:{"id":"middle","name":"serverPackage","type":"radio","value":"2"},domProps:{"checked":_vm._q(_vm.formDatas.serverType,"2")},on:{"change":function($event){_vm.$set(_vm.formDatas, "serverType", "2")}}}),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("中型服")])]),_vm._v(" "),_c('p',{staticClass:"ticket-desc"},[_vm._v("小型服务器最多可同时在线12人，中型服务器可同时在线50人。")]),_vm._v(" "),_c('div',{staticClass:"ticket-count"},[_c('span',[_vm._v("小型开服券 "+_vm._s(_vm.countTicket(1).length))]),_vm._v(" "),_c('span',[_vm._v("中型开服券 "+_vm._s(_vm.countTicket(2).length))])])])]),_vm._v(" "),_c('p',{staticClass:"error-tips"},[_vm._v(_vm._s(_vm.formErrot))]),_vm._v(" "),_c('div',{staticClass:"handle"},[_c('a',{staticClass:"btn",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.createServerFn}},[_vm._v("创建 ")])])])]),_vm._v(" "),_c('v-basic-mask',{attrs:{"show":_vm.tipsShow},on:{"closeMaskEv":_vm.closeMaskEvFn}},[_c('span',{attrs:{"slot":"desc"},slot:"desc"},[_vm._v(_vm._s(_vm.tipsText))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"icon-box",attrs:{"for":"pve"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"icon-box",attrs:{"for":"pvp"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"icon-box",attrs:{"for":"noPwd"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"icon-box",attrs:{"for":"hasPwd"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"icon-box",attrs:{"for":"pub"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"icon-box",attrs:{"for":"noPub"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"icon-box",attrs:{"for":"small"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"icon-box",attrs:{"for":"middle"}},[_c('i',{staticClass:"icon icon-radio-unchecked"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pEiu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'confirmMask',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  beforeUpdate: function beforeUpdate() {
    var _this = this;

    this.$nextTick(function () {
      // 初始化遮罩层的位置
      _this.init();
    });
  },

  methods: {
    init: function init() {
      // 获取弹出层内容
      var oConfirmMaskContent = this.$refs.confirmMaskContent;
      // 计算左边边距
      var left = oConfirmMaskContent.offsetWidth / 2;
      // 计算上边边距
      var top = oConfirmMaskContent.offsetHeight / 2;
      // 对边距进行赋值
      oConfirmMaskContent.style.marginLeft = -left + 'px';
      oConfirmMaskContent.style.marginTop = -top + 'px';
    },
    colseMask: function colseMask() {
      this.$emit('closeMaskEv', !this.show);
    }
  }
});

/***/ }),

/***/ "pLPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-info"},[_c('header',{staticClass:"head"},[_vm._t("goBack",[_c('a',{staticClass:"left clearfix",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.goBackFn}},[_c('i',{staticClass:"icon-left-arrow"})])]),_vm._v(" "),_c('div',{staticClass:"right clearfix"},[_c('span',{staticClass:"income",attrs:{"title":"收入功能正在研发中~"}},[_vm._v("我的收入：0")]),_vm._v(" "),_c('img',{staticClass:"head-pic",attrs:{"src":("/static/img/" + (_vm.loginInfo.headPic) + ".png"),"alt":"头像"}}),_vm._v(" "),_c('span',{staticClass:"head-name"},[_vm._v(_vm._s(_vm.loginInfo.userNmae))]),_vm._v(" "),_c('a',{staticClass:"handle",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.handleShowFn}},[_c('i',{staticClass:"icon icon-login-handle"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"move"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginFlag),expression:"loginFlag"}],staticClass:"login-handle"},[_c('ul',{staticClass:"login-handle-box",attrs:{"onselectstart":"return false"}},[_c('li',[_c('a',{staticClass:"item clearfix",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.logoutFn}},[_vm._v("注销")])])]),_vm._v(" "),_c('a',{staticClass:"close",on:{"click":_vm.handleHiddenFn}},[_c('i',{staticClass:"btn icon-cancel-circle"})])])])],2),_vm._v(" "),_c('v-loading',{attrs:{"show":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pY+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comment_vue__ = __webpack_require__("fk/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7947dd4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_comment_vue__ = __webpack_require__("iJuZ");
function injectStyle (ssrContext) {
  __webpack_require__("O2JA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7947dd4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q4Kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_rotate_bar_vue__ = __webpack_require__("D8rO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4819ebf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_rotate_bar_vue__ = __webpack_require__("WLJ0");
function injectStyle (ssrContext) {
  __webpack_require__("xRHL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_rotate_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4819ebf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_rotate_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qBkf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'language',
  created: function created() {
    // 匹配当前系统语言
    switch (window.navigator.language) {
      case 'zh-TW':
        // 繁体
        window.location.href = 'https://goo.gl/kaR9sk';
        break;
      case 'zh-CN':
        // 简体
        window.location.href = 'http://developer.zm.yingxiong.com/#/rootDoc';
        break;
      default:
        // 英文
        window.location.href = 'https://reurl.cc/q5lME';
    }
  }
});

/***/ }),

/***/ "qGuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_crop_vue__ = __webpack_require__("WVba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_002e6025_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_crop_vue__ = __webpack_require__("DJxX");
function injectStyle (ssrContext) {
  __webpack_require__("93t6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-002e6025"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_crop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_002e6025_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_crop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qLkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qSLe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qqiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__("iQe6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e21767e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__("145B");
function injectStyle (ssrContext) {
  __webpack_require__("ecrR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e21767e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qsOD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_image_xhr__ = __webpack_require__("doje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_image_xhr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_image_xhr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_loading_gif__ = __webpack_require__("HBWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lib_loading_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper__ = __webpack_require__("q+yL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props__ = __webpack_require__("X0k5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crop_vue__ = __webpack_require__("qGuT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue__ = __webpack_require__("Qfng");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var overflowVal = '';
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Crop: __WEBPACK_IMPORTED_MODULE_8__crop_vue__["a" /* default */],
    ResizeBar: __WEBPACK_IMPORTED_MODULE_9__resize_bar_vue__["a" /* default */]
  },
  props: __WEBPACK_IMPORTED_MODULE_7__props___default.a,
  data: function data() {
    return {
      files: [],
      hasImage: false,
      options: this.props,
      uploading: false,
      formID: (Math.random() * 10000 + '').split('.')[0],
      image: {
        src: __WEBPACK_IMPORTED_MODULE_5__lib_loading_gif___default.a,
        width: 24,
        height: 24,
        minProgress: 0.05
      }
    };
  },


  computed: {
    name: function name() {
      if (this.multiple) {
        return this.inputOfFile + '[]';
      }
      return this.inputOfFile;
    }
  },

  methods: {
    __dispatch: function __dispatch(name, res, data) {
      this.$emit && this.$emit(name, res, data);
    },
    __find: function __find(str) {
      var dq = document.querySelector('#vciu-modal-' + this.formID);
      return dq.querySelector(str);
    },
    dragover: function dragover() {
      var element = this.$refs.container;
      element.classList.add('is-dragover');
    },
    dragleave: function dragleave() {
      var element = this.$refs.container;
      element.classList.remove('is-dragover');
    },
    change: function change(e) {
      var _this = this;

      var fileVal = document.querySelector('#g-core-upload-input-' + this.formID).value.replace(/C:\\fakepath\\/i, "");
      var fileExt = fileVal.substring(fileVal.lastIndexOf(".") + 1);
      var extensionsArr = this.extensions.split(',');
      if (extensionsArr.length > 1) {
        var reg = new RegExp('^[' + extensionsArr.join('|') + ']+$', 'i');
        if (!reg.test(fileExt)) {
          return this.__dispatch('errorhandle', 'TYPE ERROR');
        }
      }
      if (e.target.files[0].size > this.maxFileSize) {
        var formatSize;
        if (parseInt(this.maxFileSize / 1024 / 1024) > 0) {
          formatSize = (this.maxFileSize / 1024 / 1024).toFixed(2) + 'MB';
        } else if (parseInt(this.maxFileSize / 1024) > 0) {
          formatSize = (this.maxFileSize / 1024).toFixed(2) + 'kB';
        } else {
          formatSize = options.maxFileSize.toFixed(2) + 'Byte';
        }
        console.warn('FILE IS TOO LARGER MAX FILE IS ' + formatSize);
        return this.__dispatch('errorhandle', 'FILE IS TOO LARGER MAX FILE IS ' + formatSize);
      }

      this.files = e.target.files;
      if (this.crop || this.resize) {
        this.__showImage();
        return;
      }
      this.__dispatch('imagechanged', this.files.length > 1 ? this.files : this.files[0]);
      if (this.compress && this.files[0]['type'] !== 'image/png' && this.files[0]['type'] !== 'image/gif') {
        __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.compress(this.files[0], 100 - this.compress, function (code) {
          _this.tryAjaxUpload('', true, code);
        });
      } else {
        this.tryAjaxUpload();
      }
    },
    __showImage: function __showImage() {
      this.hasImage = true;
      this.__readFiles();
    },
    __readFiles: function __readFiles() {
      var reader = new FileReader();
      var self = this;
      reader.onload = function (e) {
        var src = e.target.result;
        overflowVal = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        self.__initImage(src);
      };
      reader.readAsDataURL(this.files[0]);
    },


    // set the image size
    __initImage: function __initImage(src) {
      var pic = new Image();
      var self = this;
      pic.src = src;
      var cropBox = this.$refs.cropBox;
      pic.onload = function () {
        self.image.minProgress = self.minWidth / pic.naturalWidth;
        __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.init(src, function (src) {
          self.imgChangeRatio = cropBox.setImage(src, pic.naturalWidth, pic.naturalHeight);
        });
      };
    },
    resizeImage: function resizeImage(progress) {
      var cropBox = this.$refs.cropBox;
      cropBox.resizeImage(progress);
    },
    doRotate: function doRotate(e) {
      var self = this;
      var cropBox = this.$refs.cropBox;
      var targetImage = cropBox.getCropImage();
      this.data.compress = 100 - this.compress;
      return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.rotate(targetImage, 1, function (src) {
        self.__initImage(src);
      });
    },
    doReverseRotate: function doReverseRotate(e) {
      var self = this;
      var cropBox = this.$refs.cropBox;
      var targetImage = cropBox.getCropImage();
      this.data.compress = 100 - this.compress;
      return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.rotate(targetImage, -1, function (src) {
        self.__initImage(src);
      });
    },
    doCrop: function doCrop(e) {
      var _this2 = this;

      this.__setData('crop');
      var cropBox = this.$refs.cropBox;
      var upload = this.__setUpload(e.target);
      if (this.crop === 'local') {
        var targetImage = cropBox.getCropImage();
        this.data.compress = 100 - this.compress;
        return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.crop(targetImage, this.data, function (code) {
          upload(code);
          _this2.__dispatch('imagechanged', code);
        });
      }
      upload();
    },
    doResize: function doResize(e) {
      var _this3 = this;

      this.__setData('resize');
      var cropBox = this.$refs.cropBox;
      var upload = this.__setUpload(e.target);
      if (this.resize === 'local') {
        var targetImage = cropBox.getCropImage();
        this.data.compress = 100 - this.compress;
        return __WEBPACK_IMPORTED_MODULE_6__lib_canvas_helper___default.a.resize(targetImage, this.data, function (code) {
          upload(code);
          _this3.__dispatch('imagechanged', code);
        });
      }
      upload();
    },
    __setData: function __setData(type) {
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) !== 'object') {
        this.data = {};
      }
      this.data["request"] = type;
      var cropBox = this.$refs.cropBox;
      var newCSSObj = cropBox.getCropData();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newCSSObj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          this.data[k] = newCSSObj[k];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.maxWidth) {
        this.data['maxWidth'] = this.maxWidth;
      }
      if (this.maxHeight) {
        this.data['maxHeight'] = this.maxHeight;
      }
      if (this.minWidth) {
        this.data['minWidth'] = this.minWidth;
      }
    },
    __setUpload: function __setUpload(btn) {
      var _this4 = this;

      btn.value = btn.value + '...';
      btn.disabled = true;
      var upload = function upload(code) {
        _this4.tryAjaxUpload(function () {
          btn.value = btn.value.replace('...', '');
          btn.disabled = false;
        }, code ? true : false, code);
      };
      return upload;
    },
    cancel: function cancel() {
      this.hasImage = false;
      document.body.style.overflow = overflowVal;
      this.files = '';
      var cropBox = this.$refs.cropBox;
      cropBox.setOriginalSrc(null);
      document.querySelector('#g-core-upload-input-' + this.formID).value = '';
    },


    // use ajax upload  IE10+
    tryAjaxUpload: function tryAjaxUpload(callback, isBinary, base64Code) {
      var self = this;
      this.__dispatch('imageuploading', this.files[0]);
      var done = function done(res) {
        if (typeof callback === 'function') {
          callback();
        }
        self.uploading = false;
        self.cancel();
        self.__dispatch('imageuploaded', res, self.data);
      };
      var errorUpload = function errorUpload(err) {
        self.__dispatch('errorhandle', err);
      };
      if (!this.isXhr) {
        if (this.crop) {
          this.hasImage = false;
        }
        return typeof callback === 'function' && callback();
      }
      var data = void 0;
      if (isBinary) {
        data = {
          type: this.files[0]['type'],
          filename: this.files[0]['name'],
          filed: this.inputOfFile,
          base64Code: base64Code
        };
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) === 'object') {
          data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.data, data);
        }
      } else {
        data = new FormData();
        for (var i = 0; i < this.files.length; i++) {
          data.append(this.name, this.files[i]);
        }
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.data) === 'object') {
          for (var k in this.data) {
            if (this.data[k] !== undefined) {
              data.append(k, this.data[k]);
            }
          }
        }
      }
      __WEBPACK_IMPORTED_MODULE_4_core_image_xhr___default()('POST', this.url, this.headers, data, done, errorUpload, isBinary, this.credentials);
    }
  }

});

/***/ }),

/***/ "r42K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"downloadPlugin"},[_c('v-login-info'),_vm._v("\n  "+_vm._s(_vm.pcFlag)+"\n  "),_vm._v(" "),_c('div',{staticClass:"tab"},_vm._l((_vm.menuList),function(item,index){return _c('a',{staticClass:"item",class:{ active : _vm.menuIndex === index },attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.meunFn(index)}}},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('div',{staticClass:"content"},_vm._l((_vm.mapList),function(mod,index){return _c('div',{staticClass:"mod",class:{ active : _vm.menuIndex === index }},_vm._l((mod.list),function(item){return _c('dl',{staticClass:"item"},[_c('dt',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('a',{staticClass:"down-link",attrs:{"target":item.blank ? '_blank' : '_self',"href":item.downLink}},[_vm._v(_vm._s(item.downLink))])])}))}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sS7y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sqEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_faqLeft_faqLeft__ = __webpack_require__("m16g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_faqNew_faqNew__ = __webpack_require__("AmPc");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'faq',
  methods: {
    goBackFn: function goBackFn() {
      this.$router.push({ path: '/home' });
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */],
    'v-faq-new': __WEBPACK_IMPORTED_MODULE_2_views_faqNew_faqNew__["a" /* default */],
    'v-faq-left': __WEBPACK_IMPORTED_MODULE_1_components_faqLeft_faqLeft__["a" /* default */]
  }
});

/***/ }),

/***/ "srZ8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tPdr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapMod_vue__ = __webpack_require__("zE0x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_521a6a4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapMod_vue__ = __webpack_require__("RysO");
function injectStyle (ssrContext) {
  __webpack_require__("5MOu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapMod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_521a6a4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapMod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uGtc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'faqLeft'
});

/***/ }),

/***/ "umVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developmentFile_vue__ = __webpack_require__("B7TD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218d5f3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developmentFile_vue__ = __webpack_require__("nXej");
function injectStyle (ssrContext) {
  __webpack_require__("laqr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_developmentFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218d5f3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_developmentFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uxun":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.e552c49.png";

/***/ }),

/***/ "vH9d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPc;
/* eslint-disable */
// 判断客户端来源
function isPc() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod');
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

/***/ }),

/***/ "vf9b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w+iX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirm-mask-wrap",attrs:{"onselectstart":"return false"}},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"confirm-mask"},[_c('div',{ref:"confirmMaskContent",staticClass:"confirm-mask-content"},[_c('p',{staticClass:"desc"},[_vm._t("desc",[_vm._v("提示层")])],2),_vm._v(" "),_c('div',{staticClass:"btn-wrap"},[_c('a',{staticClass:"btn cancel",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.colseMask}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"btn revoke",attrs:{"href":"javascript: void(0)"}},[_vm._v("撤销审核")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w2qT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__ = __webpack_require__("+hi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_core_image_upload__ = __webpack_require__("ngqk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_js_user__ = __webpack_require__("xKOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_basicMask_basicMask__ = __webpack_require__("/pyY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入用户登录信息组件

// 图片上传组件

// ajax 请求插件

// 引入 cookie插件

// 用户信息相关操作

// 遮罩提示层

var ERROR_TIPS = [{ desc: '表单验证失败' }, { desc: '最少上传3张游戏截图' }, { desc: '网络错误' }, { desc: '请上传游戏主图' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  // 测试区地图审核页面
  name: 'devMapinspect',
  data: function data() {
    return {
      // 遮罩层
      maskFlag: false,
      // 上传图片时的错误信息
      uploadPicTps: '',
      // loading 加载层开关
      imageLoadingFlag: false,
      // 地图版本信息
      mapVersion: '',
      // 游戏类型
      mapType: 1,
      // 地图信息
      mapInfo: '',
      // 地图id
      mapId: this.$route.params.mapId,
      // 地图进行阶段
      stage: this.$route.params.stage,
      // 请求地图信息接口
      apiPath: '',
      // 地图标签
      tags: [],
      // 添加地图标标签输入框默认值
      tagVal: '',
      // 地图名称
      mapName: '',
      // 地图描述
      mapDesc: '',
      // 地图更新内容
      mapUpdate: '',
      // 图片demo1
      demoFlag1: false,
      // 图片demo2
      demoFlag2: false,
      // 表单错误信息
      formErrot: '',
      // 表单数据
      formDatas: {
        // 用户id
        userId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('UserID'),
        // session id
        sessionId: __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('SessionID')
      },
      // 默认显示图片
      defaultPic: '/static/img/default-image.png',
      // 上传图片信息列表
      picList: [{ picture: '' }, { picture: '' }, { picture: '' }, { picture: '' }, { picture: '' }, { picture: '' }],
      // 图片上传参数列表
      picData: {
        // 用户id
        UserID: '',
        // session id
        SessionID: '',
        // 地图进度阶段id
        Stage: '',
        // 地图 id
        MapStageId: '',
        // 地图索引
        PictureIndex: '',
        // 上传地图后要替换的图片位置
        picReplace: ''
      }
    };
  },

  computed: {
    // 地图标签输入框 显示\隐藏 标志
    tagAddFlag: function tagAddFlag() {
      if (this.tags.length >= 3) {
        return false;
      } else {
        return true;
      }
    },

    // 计算上传图片的数量
    countPicList: function countPicList() {
      var tempArr = [];
      // 过滤
      this.picList.forEach(function (item, index) {
        // 跳过游戏主图
        if (index !== 0) {
          if (item.picture !== '') {
            tempArr.push(item);
          }
        }
      });
      // 返回过滤后数组的长度
      return tempArr.length;
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    // 初始化数据
    init: function init() {
      var _this = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图id
      formData.append('MapId', this.mapId);
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.root + '/Developer/GetMaptestInfo', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 将地图信息赋值到对象属性
              _this.mapInfo = res.testInfo;
              // 游戏主图
              _this.picList[0].picture = _this.mapInfo.MainPicture;
              // 获取图片默认地址
              _this.picList[1].picture = _this.mapInfo.Picture1;
              _this.picList[2].picture = _this.mapInfo.Picture2;
              _this.picList[3].picture = _this.mapInfo.Picture3;
              _this.picList[4].picture = _this.mapInfo.Picture4;
              _this.picList[5].picture = _this.mapInfo.Picture5;
              // 设置地图当前进行阶段的id
              _this.picData.MapStageId = _this.mapInfo.Id;
              // 设置图片上传时的地图进行阶段id
              _this.picData.Stage = _this.stage;
              // 地图描述信息
              _this.mapDesc = _this.mapInfo.Note;
              // 地图更新内容
              _this.mapUpdate = _this.mapInfo.UpdateContent;
              // 地图版本你信息
              _this.mapVersion = _this.mapInfo.MapVersion;
              // 如果标签不是为空
              if (_this.mapInfo.MapTag !== null) {
                // 将字符串拆分成数组
                _this.tags = _this.mapInfo.MapTag.split(',');
              }
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 图片上传回调函数
    imageuploaded: function imageuploaded(res) {
      switch (res.Code) {
        case 0:
          // 关闭图片上传 loading 加载层
          this.imageLoadingFlag = false;
          // 将返回的图片地址设置到图片上
          this.picReplace[0].src = res.ImgUrl;
          // 对数组中的图片信息进行赋值
          this.picList[this.picData.PictureIndex].picture = res.ImgUrl;
          // 清空错误信息
          this.formErrot = '';
          break;
        case 1:
          // 删除登录信息
          Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
          this.$router.push({ name: 'login' });
          break;
        case 2:
          // this.uploadPicTps = res.Msg
          // 弹出提示层
          // this.maskFlag = true
          this.formErrot = res.Msg;
          break;
        default:
          // 其他错误
          this.formErrot = res.Msg;
          console.log(res.Code);
          console.log(res.Msg);
      }
    },

    // 图片上传过程中
    imageuploading: function imageuploading() {
      // 打开 loading 加载层
      this.imageLoadingFlag = true;
    },

    // 文件上传时出现错误
    errorhandle: function errorhandle(error) {
      // 检查错误
      switch (error) {
        case 'FILE IS TOO LARGER MAX FILE IS 1.00MB':
          this.uploadPicTps = '文件大小不能超过1M';
          break;
        case 'access_denied':
          this.uploadPicTps = '网络错误';
          break;
        default:
          this.uploadPicTps = error;
      }
      // 弹出错误提示
      this.maskFlag = true;
    },

    // 关闭错误提示层
    closeMaskFn: function closeMaskFn() {
      this.maskFlag = false;
    },

    // 点击上传图片时设置参数
    picUploadFn: function picUploadFn(event, index) {
      // 设置图片索引
      this.picData.PictureIndex = index;
      // 设置上传参数用户id
      this.picData.UserID = this.formDatas.userId;
      // 设置上传参数 session id
      this.picData.SessionID = this.formDatas.sessionId;
      // 上传后替换图片的位置
      this.picReplace = event.currentTarget.getElementsByClassName('hook-item-pic');
    },

    // 删除图片
    delPicFn: function delPicFn(index) {
      var _this2 = this;

      // 实例化表单对象
      var formData = new FormData();
      // 将用户名添加到表单
      formData.append('UserID', this.formDatas.userId);
      // 将密码添加到表单
      formData.append('SessionID', this.formDatas.sessionId);
      // 地图进行阶段
      formData.append('Stage', this.picData.Stage);
      // 地图进行阶段id
      formData.append('MapStageId', this.picData.MapStageId);
      // 图片索引
      formData.append('PictureIndex', index);
      // 请求地图详细信息 api
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$api.upload + '/Developer/DeleteMapPicture', formData, {
        // 设置请求为表单提交
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // http 请求成功
        if (response.status === 200) {
          // 获取接口数据
          var res = response.data;
          switch (res.Code) {
            case 0:
              // 清空图片信息
              _this2.picList[_this2.picData.PictureIndex].picture = '';
              break;
            case 1:
              // 删除登录信息
              Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
              _this2.$router.push({ name: 'login' });
              break;
            default:
              console.log(res.Code);
              console.log(res.Msg);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 添加地图标签
    addTagFn: function addTagFn() {
      // 清空输入内容的空格
      var tag = this.tagVal.trim();
      // 如果地图标签有内容输入
      if (tag !== '') {
        // 添加到数组
        this.tags.push(this.tagVal);
        // 清空输入框
        this.tagVal = '';
        // 获取输入框焦点
        this.$refs.addTagInput.focus();
      }
    },

    // 删除地图标签
    delTagFn: function delTagFn(index) {
      // console.log(index)
      this.tags.splice(index, 1);
    },

    // 地图提交审核
    mapSubexamine: function mapSubexamine() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        // 表单是否有错误信息
        var isError = _this3.errors.any();
        if (isError) {
          // 获取所有错误信息的数组列表
          var formErrors = _this3.$validator.errors.all();
          // 返回第一个错误信息
          _this3.formErrot = formErrors[0];
        } else {
          if (_this3.picList[0].picture !== '') {
            // 判断上传游戏截图的数量
            if (_this3.countPicList >= 3) {
              // 实例化表单对象
              var formData = new FormData();
              // 将用户名添加到表单
              formData.append('UserID', _this3.formDatas.userId);
              // 将密码添加到表单
              formData.append('SessionID', _this3.formDatas.sessionId);
              // 地图id
              formData.append('MapId', _this3.mapId);
              // 地图名称
              formData.append('MapName', _this3.mapName);
              // 地图进行阶段
              formData.append('Stage', _this3.picData.Stage);
              // 地图标签
              formData.append('MapTag', _this3.tags.join(','));
              // 地图进行阶段id
              formData.append('MapStageId', _this3.picData.MapStageId);
              // 地图类型
              formData.append('MapType', _this3.mapType);
              // 地图描述
              formData.append('Note', _this3.mapDesc);
              // 更新内容
              formData.append('UpdateContent', _this3.mapUpdate);
              // 地图版本
              formData.append('MapVersion', _this3.mapInfo.MapVersion);
              // 请求地图详细信息 api
              __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this3.$api.root + '/Developer/SubmitAuditDev', formData, {
                // 设置请求为表单提交
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then(function (response) {
                // http 请求成功
                if (response.status === 200) {
                  // 获取接口数据
                  var res = response.data;
                  switch (res.Code) {
                    case 0:
                      // 跳转到审核中页面
                      _this3.$router.push({ name: 'toExamine', params: { mapId: _this3.mapId, stage: _this3.stage } });
                      break;
                    case 1:
                      // 删除登录信息
                      Object(__WEBPACK_IMPORTED_MODULE_4_assets_js_user__["a" /* delUserCookie */])();
                      _this3.$router.push({ name: 'login' });
                      break;
                    default:
                      console.log(res.Code);
                      console.log(res.Msg);
                  }
                }
              }).catch(function (error) {
                _this3.formErrot = ERROR_TIPS[2].desc;
                console.log(error);
              });
            } else {
              // 提示上传图片数量的信息
              _this3.formErrot = ERROR_TIPS[1].desc;
            }
          } else {
            // 提示上传游戏主图
            _this3.formErrot = ERROR_TIPS[3].desc;
          }
        }
      }).catch(function () {
        _this3.formErrot = ERROR_TIPS[0].desc;
      });
    },

    // demo图示1
    demo1Fn: function demo1Fn() {
      this.demoFlag1 = !this.demoFlag1;
    },

    // demo图示2
    demo2Fn: function demo2Fn() {
      this.demoFlag2 = !this.demoFlag2;
    }
  },
  components: {
    'v-login-info': __WEBPACK_IMPORTED_MODULE_0_components_loginInfo_loginInfo__["a" /* default */],
    'vue-core-image-upload': __WEBPACK_IMPORTED_MODULE_1_vue_core_image_upload__["a" /* default */],
    'v-basic-mask': __WEBPACK_IMPORTED_MODULE_5_components_basicMask_basicMask__["a" /* default */]
  }
});

/***/ }),

/***/ "wOAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod"},[_c('div',{staticClass:"mod-nav"},_vm._l((_vm.modList),function(item,index){return _c('a',{staticClass:"nav-item",class:{ active : _vm.modNavIndex === index },attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.modNavFn(index)}}},[_vm._v(_vm._s(item.text))])})),_vm._v(" "),_c('div',{staticClass:"mod-content"},[_c('div',{staticClass:"model-item",class:{ active : _vm.modNavIndex === _vm.modList[0].index }},[_c('div',{staticClass:"setp-nav"},_vm._l((_vm.stepList),function(item,index){return _c('div',{staticClass:"step-item link-itme"},[_c('a',{staticClass:"link-itme",class:[item.cls, { active : _vm.setpNavIndex === index }],attrs:{"href":"javascript: void(0)"},on:{"click":function($event){_vm.setpNavIndexFn(index)}}},[_vm._v(_vm._s(item.text))])])})),_vm._v(" "),_c('div',{staticClass:"setp-content"},[_c('div',{staticClass:"step-item",class:{ active : _vm.setpNavIndex === _vm.stepList[0].index }},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"step-item",class:{ active : _vm.setpNavIndex === _vm.stepList[1].index }},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"step-item",class:{ active : _vm.setpNavIndex === _vm.stepList[2].index }},[_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"step-item",class:{ active : _vm.setpNavIndex === _vm.stepList[3].index }},[_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"model-item",class:{ active : _vm.modNavIndex === _vm.modList[1].index }},[_c('p',{staticClass:"desc"},[_vm._v("私服模式正在研发中，敬请期待。")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"step-list"},[_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("1.下载windows版开发插件。")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("2.下载windows版unity客户端。")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("3.下载开发者文档。")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("4.安装unity并完成注册")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("5.使用unity打开创造与魔法开发工具包Creation & Magic Development Kit工程，第一次运行会hold一会，请耐心等待")]),_vm._v(" "),_c('div',{staticClass:"images-box"},[_c('img',{attrs:{"src":__webpack_require__("C5HD"),"alt":"截图"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"step-list"},[_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("1.使用开发者账户登陆")]),_vm._v(" "),_c('div',{staticClass:"images-box"},[_c('img',{attrs:{"src":__webpack_require__("VGXw"),"alt":"截图"}})])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("2.创建一张地图，给地图起一个名字和匹配模式")]),_vm._v(" "),_c('p',[_vm._v("1)匹配模式支持1~5排")]),_vm._v(" "),_c('p',[_vm._v("2)X排指一个基础小队的人数上限，比如2排就是一个基础小队是2人")]),_vm._v(" "),_c('p',[_vm._v("3)最大队伍是地图开启需要的队伍数量，如图2排，最大队伍2，就是需要2*2四个玩家可以进行游戏")]),_vm._v(" "),_c('div',{staticClass:"images-box"},[_c('img',{attrs:{"src":__webpack_require__("cuet"),"alt":"截图"}})])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("3.建立好地图之后，可以使用辅助工具制作地图内容，首先要创建一张大陆")]),_vm._v(" "),_c('div',{staticClass:"images-box"},[_c('img',{attrs:{"src":__webpack_require__("lv+N"),"alt":"截图"}})])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("4.大陆创建好之后可以制作怪物等等，需要使用mine_data的表格，详情请阅读开发文档说明，编辑完毕表格，使用导出客户端表和导出服务器表可以导出客户端和服务器使用的文件格式")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("5.请在mine_server中修改fuc10000的lua脚本，可以使用notepad++打开，该脚本为mod的服务器脚本文件")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("6.请在mine_client中修改客户端资源文件，该目录为客户端资源文件和脚本文件位置")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("7.调试工具，制作好地图之后可以使用调试工具上传服务器资源，将mine_server中的脚本文件上传")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("8.使用SCENES中的login场景，打开后运行，即可进行游戏的调试。")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"step-list"},[_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("1.地图制作完成后，可以使用发布工具将地图发布到测试区给玩家测试")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("2.首先使用资源打包功能，将打包mine_client和mine_server的资源打包")])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("3.打包成功后使用提交测试区审核按钮将资源上传，资源上传成功后前往开发者后台进行审核申请")]),_vm._v(" "),_c('div',{staticClass:"images-box"},[_c('img',{attrs:{"src":__webpack_require__("kOlq"),"alt":"截图"}})])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("4.在开发者后台提交审核完善信息后等待审核")]),_vm._v(" "),_c('div',{staticClass:"images-box"},[_c('img',{attrs:{"src":__webpack_require__("zyW5"),"alt":"截图"}})])]),_vm._v(" "),_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("5.审核通过后，在游戏的创意工坊中即可提供玩家试玩游戏了~")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"step-list"},[_c('li',{staticClass:"list-item"},[_c('p',[_vm._v("正式区内容正在研发中，敬请期待。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wc9d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/demo-image.a72b71e.png";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xKOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = saveCookie;
/* harmony export (immutable) */ __webpack_exports__["a"] = delUserCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie__);
// 引入 cookie插件

// 用户登出
function saveCookie(res) {
  // 将 UserID 写入 cookie
  __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.set('UserID', res.UserID);
  // 将 UserName 写入 cookie
  __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.set('UserName', res.UserName);
  // 将 SessionID 写入 cookie
  __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.set('SessionID', res.SessionID);
  // 获取用户头像
  __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.set('HeadPictrueUrl', res.HeadPictrueUrl);
}
// 用户登出
function delUserCookie() {
  // 删除 cookie
  __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.delete('UserID');
  __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.delete('UserName');
  __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.delete('SessionID');
  __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.delete('HeadPictrueUrl');
}

/***/ }),

/***/ "xPYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pluginFaq'
});

/***/ }),

/***/ "xRHL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y0yL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selfMod_vue__ = __webpack_require__("TT/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aed8abb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selfMod_vue__ = __webpack_require__("LiqL");
function injectStyle (ssrContext) {
  __webpack_require__("ZH/w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selfMod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aed8abb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selfMod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yqDz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.3b09d70.png";

/***/ }),

/***/ "ywfD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',
  props: {
    mold: {
      type: String
    },
    rId: {
      type: String,
      default: ''
    },
    rName: {
      tpye: String,
      default: ''
    }
  },
  data: function data() {
    return {
      checkboxFlag: false
    };
  },

  methods: {
    // 单选切换
    toggleFn: function toggleFn() {
      // 切换单选框状态
      this.checkboxFlag = !this.checkboxFlag;
      // 将复选框的值传递到父级
      this.$emit('checkboxEv', this.rName, this.checkboxFlag);
      // 如果是创建服务器密码的调用
      /* if (this.mold === 'serverPwd') {
        // 将修改后的状态提交到 store
        this.$store.commit('setFlag', this.checkboxFlag)
      } */
    }
  }
});

/***/ }),

/***/ "z1Lt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // 后台faq
  name: 'backstage'
});

/***/ }),

/***/ "z4Eo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.63b2722.png";

/***/ }),

/***/ "zE0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // 我的地图MOD
  name: 'mapMod',
  props: {
    mapInfo: ''
  }
});

/***/ }),

/***/ "zKIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("SFkb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f5f9a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("KuXf");
function injectStyle (ssrContext) {
  __webpack_require__("GoBJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f5f9a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zyW5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/step-3-image-2.1dd31b9.png";

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.b5c3873f15744852af10.js